/**
 * Number.prototype.format(n, x, s, c)
 * 
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		num = this.toFixed(Math.max(0, ~~n));

	return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

String.prototype.moneyBR = function() {
	return parseFloat(this).format(2, 3, '.', ',');
};

String.prototype.parseMoney = function() {
	return this.length > 0 ? parseFloat(this.split('.').join('').replace(',', '.')) : 0;
};

String.prototype.ucfirst = function() {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.dateDB = function() {
	var d = this.split('/');
	return d[2] + '-' + d[1] + '-' + d[0];
};

String.prototype.dateBR = function() {
	var t = this.split('-');
	return t[2] + '/' + t[1] + '/' + t[0];
};

String.prototype.toDate = function() {
	/* Espera data no formato YYYY-mm-dd */
	var d = this.split('-');
	return new Date(parseInt(d[0]), parseInt(d[1]) - 1, parseInt(d[2]));
};

Date.prototype.date_format = function(format) {
	var date =
		this.getFullYear() +
		'-' +
		to2ndBase(this.getMonth() + 1) +
		'-' +
		to2ndBase(this.getDate()) +
		' ' +
		to2ndBase(this.getHours()) +
		':' +
		to2ndBase(this.getMinutes()) +
		':' +
		to2ndBase(this.getSeconds());

	var date = date.split(' ');
	var d = date[0].split('-');
	format = format.replace('%Y', d[0]);
	format = format.replace('%m', d[1]);
	format = format.replace('%d', d[2]);

	format = format.replace('%b', meses[parseInt(d[1])]);
	format = format.replace('%D', weekday[this.getDay()]);

	if (date[1]) {
		var d = date[1].split(':');
		format = format.replace('%H', d[0]);
		format = format.replace('%i', d[1]);
		format = format.replace('%s', d[2]);
	}

	return format;
};

String.prototype.calcAge = function() {
	var birthday = +new Date(this);
	return ~~((Date.now() - birthday) / 31557600000) + ' anos';
};

function to2ndBase(n) {
	n = parseInt(n);
	return n < 10 ? '0' + n : n;
}

function echo(t) {
	return t ? t.sanitize() : '';
}

String.prototype.sanitize = function() {
	return !this || 0 === this.length ? '' : this;
};

var meses = [
	null,
	'Janeiro',
	'Fevereiro',
	'Março',
	'Abril',
	'Maio',
	'Junho',
	'Julho',
	'Agosto',
	'Setembro',
	'Outubro',
	'Novembro',
	'Dezembro'
];

var weekday = new Array(7);
weekday[0] = 'Domingo';
weekday[1] = 'Segunda';
weekday[2] = 'Terça';
weekday[3] = 'Quarta';
weekday[4] = 'Quinta';
weekday[5] = 'Sexta';
weekday[6] = 'Sábado';

// jQuery Mask Plugin v1.14.16
// github.com/igorescobar/jQuery-Mask-Plugin
var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.findInternal = function(a, n, f) {
	a instanceof String && (a = String(a));
	for (var p = a.length, k = 0; k < p; k++) {
		var b = a[k];
		if (n.call(f, b, k, a)) return { i: k, v: b };
	}
	return { i: -1, v: void 0 };
};
$jscomp.ASSUME_ES5 = !1;
$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$jscomp.ASSUME_NO_NATIVE_SET = !1;
$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$jscomp.defineProperty =
	$jscomp.ASSUME_ES5 || 'function' == typeof Object.defineProperties
		? Object.defineProperty
		: function(a, n, f) {
				a != Array.prototype && a != Object.prototype && (a[n] = f.value);
			};
$jscomp.getGlobal = function(a) {
	return 'undefined' != typeof window && window === a
		? a
		: 'undefined' != typeof global && null != global ? global : a;
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.polyfill = function(a, n, f, p) {
	if (n) {
		f = $jscomp.global;
		a = a.split('.');
		for (p = 0; p < a.length - 1; p++) {
			var k = a[p];
			k in f || (f[k] = {});
			f = f[k];
		}
		a = a[a.length - 1];
		p = f[a];
		n = n(p);
		n != p && null != n && $jscomp.defineProperty(f, a, { configurable: !0, writable: !0, value: n });
	}
};
$jscomp.polyfill(
	'Array.prototype.find',
	function(a) {
		return a
			? a
			: function(a, f) {
					return $jscomp.findInternal(this, a, f).v;
				};
	},
	'es6',
	'es3'
);
(function(a, n, f) {
	'function' === typeof define && define.amd
		? define([ 'jquery' ], a)
		: 'object' === typeof exports && 'undefined' === typeof Meteor
			? (module.exports = a(require('jquery')))
			: a(n || f);
})(
	function(a) {
		var n = function(b, d, e) {
			var c = {
				invalid: [],
				getCaret: function() {
					try {
						var a = 0,
							r = b.get(0),
							h = document.selection,
							d = r.selectionStart;
						if (h && -1 === navigator.appVersion.indexOf('MSIE 10')) {
							var e = h.createRange();
							e.moveStart('character', -c.val().length);
							a = e.text.length;
						} else if (d || '0' === d) a = d;
						return a;
					} catch (C) {}
				},
				setCaret: function(a) {
					try {
						if (b.is(':focus')) {
							var c = b.get(0);
							if (c.setSelectionRange) c.setSelectionRange(a, a);
							else {
								var g = c.createTextRange();
								g.collapse(!0);
								g.moveEnd('character', a);
								g.moveStart('character', a);
								g.select();
							}
						}
					} catch (B) {}
				},
				events: function() {
					b
						.on('keydown.mask', function(a) {
							b.data('mask-keycode', a.keyCode || a.which);
							b.data('mask-previus-value', b.val());
							b.data('mask-previus-caret-pos', c.getCaret());
							c.maskDigitPosMapOld = c.maskDigitPosMap;
						})
						.on(a.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', c.behaviour)
						.on('paste.mask drop.mask', function() {
							setTimeout(function() {
								b.keydown().keyup();
							}, 100);
						})
						.on('change.mask', function() {
							b.data('changed', !0);
						})
						.on('blur.mask', function() {
							f === c.val() || b.data('changed') || b.trigger('change');
							b.data('changed', !1);
						})
						.on('blur.mask', function() {
							f = c.val();
						})
						.on('focus.mask', function(b) {
							!0 === e.selectOnFocus && a(b.target).select();
						})
						.on('focusout.mask', function() {
							e.clearIfNotMatch && !k.test(c.val()) && c.val('');
						});
				},
				getRegexMask: function() {
					for (var a = [], b, c, e, t, f = 0; f < d.length; f++)
						(b = l.translation[d.charAt(f)])
							? ((c = b.pattern.toString().replace(/.{1}$|^.{1}/g, '')),
								(e = b.optional),
								(b = b.recursive)
									? (a.push(d.charAt(f)), (t = { digit: d.charAt(f), pattern: c }))
									: a.push(e || b ? c + '?' : c))
							: a.push(d.charAt(f).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
					a = a.join('');
					t &&
						(a = a
							.replace(new RegExp('(' + t.digit + '(.*' + t.digit + ')?)'), '($1)?')
							.replace(new RegExp(t.digit, 'g'), t.pattern));
					return new RegExp(a);
				},
				destroyEvents: function() {
					b.off('input keydown keyup paste drop blur focusout '.split(' ').join('.mask '));
				},
				val: function(a) {
					var c = b.is('input') ? 'val' : 'text';
					if (0 < arguments.length) {
						if (b[c]() !== a) b[c](a);
						c = b;
					} else c = b[c]();
					return c;
				},
				calculateCaretPosition: function(a) {
					var d = c.getMasked(),
						h = c.getCaret();
					if (a !== d) {
						var e = b.data('mask-previus-caret-pos') || 0;
						d = d.length;
						var g = a.length,
							f = (a = 0),
							l = 0,
							k = 0,
							m;
						for (m = h; m < d && c.maskDigitPosMap[m]; m++) f++;
						for (m = h - 1; 0 <= m && c.maskDigitPosMap[m]; m--) a++;
						for (m = h - 1; 0 <= m; m--) c.maskDigitPosMap[m] && l++;
						for (m = e - 1; 0 <= m; m--) c.maskDigitPosMapOld[m] && k++;
						h > g
							? (h = 10 * d)
							: e >= h && e !== g
								? c.maskDigitPosMapOld[h] ||
									((e = h), (h = h - (k - l) - a), c.maskDigitPosMap[h] && (h = e))
								: h > e && (h = h + (l - k) + f);
					}
					return h;
				},
				behaviour: function(d) {
					d = d || window.event;
					c.invalid = [];
					var e = b.data('mask-keycode');
					if (-1 === a.inArray(e, l.byPassKeys)) {
						e = c.getMasked();
						var h = c.getCaret(),
							g = b.data('mask-previus-value') || '';
						setTimeout(function() {
							c.setCaret(c.calculateCaretPosition(g));
						}, a.jMaskGlobals.keyStrokeCompensation);
						c.val(e);
						c.setCaret(h);
						return c.callbacks(d);
					}
				},
				getMasked: function(a, b) {
					var h = [],
						f = void 0 === b ? c.val() : b + '',
						g = 0,
						k = d.length,
						n = 0,
						p = f.length,
						m = 1,
						r = 'push',
						u = -1,
						w = 0;
					b = [];
					if (e.reverse) {
						r = 'unshift';
						m = -1;
						var x = 0;
						g = k - 1;
						n = p - 1;
						var A = function() {
							return -1 < g && -1 < n;
						};
					} else
						(x = k - 1),
							(A = function() {
								return g < k && n < p;
							});
					for (var z; A(); ) {
						var y = d.charAt(g),
							v = f.charAt(n),
							q = l.translation[y];
						if (q)
							v.match(q.pattern)
								? (h[r](v),
									q.recursive &&
										(-1 === u ? (u = g) : g === x && g !== u && (g = u - m), x === u && (g -= m)),
									(g += m))
								: v === z
									? (w--, (z = void 0))
									: q.optional
										? ((g += m), (n -= m))
										: q.fallback
											? (h[r](q.fallback), (g += m), (n -= m))
											: c.invalid.push({ p: n, v: v, e: q.pattern }),
								(n += m);
						else {
							if (!a) h[r](y);
							v === y ? (b.push(n), (n += m)) : ((z = y), b.push(n + w), w++);
							g += m;
						}
					}
					a = d.charAt(x);
					k !== p + 1 || l.translation[a] || h.push(a);
					h = h.join('');
					c.mapMaskdigitPositions(h, b, p);
					return h;
				},
				mapMaskdigitPositions: function(a, b, d) {
					a = e.reverse ? a.length - d : 0;
					c.maskDigitPosMap = {};
					for (d = 0; d < b.length; d++) c.maskDigitPosMap[b[d] + a] = 1;
				},
				callbacks: function(a) {
					var g = c.val(),
						h = g !== f,
						k = [ g, a, b, e ],
						l = function(a, b, c) {
							'function' === typeof e[a] && b && e[a].apply(this, c);
						};
					l('onChange', !0 === h, k);
					l('onKeyPress', !0 === h, k);
					l('onComplete', g.length === d.length, k);
					l('onInvalid', 0 < c.invalid.length, [ g, a, b, c.invalid, e ]);
				}
			};
			b = a(b);
			var l = this,
				f = c.val(),
				k;
			d = 'function' === typeof d ? d(c.val(), void 0, b, e) : d;
			l.mask = d;
			l.options = e;
			l.remove = function() {
				var a = c.getCaret();
				l.options.placeholder && b.removeAttr('placeholder');
				b.data('mask-maxlength') && b.removeAttr('maxlength');
				c.destroyEvents();
				c.val(l.getCleanVal());
				c.setCaret(a);
				return b;
			};
			l.getCleanVal = function() {
				return c.getMasked(!0);
			};
			l.getMaskedVal = function(a) {
				return c.getMasked(!1, a);
			};
			l.init = function(g) {
				g = g || !1;
				e = e || {};
				l.clearIfNotMatch = a.jMaskGlobals.clearIfNotMatch;
				l.byPassKeys = a.jMaskGlobals.byPassKeys;
				l.translation = a.extend({}, a.jMaskGlobals.translation, e.translation);
				l = a.extend(!0, {}, l, e);
				k = c.getRegexMask();
				if (g) c.events(), c.val(c.getMasked());
				else {
					e.placeholder && b.attr('placeholder', e.placeholder);
					b.data('mask') && b.attr('autocomplete', 'off');
					g = 0;
					for (var f = !0; g < d.length; g++) {
						var h = l.translation[d.charAt(g)];
						if (h && h.recursive) {
							f = !1;
							break;
						}
					}
					f && b.attr('maxlength', d.length).data('mask-maxlength', !0);
					c.destroyEvents();
					c.events();
					g = c.getCaret();
					c.val(c.getMasked());
					c.setCaret(g);
				}
			};
			l.init(!b.is('input'));
		};
		a.maskWatchers = {};
		var f = function() {
				var b = a(this),
					d = {},
					e = b.attr('data-mask');
				b.attr('data-mask-reverse') && (d.reverse = !0);
				b.attr('data-mask-clearifnotmatch') && (d.clearIfNotMatch = !0);
				'true' === b.attr('data-mask-selectonfocus') && (d.selectOnFocus = !0);
				if (p(b, e, d)) return b.data('mask', new n(this, e, d));
			},
			p = function(b, d, e) {
				e = e || {};
				var c = a(b).data('mask'),
					f = JSON.stringify;
				b = a(b).val() || a(b).text();
				try {
					return (
						'function' === typeof d && (d = d(b)),
						'object' !== typeof c || f(c.options) !== f(e) || c.mask !== d
					);
				} catch (w) {}
			},
			k = function(a) {
				var b = document.createElement('div');
				a = 'on' + a;
				var e = a in b;
				e || (b.setAttribute(a, 'return;'), (e = 'function' === typeof b[a]));
				return e;
			};
		a.fn.mask = function(b, d) {
			d = d || {};
			var e = this.selector,
				c = a.jMaskGlobals,
				f = c.watchInterval;
			c = d.watchInputs || c.watchInputs;
			var k = function() {
				if (p(this, b, d)) return a(this).data('mask', new n(this, b, d));
			};
			a(this).each(k);
			e &&
				'' !== e &&
				c &&
				(clearInterval(a.maskWatchers[e]),
				(a.maskWatchers[e] = setInterval(function() {
					a(document).find(e).each(k);
				}, f)));
			return this;
		};
		a.fn.masked = function(a) {
			return this.data('mask').getMaskedVal(a);
		};
		a.fn.unmask = function() {
			clearInterval(a.maskWatchers[this.selector]);
			delete a.maskWatchers[this.selector];
			return this.each(function() {
				var b = a(this).data('mask');
				b && b.remove().removeData('mask');
			});
		};
		a.fn.cleanVal = function() {
			return this.data('mask').getCleanVal();
		};
		a.applyDataMask = function(b) {
			b = b || a.jMaskGlobals.maskElements;
			(b instanceof a ? b : a(b)).filter(a.jMaskGlobals.dataMaskAttr).each(f);
		};
		k = {
			maskElements: 'input,td,span,div',
			dataMaskAttr: '*[data-mask]',
			dataMask: !0,
			watchInterval: 300,
			watchInputs: !0,
			keyStrokeCompensation: 10,
			useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && k('input'),
			watchDataMask: !1,
			byPassKeys: [ 9, 16, 17, 18, 36, 37, 38, 39, 40, 91 ],
			translation: {
				0: { pattern: /\d/ },
				9: { pattern: /\d/, optional: !0 },
				'#': { pattern: /\d/, recursive: !0 },
				A: { pattern: /[a-zA-Z0-9]/ },
				S: { pattern: /[a-zA-Z]/ }
			}
		};
		a.jMaskGlobals = a.jMaskGlobals || {};
		k = a.jMaskGlobals = a.extend(!0, {}, k, a.jMaskGlobals);
		k.dataMask && a.applyDataMask();
		setInterval(function() {
			a.jMaskGlobals.watchDataMask && a.applyDataMask();
		}, k.watchInterval);
	},
	window.jQuery,
	window.Zepto
);

// Alphanumeric
(function($) {
	$.fn.alphanumeric = function(p) {
		p = $.extend({ ichars: '_¨´`!@#$%^&*()+=[]\\\';,/{}|":<>?~`.- ', nchars: '', allow: '' }, p);
		return this.each(function() {
			if (p.nocaps) p.nchars += 'ABCDEFGHIJKLMNOPQRSTUVWXYZÇÁÀÂÃÉÈÊÍÓÚÌÒÙÎÔÛÕÑ';
			if (p.allcaps) p.nchars += 'abcdefghijklmnopqrstuvwxyzçáéíóúàèìòùâêîôûãõñ';
			s = p.allow.split('');
			for (i = 0; i < s.length; i++) if (p.ichars.indexOf(s[i]) != -1) s[i] = '\\' + s[i];
			p.allow = s.join('|');
			var reg = new RegExp(p.allow, 'gi');
			var ch = p.ichars + p.nchars;
			ch = ch.replace(reg, '');
			$(this).keypress(function(e) {
				if (!e.charCode) k = String.fromCharCode(e.which);
				else k = String.fromCharCode(e.charCode);
				if (ch.indexOf(k) != -1) e.preventDefault();
				if (e.ctrlKey && k == 'v') e.preventDefault();
			});
			$(this).bind('contextmenu', function() {
				return false;
			});
		});
	};
	$.fn.numeric = function(p) {
		var az = 'abcdefghijklmnopqrstuvwxyzçáéíóúàèìòùâêîôûãõñ';
		az += az.toUpperCase();
		p = $.extend({ nchars: az }, p);
		return this.each(function() {
			$(this).alphanumeric(p);
		});
	};
	$.fn.alpha = function(p) {
		var nm = '1234567890';
		p = $.extend({ nchars: nm }, p);
		return this.each(function() {
			$(this).alphanumeric(p);
		});
	};
})(jQuery);

//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function() {
	function n(n) {
		function t(t, r, e, u, i, o) {
			for (; i >= 0 && o > i; i += n) {
				var a = u ? u[i] : i;
				e = r(e, t[a], a, t);
			}
			return e;
		}
		return function(r, e, u, i) {
			e = b(e, i, 4);
			var o = !k(r) && m.keys(r),
				a = (o || r).length,
				c = n > 0 ? 0 : a - 1;
			return arguments.length < 3 && ((u = r[o ? o[c] : c]), (c += n)), t(r, e, u, o, c, a);
		};
	}
	function t(n) {
		return function(t, r, e) {
			r = x(r, e);
			for (var u = O(t), i = n > 0 ? 0 : u - 1; i >= 0 && u > i; i += n) if (r(t[i], i, t)) return i;
			return -1;
		};
	}
	function r(n, t, r) {
		return function(e, u, i) {
			var o = 0,
				a = O(e);
			if ('number' == typeof i)
				n > 0 ? (o = i >= 0 ? i : Math.max(i + a, o)) : (a = i >= 0 ? Math.min(i + 1, a) : i + a + 1);
			else if (r && i && a) return (i = r(e, u)), e[i] === u ? i : -1;
			if (u !== u) return (i = t(l.call(e, o, a), m.isNaN)), i >= 0 ? i + o : -1;
			for (i = n > 0 ? o : a - 1; i >= 0 && a > i; i += n) if (e[i] === u) return i;
			return -1;
		};
	}
	function e(n, t) {
		var r = I.length,
			e = n.constructor,
			u = (m.isFunction(e) && e.prototype) || a,
			i = 'constructor';
		for (m.has(n, i) && !m.contains(t, i) && t.push(i); r--; )
			(i = I[r]), i in n && n[i] !== u[i] && !m.contains(t, i) && t.push(i);
	}
	var u = this,
		i = u._,
		o = Array.prototype,
		a = Object.prototype,
		c = Function.prototype,
		f = o.push,
		l = o.slice,
		s = a.toString,
		p = a.hasOwnProperty,
		h = Array.isArray,
		v = Object.keys,
		g = c.bind,
		y = Object.create,
		d = function() {},
		m = function(n) {
			return n instanceof m ? n : this instanceof m ? void (this._wrapped = n) : new m(n);
		};
	'undefined' != typeof exports
		? ('undefined' != typeof module && module.exports && (exports = module.exports = m), (exports._ = m))
		: (u._ = m),
		(m.VERSION = '1.8.3');
	var b = function(n, t, r) {
			if (t === void 0) return n;
			switch (null == r ? 3 : r) {
				case 1:
					return function(r) {
						return n.call(t, r);
					};
				case 2:
					return function(r, e) {
						return n.call(t, r, e);
					};
				case 3:
					return function(r, e, u) {
						return n.call(t, r, e, u);
					};
				case 4:
					return function(r, e, u, i) {
						return n.call(t, r, e, u, i);
					};
			}
			return function() {
				return n.apply(t, arguments);
			};
		},
		x = function(n, t, r) {
			return null == n ? m.identity : m.isFunction(n) ? b(n, t, r) : m.isObject(n) ? m.matcher(n) : m.property(n);
		};
	m.iteratee = function(n, t) {
		return x(n, t, 1 / 0);
	};
	var _ = function(n, t) {
			return function(r) {
				var e = arguments.length;
				if (2 > e || null == r) return r;
				for (var u = 1; e > u; u++)
					for (var i = arguments[u], o = n(i), a = o.length, c = 0; a > c; c++) {
						var f = o[c];
						(t && r[f] !== void 0) || (r[f] = i[f]);
					}
				return r;
			};
		},
		j = function(n) {
			if (!m.isObject(n)) return {};
			if (y) return y(n);
			d.prototype = n;
			var t = new d();
			return (d.prototype = null), t;
		},
		w = function(n) {
			return function(t) {
				return null == t ? void 0 : t[n];
			};
		},
		A = Math.pow(2, 53) - 1,
		O = w('length'),
		k = function(n) {
			var t = O(n);
			return 'number' == typeof t && t >= 0 && A >= t;
		};
	(m.each = m.forEach = function(n, t, r) {
		t = b(t, r);
		var e, u;
		if (k(n)) for (e = 0, u = n.length; u > e; e++) t(n[e], e, n);
		else {
			var i = m.keys(n);
			for (e = 0, u = i.length; u > e; e++) t(n[i[e]], i[e], n);
		}
		return n;
	}),
		(m.map = m.collect = function(n, t, r) {
			t = x(t, r);
			for (var e = !k(n) && m.keys(n), u = (e || n).length, i = Array(u), o = 0; u > o; o++) {
				var a = e ? e[o] : o;
				i[o] = t(n[a], a, n);
			}
			return i;
		}),
		(m.reduce = m.foldl = m.inject = n(1)),
		(m.reduceRight = m.foldr = n(-1)),
		(m.find = m.detect = function(n, t, r) {
			var e;
			return (e = k(n) ? m.findIndex(n, t, r) : m.findKey(n, t, r)), e !== void 0 && e !== -1 ? n[e] : void 0;
		}),
		(m.filter = m.select = function(n, t, r) {
			var e = [];
			return (
				(t = x(t, r)),
				m.each(n, function(n, r, u) {
					t(n, r, u) && e.push(n);
				}),
				e
			);
		}),
		(m.reject = function(n, t, r) {
			return m.filter(n, m.negate(x(t)), r);
		}),
		(m.every = m.all = function(n, t, r) {
			t = x(t, r);
			for (var e = !k(n) && m.keys(n), u = (e || n).length, i = 0; u > i; i++) {
				var o = e ? e[i] : i;
				if (!t(n[o], o, n)) return !1;
			}
			return !0;
		}),
		(m.some = m.any = function(n, t, r) {
			t = x(t, r);
			for (var e = !k(n) && m.keys(n), u = (e || n).length, i = 0; u > i; i++) {
				var o = e ? e[i] : i;
				if (t(n[o], o, n)) return !0;
			}
			return !1;
		}),
		(m.contains = m.includes = m.include = function(n, t, r, e) {
			return k(n) || (n = m.values(n)), ('number' != typeof r || e) && (r = 0), m.indexOf(n, t, r) >= 0;
		}),
		(m.invoke = function(n, t) {
			var r = l.call(arguments, 2),
				e = m.isFunction(t);
			return m.map(n, function(n) {
				var u = e ? t : n[t];
				return null == u ? u : u.apply(n, r);
			});
		}),
		(m.pluck = function(n, t) {
			return m.map(n, m.property(t));
		}),
		(m.where = function(n, t) {
			return m.filter(n, m.matcher(t));
		}),
		(m.findWhere = function(n, t) {
			return m.find(n, m.matcher(t));
		}),
		(m.max = function(n, t, r) {
			var e,
				u,
				i = -1 / 0,
				o = -1 / 0;
			if (null == t && null != n) {
				n = k(n) ? n : m.values(n);
				for (var a = 0, c = n.length; c > a; a++) (e = n[a]), e > i && (i = e);
			} else
				(t = x(t, r)),
					m.each(n, function(n, r, e) {
						(u = t(n, r, e)), (u > o || (u === -1 / 0 && i === -1 / 0)) && ((i = n), (o = u));
					});
			return i;
		}),
		(m.min = function(n, t, r) {
			var e,
				u,
				i = 1 / 0,
				o = 1 / 0;
			if (null == t && null != n) {
				n = k(n) ? n : m.values(n);
				for (var a = 0, c = n.length; c > a; a++) (e = n[a]), i > e && (i = e);
			} else
				(t = x(t, r)),
					m.each(n, function(n, r, e) {
						(u = t(n, r, e)), (o > u || (1 / 0 === u && 1 / 0 === i)) && ((i = n), (o = u));
					});
			return i;
		}),
		(m.shuffle = function(n) {
			for (var t, r = k(n) ? n : m.values(n), e = r.length, u = Array(e), i = 0; e > i; i++)
				(t = m.random(0, i)), t !== i && (u[i] = u[t]), (u[t] = r[i]);
			return u;
		}),
		(m.sample = function(n, t, r) {
			return null == t || r
				? (k(n) || (n = m.values(n)), n[m.random(n.length - 1)])
				: m.shuffle(n).slice(0, Math.max(0, t));
		}),
		(m.sortBy = function(n, t, r) {
			return (
				(t = x(t, r)),
				m.pluck(
					m
						.map(n, function(n, r, e) {
							return { value: n, index: r, criteria: t(n, r, e) };
						})
						.sort(function(n, t) {
							var r = n.criteria,
								e = t.criteria;
							if (r !== e) {
								if (r > e || r === void 0) return 1;
								if (e > r || e === void 0) return -1;
							}
							return n.index - t.index;
						}),
					'value'
				)
			);
		});
	var F = function(n) {
		return function(t, r, e) {
			var u = {};
			return (
				(r = x(r, e)),
				m.each(t, function(e, i) {
					var o = r(e, i, t);
					n(u, e, o);
				}),
				u
			);
		};
	};
	(m.groupBy = F(function(n, t, r) {
		m.has(n, r) ? n[r].push(t) : (n[r] = [ t ]);
	})),
		(m.indexBy = F(function(n, t, r) {
			n[r] = t;
		})),
		(m.countBy = F(function(n, t, r) {
			m.has(n, r) ? n[r]++ : (n[r] = 1);
		})),
		(m.toArray = function(n) {
			return n ? (m.isArray(n) ? l.call(n) : k(n) ? m.map(n, m.identity) : m.values(n)) : [];
		}),
		(m.size = function(n) {
			return null == n ? 0 : k(n) ? n.length : m.keys(n).length;
		}),
		(m.partition = function(n, t, r) {
			t = x(t, r);
			var e = [],
				u = [];
			return (
				m.each(n, function(n, r, i) {
					(t(n, r, i) ? e : u).push(n);
				}),
				[ e, u ]
			);
		}),
		(m.first = m.head = m.take = function(n, t, r) {
			return null == n ? void 0 : null == t || r ? n[0] : m.initial(n, n.length - t);
		}),
		(m.initial = function(n, t, r) {
			return l.call(n, 0, Math.max(0, n.length - (null == t || r ? 1 : t)));
		}),
		(m.last = function(n, t, r) {
			return null == n ? void 0 : null == t || r ? n[n.length - 1] : m.rest(n, Math.max(0, n.length - t));
		}),
		(m.rest = m.tail = m.drop = function(n, t, r) {
			return l.call(n, null == t || r ? 1 : t);
		}),
		(m.compact = function(n) {
			return m.filter(n, m.identity);
		});
	var S = function(n, t, r, e) {
		for (var u = [], i = 0, o = e || 0, a = O(n); a > o; o++) {
			var c = n[o];
			if (k(c) && (m.isArray(c) || m.isArguments(c))) {
				t || (c = S(c, t, r));
				var f = 0,
					l = c.length;
				for (u.length += l; l > f; ) u[i++] = c[f++];
			} else r || (u[i++] = c);
		}
		return u;
	};
	(m.flatten = function(n, t) {
		return S(n, t, !1);
	}),
		(m.without = function(n) {
			return m.difference(n, l.call(arguments, 1));
		}),
		(m.uniq = m.unique = function(n, t, r, e) {
			m.isBoolean(t) || ((e = r), (r = t), (t = !1)), null != r && (r = x(r, e));
			for (var u = [], i = [], o = 0, a = O(n); a > o; o++) {
				var c = n[o],
					f = r ? r(c, o, n) : c;
				t
					? ((o && i === f) || u.push(c), (i = f))
					: r ? m.contains(i, f) || (i.push(f), u.push(c)) : m.contains(u, c) || u.push(c);
			}
			return u;
		}),
		(m.union = function() {
			return m.uniq(S(arguments, !0, !0));
		}),
		(m.intersection = function(n) {
			for (var t = [], r = arguments.length, e = 0, u = O(n); u > e; e++) {
				var i = n[e];
				if (!m.contains(t, i)) {
					for (var o = 1; r > o && m.contains(arguments[o], i); o++);
					o === r && t.push(i);
				}
			}
			return t;
		}),
		(m.difference = function(n) {
			var t = S(arguments, !0, !0, 1);
			return m.filter(n, function(n) {
				return !m.contains(t, n);
			});
		}),
		(m.zip = function() {
			return m.unzip(arguments);
		}),
		(m.unzip = function(n) {
			for (var t = (n && m.max(n, O).length) || 0, r = Array(t), e = 0; t > e; e++) r[e] = m.pluck(n, e);
			return r;
		}),
		(m.object = function(n, t) {
			for (var r = {}, e = 0, u = O(n); u > e; e++) t ? (r[n[e]] = t[e]) : (r[n[e][0]] = n[e][1]);
			return r;
		}),
		(m.findIndex = t(1)),
		(m.findLastIndex = t(-1)),
		(m.sortedIndex = function(n, t, r, e) {
			r = x(r, e, 1);
			for (var u = r(t), i = 0, o = O(n); o > i; ) {
				var a = Math.floor((i + o) / 2);
				r(n[a]) < u ? (i = a + 1) : (o = a);
			}
			return i;
		}),
		(m.indexOf = r(1, m.findIndex, m.sortedIndex)),
		(m.lastIndexOf = r(-1, m.findLastIndex)),
		(m.range = function(n, t, r) {
			null == t && ((t = n || 0), (n = 0)), (r = r || 1);
			for (var e = Math.max(Math.ceil((t - n) / r), 0), u = Array(e), i = 0; e > i; i++, n += r) u[i] = n;
			return u;
		});
	var E = function(n, t, r, e, u) {
		if (!(e instanceof t)) return n.apply(r, u);
		var i = j(n.prototype),
			o = n.apply(i, u);
		return m.isObject(o) ? o : i;
	};
	(m.bind = function(n, t) {
		if (g && n.bind === g) return g.apply(n, l.call(arguments, 1));
		if (!m.isFunction(n)) throw new TypeError('Bind must be called on a function');
		var r = l.call(arguments, 2),
			e = function() {
				return E(n, e, t, this, r.concat(l.call(arguments)));
			};
		return e;
	}),
		(m.partial = function(n) {
			var t = l.call(arguments, 1),
				r = function() {
					for (var e = 0, u = t.length, i = Array(u), o = 0; u > o; o++)
						i[o] = t[o] === m ? arguments[e++] : t[o];
					for (; e < arguments.length; ) i.push(arguments[e++]);
					return E(n, r, this, this, i);
				};
			return r;
		}),
		(m.bindAll = function(n) {
			var t,
				r,
				e = arguments.length;
			if (1 >= e) throw new Error('bindAll must be passed function names');
			for (t = 1; e > t; t++) (r = arguments[t]), (n[r] = m.bind(n[r], n));
			return n;
		}),
		(m.memoize = function(n, t) {
			var r = function(e) {
				var u = r.cache,
					i = '' + (t ? t.apply(this, arguments) : e);
				return m.has(u, i) || (u[i] = n.apply(this, arguments)), u[i];
			};
			return (r.cache = {}), r;
		}),
		(m.delay = function(n, t) {
			var r = l.call(arguments, 2);
			return setTimeout(function() {
				return n.apply(null, r);
			}, t);
		}),
		(m.defer = m.partial(m.delay, m, 1)),
		(m.throttle = function(n, t, r) {
			var e,
				u,
				i,
				o = null,
				a = 0;
			r || (r = {});
			var c = function() {
				(a = r.leading === !1 ? 0 : m.now()), (o = null), (i = n.apply(e, u)), o || (e = u = null);
			};
			return function() {
				var f = m.now();
				a || r.leading !== !1 || (a = f);
				var l = t - (f - a);
				return (
					(e = this),
					(u = arguments),
					0 >= l || l > t
						? (o && (clearTimeout(o), (o = null)), (a = f), (i = n.apply(e, u)), o || (e = u = null))
						: o || r.trailing === !1 || (o = setTimeout(c, l)),
					i
				);
			};
		}),
		(m.debounce = function(n, t, r) {
			var e,
				u,
				i,
				o,
				a,
				c = function() {
					var f = m.now() - o;
					t > f && f >= 0
						? (e = setTimeout(c, t - f))
						: ((e = null), r || ((a = n.apply(i, u)), e || (i = u = null)));
				};
			return function() {
				(i = this), (u = arguments), (o = m.now());
				var f = r && !e;
				return e || (e = setTimeout(c, t)), f && ((a = n.apply(i, u)), (i = u = null)), a;
			};
		}),
		(m.wrap = function(n, t) {
			return m.partial(t, n);
		}),
		(m.negate = function(n) {
			return function() {
				return !n.apply(this, arguments);
			};
		}),
		(m.compose = function() {
			var n = arguments,
				t = n.length - 1;
			return function() {
				for (var r = t, e = n[t].apply(this, arguments); r--; ) e = n[r].call(this, e);
				return e;
			};
		}),
		(m.after = function(n, t) {
			return function() {
				return --n < 1 ? t.apply(this, arguments) : void 0;
			};
		}),
		(m.before = function(n, t) {
			var r;
			return function() {
				return --n > 0 && (r = t.apply(this, arguments)), 1 >= n && (t = null), r;
			};
		}),
		(m.once = m.partial(m.before, 2));
	var M = !{ toString: null }.propertyIsEnumerable('toString'),
		I = [ 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString' ];
	(m.keys = function(n) {
		if (!m.isObject(n)) return [];
		if (v) return v(n);
		var t = [];
		for (var r in n) m.has(n, r) && t.push(r);
		return M && e(n, t), t;
	}),
		(m.allKeys = function(n) {
			if (!m.isObject(n)) return [];
			var t = [];
			for (var r in n) t.push(r);
			return M && e(n, t), t;
		}),
		(m.values = function(n) {
			for (var t = m.keys(n), r = t.length, e = Array(r), u = 0; r > u; u++) e[u] = n[t[u]];
			return e;
		}),
		(m.mapObject = function(n, t, r) {
			t = x(t, r);
			for (var e, u = m.keys(n), i = u.length, o = {}, a = 0; i > a; a++) (e = u[a]), (o[e] = t(n[e], e, n));
			return o;
		}),
		(m.pairs = function(n) {
			for (var t = m.keys(n), r = t.length, e = Array(r), u = 0; r > u; u++) e[u] = [ t[u], n[t[u]] ];
			return e;
		}),
		(m.invert = function(n) {
			for (var t = {}, r = m.keys(n), e = 0, u = r.length; u > e; e++) t[n[r[e]]] = r[e];
			return t;
		}),
		(m.functions = m.methods = function(n) {
			var t = [];
			for (var r in n) m.isFunction(n[r]) && t.push(r);
			return t.sort();
		}),
		(m.extend = _(m.allKeys)),
		(m.extendOwn = m.assign = _(m.keys)),
		(m.findKey = function(n, t, r) {
			t = x(t, r);
			for (var e, u = m.keys(n), i = 0, o = u.length; o > i; i++) if (((e = u[i]), t(n[e], e, n))) return e;
		}),
		(m.pick = function(n, t, r) {
			var e,
				u,
				i = {},
				o = n;
			if (null == o) return i;
			m.isFunction(t)
				? ((u = m.allKeys(o)), (e = b(t, r)))
				: ((u = S(arguments, !1, !1, 1)),
					(e = function(n, t, r) {
						return t in r;
					}),
					(o = Object(o)));
			for (var a = 0, c = u.length; c > a; a++) {
				var f = u[a],
					l = o[f];
				e(l, f, o) && (i[f] = l);
			}
			return i;
		}),
		(m.omit = function(n, t, r) {
			if (m.isFunction(t)) t = m.negate(t);
			else {
				var e = m.map(S(arguments, !1, !1, 1), String);
				t = function(n, t) {
					return !m.contains(e, t);
				};
			}
			return m.pick(n, t, r);
		}),
		(m.defaults = _(m.allKeys, !0)),
		(m.create = function(n, t) {
			var r = j(n);
			return t && m.extendOwn(r, t), r;
		}),
		(m.clone = function(n) {
			return m.isObject(n) ? (m.isArray(n) ? n.slice() : m.extend({}, n)) : n;
		}),
		(m.tap = function(n, t) {
			return t(n), n;
		}),
		(m.isMatch = function(n, t) {
			var r = m.keys(t),
				e = r.length;
			if (null == n) return !e;
			for (var u = Object(n), i = 0; e > i; i++) {
				var o = r[i];
				if (t[o] !== u[o] || !(o in u)) return !1;
			}
			return !0;
		});
	var N = function(n, t, r, e) {
		if (n === t) return 0 !== n || 1 / n === 1 / t;
		if (null == n || null == t) return n === t;
		n instanceof m && (n = n._wrapped), t instanceof m && (t = t._wrapped);
		var u = s.call(n);
		if (u !== s.call(t)) return !1;
		switch (u) {
			case '[object RegExp]':
			case '[object String]':
				return '' + n == '' + t;
			case '[object Number]':
				return +n !== +n ? +t !== +t : 0 === +n ? 1 / +n === 1 / t : +n === +t;
			case '[object Date]':
			case '[object Boolean]':
				return +n === +t;
		}
		var i = '[object Array]' === u;
		if (!i) {
			if ('object' != typeof n || 'object' != typeof t) return !1;
			var o = n.constructor,
				a = t.constructor;
			if (
				o !== a &&
				!(m.isFunction(o) && o instanceof o && m.isFunction(a) && a instanceof a) &&
				'constructor' in n &&
				'constructor' in t
			)
				return !1;
		}
		(r = r || []), (e = e || []);
		for (var c = r.length; c--; ) if (r[c] === n) return e[c] === t;
		if ((r.push(n), e.push(t), i)) {
			if (((c = n.length), c !== t.length)) return !1;
			for (; c--; ) if (!N(n[c], t[c], r, e)) return !1;
		} else {
			var f,
				l = m.keys(n);
			if (((c = l.length), m.keys(t).length !== c)) return !1;
			for (; c--; ) if (((f = l[c]), !m.has(t, f) || !N(n[f], t[f], r, e))) return !1;
		}
		return r.pop(), e.pop(), !0;
	};
	(m.isEqual = function(n, t) {
		return N(n, t);
	}),
		(m.isEmpty = function(n) {
			return null == n
				? !0
				: k(n) && (m.isArray(n) || m.isString(n) || m.isArguments(n)) ? 0 === n.length : 0 === m.keys(n).length;
		}),
		(m.isElement = function(n) {
			return !(!n || 1 !== n.nodeType);
		}),
		(m.isArray =
			h ||
			function(n) {
				return '[object Array]' === s.call(n);
			}),
		(m.isObject = function(n) {
			var t = typeof n;
			return 'function' === t || ('object' === t && !!n);
		}),
		m.each([ 'Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error' ], function(n) {
			m['is' + n] = function(t) {
				return s.call(t) === '[object ' + n + ']';
			};
		}),
		m.isArguments(arguments) ||
			(m.isArguments = function(n) {
				return m.has(n, 'callee');
			}),
		'function' != typeof /./ &&
			'object' != typeof Int8Array &&
			(m.isFunction = function(n) {
				return 'function' == typeof n || !1;
			}),
		(m.isFinite = function(n) {
			return isFinite(n) && !isNaN(parseFloat(n));
		}),
		(m.isNaN = function(n) {
			return m.isNumber(n) && n !== +n;
		}),
		(m.isBoolean = function(n) {
			return n === !0 || n === !1 || '[object Boolean]' === s.call(n);
		}),
		(m.isNull = function(n) {
			return null === n;
		}),
		(m.isUndefined = function(n) {
			return n === void 0;
		}),
		(m.has = function(n, t) {
			return null != n && p.call(n, t);
		}),
		(m.noConflict = function() {
			return (u._ = i), this;
		}),
		(m.identity = function(n) {
			return n;
		}),
		(m.constant = function(n) {
			return function() {
				return n;
			};
		}),
		(m.noop = function() {}),
		(m.property = w),
		(m.propertyOf = function(n) {
			return null == n
				? function() {}
				: function(t) {
						return n[t];
					};
		}),
		(m.matcher = m.matches = function(n) {
			return (
				(n = m.extendOwn({}, n)),
				function(t) {
					return m.isMatch(t, n);
				}
			);
		}),
		(m.times = function(n, t, r) {
			var e = Array(Math.max(0, n));
			t = b(t, r, 1);
			for (var u = 0; n > u; u++) e[u] = t(u);
			return e;
		}),
		(m.random = function(n, t) {
			return null == t && ((t = n), (n = 0)), n + Math.floor(Math.random() * (t - n + 1));
		}),
		(m.now =
			Date.now ||
			function() {
				return new Date().getTime();
			});
	var B = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;' },
		T = m.invert(B),
		R = function(n) {
			var t = function(t) {
					return n[t];
				},
				r = '(?:' + m.keys(n).join('|') + ')',
				e = RegExp(r),
				u = RegExp(r, 'g');
			return function(n) {
				return (n = null == n ? '' : '' + n), e.test(n) ? n.replace(u, t) : n;
			};
		};
	(m.escape = R(B)),
		(m.unescape = R(T)),
		(m.result = function(n, t, r) {
			var e = null == n ? void 0 : n[t];
			return e === void 0 && (e = r), m.isFunction(e) ? e.call(n) : e;
		});
	var q = 0;
	(m.uniqueId = function(n) {
		var t = ++q + '';
		return n ? n + t : t;
	}),
		(m.templateSettings = {
			evaluate: /<%([\s\S]+?)%>/g,
			interpolate: /<%=([\s\S]+?)%>/g,
			escape: /<%-([\s\S]+?)%>/g
		});
	var K = /(.)^/,
		z = { "'": "'", '\\': '\\', '\r': 'r', '\n': 'n', '\u2028': 'u2028', '\u2029': 'u2029' },
		D = /\\|'|\r|\n|\u2028|\u2029/g,
		L = function(n) {
			return '\\' + z[n];
		};
	(m.template = function(n, t, r) {
		!t && r && (t = r), (t = m.defaults({}, t, m.templateSettings));
		var e = RegExp(
				[ (t.escape || K).source, (t.interpolate || K).source, (t.evaluate || K).source ].join('|') + '|$',
				'g'
			),
			u = 0,
			i = "__p+='";
		n.replace(e, function(t, r, e, o, a) {
			return (
				(i += n.slice(u, a).replace(D, L)),
				(u = a + t.length),
				r
					? (i += "'+\n((__t=(" + r + "))==null?'':_.escape(__t))+\n'")
					: e ? (i += "'+\n((__t=(" + e + "))==null?'':__t)+\n'") : o && (i += "';\n" + o + "\n__p+='"),
				t
			);
		}),
			(i += "';\n"),
			t.variable || (i = 'with(obj||{}){\n' + i + '}\n'),
			(i =
				"var __t,__p='',__j=Array.prototype.join," +
				"print=function(){__p+=__j.call(arguments,'');};\n" +
				i +
				'return __p;\n');
		try {
			var o = new Function(t.variable || 'obj', '_', i);
		} catch (a) {
			throw ((a.source = i), a);
		}
		var c = function(n) {
				return o.call(this, n, m);
			},
			f = t.variable || 'obj';
		return (c.source = 'function(' + f + '){\n' + i + '}'), c;
	}),
		(m.chain = function(n) {
			var t = m(n);
			return (t._chain = !0), t;
		});
	var P = function(n, t) {
		return n._chain ? m(t).chain() : t;
	};
	(m.mixin = function(n) {
		m.each(m.functions(n), function(t) {
			var r = (m[t] = n[t]);
			m.prototype[t] = function() {
				var n = [ this._wrapped ];
				return f.apply(n, arguments), P(this, r.apply(m, n));
			};
		});
	}),
		m.mixin(m),
		m.each([ 'pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift' ], function(n) {
			var t = o[n];
			m.prototype[n] = function() {
				var r = this._wrapped;
				return (
					t.apply(r, arguments),
					('shift' !== n && 'splice' !== n) || 0 !== r.length || delete r[0],
					P(this, r)
				);
			};
		}),
		m.each([ 'concat', 'join', 'slice' ], function(n) {
			var t = o[n];
			m.prototype[n] = function() {
				return P(this, t.apply(this._wrapped, arguments));
			};
		}),
		(m.prototype.value = function() {
			return this._wrapped;
		}),
		(m.prototype.valueOf = m.prototype.toJSON = m.prototype.value),
		(m.prototype.toString = function() {
			return '' + this._wrapped;
		}),
		'function' == typeof define &&
			define.amd &&
			define('underscore', [], function() {
				return m;
			});
}.call(this));

/**
 * jquery.Jcrop.min.js v0.9.12 (build:20130202)
 * jQuery Image Cropping Plugin - released under MIT License
 * Copyright (c) 2008-2013 Tapmodo Interactive LLC
 * https://github.com/tapmodo/Jcrop
 */
(function(a) {
	(a.Jcrop = function(b, c) {
		function i(a) {
			return Math.round(a) + 'px';
		}
		function j(a) {
			return d.baseClass + '-' + a;
		}
		function k() {
			return a.fx.step.hasOwnProperty('backgroundColor');
		}
		function l(b) {
			var c = a(b).offset();
			return [ c.left, c.top ];
		}
		function m(a) {
			return [ a.pageX - e[0], a.pageY - e[1] ];
		}
		function n(b) {
			typeof b != 'object' && (b = {}),
				(d = a.extend(d, b)),
				a.each([ 'onChange', 'onSelect', 'onRelease', 'onDblClick' ], function(a, b) {
					typeof d[b] != 'function' && (d[b] = function() {});
				});
		}
		function o(a, b, c) {
			(e = l(D)), bc.setCursor(a === 'move' ? a : a + '-resize');
			if (a === 'move') return bc.activateHandlers(q(b), v, c);
			var d = _.getFixed(),
				f = r(a),
				g = _.getCorner(r(f));
			_.setPressed(_.getCorner(f)), _.setCurrent(g), bc.activateHandlers(p(a, d), v, c);
		}
		function p(a, b) {
			return function(c) {
				if (!d.aspectRatio)
					switch (a) {
						case 'e':
							c[1] = b.y2;
							break;
						case 'w':
							c[1] = b.y2;
							break;
						case 'n':
							c[0] = b.x2;
							break;
						case 's':
							c[0] = b.x2;
					}
				else
					switch (a) {
						case 'e':
							c[1] = b.y + 1;
							break;
						case 'w':
							c[1] = b.y + 1;
							break;
						case 'n':
							c[0] = b.x + 1;
							break;
						case 's':
							c[0] = b.x + 1;
					}
				_.setCurrent(c), bb.update();
			};
		}
		function q(a) {
			var b = a;
			return (
				bd.watchKeys(),
				function(a) {
					_.moveOffset([ a[0] - b[0], a[1] - b[1] ]), (b = a), bb.update();
				}
			);
		}
		function r(a) {
			switch (a) {
				case 'n':
					return 'sw';
				case 's':
					return 'nw';
				case 'e':
					return 'nw';
				case 'w':
					return 'ne';
				case 'ne':
					return 'sw';
				case 'nw':
					return 'se';
				case 'se':
					return 'nw';
				case 'sw':
					return 'ne';
			}
		}
		function s(a) {
			return function(b) {
				return d.disabled
					? !1
					: a === 'move' && !d.allowMove
						? !1
						: ((e = l(D)), (W = !0), o(a, m(b)), b.stopPropagation(), b.preventDefault(), !1);
			};
		}
		function t(a, b, c) {
			var d = a.width(),
				e = a.height();
			d > b && b > 0 && ((d = b), (e = b / a.width() * a.height())),
				e > c && c > 0 && ((e = c), (d = c / a.height() * a.width())),
				(T = a.width() / d),
				(U = a.height() / e),
				a.width(d).height(e);
		}
		function u(a) {
			return { x: a.x * T, y: a.y * U, x2: a.x2 * T, y2: a.y2 * U, w: a.w * T, h: a.h * U };
		}
		function v(a) {
			var b = _.getFixed();
			b.w > d.minSelect[0] && b.h > d.minSelect[1] ? (bb.enableHandles(), bb.done()) : bb.release(),
				bc.setCursor(d.allowSelect ? 'crosshair' : 'default');
		}
		function w(a) {
			if (d.disabled) return !1;
			if (!d.allowSelect) return !1;
			(W = !0), (e = l(D)), bb.disableHandles(), bc.setCursor('crosshair');
			var b = m(a);
			return (
				_.setPressed(b),
				bb.update(),
				bc.activateHandlers(x, v, a.type.substring(0, 5) === 'touch'),
				bd.watchKeys(),
				a.stopPropagation(),
				a.preventDefault(),
				!1
			);
		}
		function x(a) {
			_.setCurrent(a), bb.update();
		}
		function y() {
			var b = a('<div></div>').addClass(j('tracker'));
			return g && b.css({ opacity: 0, backgroundColor: 'white' }), b;
		}
		function be(a) {
			G.removeClass().addClass(j('holder')).addClass(a);
		}
		function bf(a, b) {
			function t() {
				window.setTimeout(u, l);
			}
			var c = a[0] / T,
				e = a[1] / U,
				f = a[2] / T,
				g = a[3] / U;
			if (X) return;
			var h = _.flipCoords(c, e, f, g),
				i = _.getFixed(),
				j = [ i.x, i.y, i.x2, i.y2 ],
				k = j,
				l = d.animationDelay,
				m = h[0] - j[0],
				n = h[1] - j[1],
				o = h[2] - j[2],
				p = h[3] - j[3],
				q = 0,
				r = d.swingSpeed;
			(c = k[0]), (e = k[1]), (f = k[2]), (g = k[3]), bb.animMode(!0);
			var s,
				u = (function() {
					return function() {
						(q += (100 - q) / r),
							(k[0] = Math.round(c + q / 100 * m)),
							(k[1] = Math.round(e + q / 100 * n)),
							(k[2] = Math.round(f + q / 100 * o)),
							(k[3] = Math.round(g + q / 100 * p)),
							q >= 99.8 && (q = 100),
							q < 100 ? (bh(k), t()) : (bb.done(), bb.animMode(!1), typeof b == 'function' && b.call(bs));
					};
				})();
			t();
		}
		function bg(a) {
			bh([ a[0] / T, a[1] / U, a[2] / T, a[3] / U ]), d.onSelect.call(bs, u(_.getFixed())), bb.enableHandles();
		}
		function bh(a) {
			_.setPressed([ a[0], a[1] ]), _.setCurrent([ a[2], a[3] ]), bb.update();
		}
		function bi() {
			return u(_.getFixed());
		}
		function bj() {
			return _.getFixed();
		}
		function bk(a) {
			n(a), br();
		}
		function bl() {
			(d.disabled = !0), bb.disableHandles(), bb.setCursor('default'), bc.setCursor('default');
		}
		function bm() {
			(d.disabled = !1), br();
		}
		function bn() {
			bb.done(), bc.activateHandlers(null, null);
		}
		function bo() {
			G.remove(), A.show(), A.css('visibility', 'visible'), a(b).removeData('Jcrop');
		}
		function bp(a, b) {
			bb.release(), bl();
			var c = new Image();
			(c.onload = function() {
				var e = c.width,
					f = c.height,
					g = d.boxWidth,
					h = d.boxHeight;
				D.width(e).height(f),
					D.attr('src', a),
					H.attr('src', a),
					t(D, g, h),
					(E = D.width()),
					(F = D.height()),
					H.width(E).height(F),
					M.width(E + L * 2).height(F + L * 2),
					G.width(E).height(F),
					ba.resize(E, F),
					bm(),
					typeof b == 'function' && b.call(bs);
			}),
				(c.src = a);
		}
		function bq(a, b, c) {
			var e = b || d.bgColor;
			d.bgFade && k() && d.fadeTime && !c
				? a.animate({ backgroundColor: e }, { queue: !1, duration: d.fadeTime })
				: a.css('backgroundColor', e);
		}
		function br(a) {
			d.allowResize ? (a ? bb.enableOnly() : bb.enableHandles()) : bb.disableHandles(),
				bc.setCursor(d.allowSelect ? 'crosshair' : 'default'),
				bb.setCursor(d.allowMove ? 'move' : 'default'),
				d.hasOwnProperty('trueSize') && ((T = d.trueSize[0] / E), (U = d.trueSize[1] / F)),
				d.hasOwnProperty('setSelect') && (bg(d.setSelect), bb.done(), delete d.setSelect),
				ba.refresh(),
				d.bgColor != N &&
					(bq(d.shade ? ba.getShades() : G, d.shade ? d.shadeColor || d.bgColor : d.bgColor),
					(N = d.bgColor)),
				O != d.bgOpacity && ((O = d.bgOpacity), d.shade ? ba.refresh() : bb.setBgOpacity(O)),
				(P = d.maxSize[0] || 0),
				(Q = d.maxSize[1] || 0),
				(R = d.minSize[0] || 0),
				(S = d.minSize[1] || 0),
				d.hasOwnProperty('outerImage') && (D.attr('src', d.outerImage), delete d.outerImage),
				bb.refresh();
		}
		var d = a.extend({}, a.Jcrop.defaults),
			e,
			f = navigator.userAgent.toLowerCase(),
			g = /msie/.test(f),
			h = /msie [1-6]\./.test(f);
		typeof b != 'object' && (b = a(b)[0]), typeof c != 'object' && (c = {}), n(c);
		var z = { border: 'none', visibility: 'visible', margin: 0, padding: 0, position: 'absolute', top: 0, left: 0 },
			A = a(b),
			B = !0;
		if (b.tagName == 'IMG') {
			if (A[0].width != 0 && A[0].height != 0) A.width(A[0].width), A.height(A[0].height);
			else {
				var C = new Image();
				(C.src = A[0].src), A.width(C.width), A.height(C.height);
			}
			var D = A.clone().removeAttr('id').css(z).show();
			D.width(A.width()), D.height(A.height()), A.after(D).hide();
		} else (D = A.css(z).show()), (B = !1), d.shade === null && (d.shade = !0);
		t(D, d.boxWidth, d.boxHeight);
		var E = D.width(),
			F = D.height(),
			G = a('<div />')
				.width(E)
				.height(F)
				.addClass(j('holder'))
				.css({ position: 'relative', backgroundColor: d.bgColor })
				.insertAfter(A)
				.append(D);
		d.addClass && G.addClass(d.addClass);
		var H = a('<div />'),
			I = a('<div />')
				.width('100%')
				.height('100%')
				.css({ zIndex: 310, position: 'absolute', overflow: 'hidden' }),
			J = a('<div />').width('100%').height('100%').css('zIndex', 320),
			K = a('<div />')
				.css({ position: 'absolute', zIndex: 600 })
				.dblclick(function() {
					var a = _.getFixed();
					d.onDblClick.call(bs, a);
				})
				.insertBefore(D)
				.append(I, J);
		B && ((H = a('<img />').attr('src', D.attr('src')).css(z).width(E).height(F)), I.append(H)),
			h && K.css({ overflowY: 'hidden' });
		var L = d.boundary,
			M = y()
				.width(E + L * 2)
				.height(F + L * 2)
				.css({ position: 'absolute', top: i(-L), left: i(-L), zIndex: 290 })
				.mousedown(w),
			N = d.bgColor,
			O = d.bgOpacity,
			P,
			Q,
			R,
			S,
			T,
			U,
			V = !0,
			W,
			X,
			Y;
		e = l(D);
		var Z = (function() {
				function a() {
					var a = {},
						b = [ 'touchstart', 'touchmove', 'touchend' ],
						c = document.createElement('div'),
						d;
					try {
						for (d = 0; d < b.length; d++) {
							var e = b[d];
							e = 'on' + e;
							var f = e in c;
							f || (c.setAttribute(e, 'return;'), (f = typeof c[e] == 'function')), (a[b[d]] = f);
						}
						return a.touchstart && a.touchend && a.touchmove;
					} catch (g) {
						return !1;
					}
				}
				function b() {
					return d.touchSupport === !0 || d.touchSupport === !1 ? d.touchSupport : a();
				}
				return {
					createDragger: function(a) {
						return function(b) {
							return d.disabled
								? !1
								: a === 'move' && !d.allowMove
									? !1
									: ((e = l(D)),
										(W = !0),
										o(a, m(Z.cfilter(b)), !0),
										b.stopPropagation(),
										b.preventDefault(),
										!1);
						};
					},
					newSelection: function(a) {
						return w(Z.cfilter(a));
					},
					cfilter: function(a) {
						return (
							(a.pageX = a.originalEvent.changedTouches[0].pageX),
							(a.pageY = a.originalEvent.changedTouches[0].pageY),
							a
						);
					},
					isSupported: a,
					support: b()
				};
			})(),
			_ = (function() {
				function h(d) {
					(d = n(d)), (c = a = d[0]), (e = b = d[1]);
				}
				function i(a) {
					(a = n(a)), (f = a[0] - c), (g = a[1] - e), (c = a[0]), (e = a[1]);
				}
				function j() {
					return [ f, g ];
				}
				function k(d) {
					var f = d[0],
						g = d[1];
					0 > a + f && (f -= f + a),
						0 > b + g && (g -= g + b),
						F < e + g && (g += F - (e + g)),
						E < c + f && (f += E - (c + f)),
						(a += f),
						(c += f),
						(b += g),
						(e += g);
				}
				function l(a) {
					var b = m();
					switch (a) {
						case 'ne':
							return [ b.x2, b.y ];
						case 'nw':
							return [ b.x, b.y ];
						case 'se':
							return [ b.x2, b.y2 ];
						case 'sw':
							return [ b.x, b.y2 ];
					}
				}
				function m() {
					if (!d.aspectRatio) return p();
					var f = d.aspectRatio,
						g = d.minSize[0] / T,
						h = d.maxSize[0] / T,
						i = d.maxSize[1] / U,
						j = c - a,
						k = e - b,
						l = Math.abs(j),
						m = Math.abs(k),
						n = l / m,
						r,
						s,
						t,
						u;
					return (
						h === 0 && (h = E * 10),
						i === 0 && (i = F * 10),
						n < f
							? ((s = e),
								(t = m * f),
								(r = j < 0 ? a - t : t + a),
								r < 0
									? ((r = 0), (u = Math.abs((r - a) / f)), (s = k < 0 ? b - u : u + b))
									: r > E && ((r = E), (u = Math.abs((r - a) / f)), (s = k < 0 ? b - u : u + b)))
							: ((r = c),
								(u = l / f),
								(s = k < 0 ? b - u : b + u),
								s < 0
									? ((s = 0), (t = Math.abs((s - b) * f)), (r = j < 0 ? a - t : t + a))
									: s > F && ((s = F), (t = Math.abs(s - b) * f), (r = j < 0 ? a - t : t + a))),
						r > a
							? (r - a < g ? (r = a + g) : r - a > h && (r = a + h),
								s > b ? (s = b + (r - a) / f) : (s = b - (r - a) / f))
							: r < a &&
								(a - r < g ? (r = a - g) : a - r > h && (r = a - h),
								s > b ? (s = b + (a - r) / f) : (s = b - (a - r) / f)),
						r < 0 ? ((a -= r), (r = 0)) : r > E && ((a -= r - E), (r = E)),
						s < 0 ? ((b -= s), (s = 0)) : s > F && ((b -= s - F), (s = F)),
						q(o(a, b, r, s))
					);
				}
				function n(a) {
					return (
						a[0] < 0 && (a[0] = 0),
						a[1] < 0 && (a[1] = 0),
						a[0] > E && (a[0] = E),
						a[1] > F && (a[1] = F),
						[ Math.round(a[0]), Math.round(a[1]) ]
					);
				}
				function o(a, b, c, d) {
					var e = a,
						f = c,
						g = b,
						h = d;
					return c < a && ((e = c), (f = a)), d < b && ((g = d), (h = b)), [ e, g, f, h ];
				}
				function p() {
					var d = c - a,
						f = e - b,
						g;
					return (
						P && Math.abs(d) > P && (c = d > 0 ? a + P : a - P),
						Q && Math.abs(f) > Q && (e = f > 0 ? b + Q : b - Q),
						S / U && Math.abs(f) < S / U && (e = f > 0 ? b + S / U : b - S / U),
						R / T && Math.abs(d) < R / T && (c = d > 0 ? a + R / T : a - R / T),
						a < 0 && ((c -= a), (a -= a)),
						b < 0 && ((e -= b), (b -= b)),
						c < 0 && ((a -= c), (c -= c)),
						e < 0 && ((b -= e), (e -= e)),
						c > E && ((g = c - E), (a -= g), (c -= g)),
						e > F && ((g = e - F), (b -= g), (e -= g)),
						a > E && ((g = a - F), (e -= g), (b -= g)),
						b > F && ((g = b - F), (e -= g), (b -= g)),
						q(o(a, b, c, e))
					);
				}
				function q(a) {
					return { x: a[0], y: a[1], x2: a[2], y2: a[3], w: a[2] - a[0], h: a[3] - a[1] };
				}
				var a = 0,
					b = 0,
					c = 0,
					e = 0,
					f,
					g;
				return {
					flipCoords: o,
					setPressed: h,
					setCurrent: i,
					getOffset: j,
					moveOffset: k,
					getCorner: l,
					getFixed: m
				};
			})(),
			ba = (function() {
				function f(a, b) {
					e.left.css({ height: i(b) }), e.right.css({ height: i(b) });
				}
				function g() {
					return h(_.getFixed());
				}
				function h(a) {
					e.top.css({ left: i(a.x), width: i(a.w), height: i(a.y) }),
						e.bottom.css({ top: i(a.y2), left: i(a.x), width: i(a.w), height: i(F - a.y2) }),
						e.right.css({ left: i(a.x2), width: i(E - a.x2) }),
						e.left.css({ width: i(a.x) });
				}
				function j() {
					return a('<div />')
						.css({ position: 'absolute', backgroundColor: d.shadeColor || d.bgColor })
						.appendTo(c);
				}
				function k() {
					b ||
						((b = !0),
						c.insertBefore(D),
						g(),
						bb.setBgOpacity(1, 0, 1),
						H.hide(),
						l(d.shadeColor || d.bgColor, 1),
						bb.isAwake() ? n(d.bgOpacity, 1) : n(1, 1));
				}
				function l(a, b) {
					bq(p(), a, b);
				}
				function m() {
					b &&
						(c.remove(),
						H.show(),
						(b = !1),
						bb.isAwake()
							? bb.setBgOpacity(d.bgOpacity, 1, 1)
							: (bb.setBgOpacity(1, 1, 1), bb.disableHandles()),
						bq(G, 0, 1));
				}
				function n(a, e) {
					b &&
						(d.bgFade && !e
							? c.animate({ opacity: 1 - a }, { queue: !1, duration: d.fadeTime })
							: c.css({ opacity: 1 - a }));
				}
				function o() {
					d.shade ? k() : m(), bb.isAwake() && n(d.bgOpacity);
				}
				function p() {
					return c.children();
				}
				var b = !1,
					c = a('<div />').css({ position: 'absolute', zIndex: 240, opacity: 0 }),
					e = { top: j(), left: j().height(F), right: j().height(F), bottom: j() };
				return {
					update: g,
					updateRaw: h,
					getShades: p,
					setBgColor: l,
					enable: k,
					disable: m,
					resize: f,
					refresh: o,
					opacity: n
				};
			})(),
			bb = (function() {
				function k(b) {
					var c = a('<div />').css({ position: 'absolute', opacity: d.borderOpacity }).addClass(j(b));
					return I.append(c), c;
				}
				function l(b, c) {
					var d = a('<div />')
						.mousedown(s(b))
						.css({ cursor: b + '-resize', position: 'absolute', zIndex: c })
						.addClass('ord-' + b);
					return Z.support && d.bind('touchstart.jcrop', Z.createDragger(b)), J.append(d), d;
				}
				function m(a) {
					var b = d.handleSize,
						e = l(a, c++).css({ opacity: d.handleOpacity }).addClass(j('handle'));
					return b && e.width(b).height(b), e;
				}
				function n(a) {
					return l(a, c++).addClass('jcrop-dragbar');
				}
				function o(a) {
					var b;
					for (b = 0; b < a.length; b++) g[a[b]] = n(a[b]);
				}
				function p(a) {
					var b, c;
					for (c = 0; c < a.length; c++) {
						switch (a[c]) {
							case 'n':
								b = 'hline';
								break;
							case 's':
								b = 'hline bottom';
								break;
							case 'e':
								b = 'vline right';
								break;
							case 'w':
								b = 'vline';
						}
						e[a[c]] = k(b);
					}
				}
				function q(a) {
					var b;
					for (b = 0; b < a.length; b++) f[a[b]] = m(a[b]);
				}
				function r(a, b) {
					d.shade || H.css({ top: i(-b), left: i(-a) }), K.css({ top: i(b), left: i(a) });
				}
				function t(a, b) {
					K.width(Math.round(a)).height(Math.round(b));
				}
				function v() {
					var a = _.getFixed();
					_.setPressed([ a.x, a.y ]), _.setCurrent([ a.x2, a.y2 ]), w();
				}
				function w(a) {
					if (b) return x(a);
				}
				function x(a) {
					var c = _.getFixed();
					t(c.w, c.h),
						r(c.x, c.y),
						d.shade && ba.updateRaw(c),
						b || A(),
						a ? d.onSelect.call(bs, u(c)) : d.onChange.call(bs, u(c));
				}
				function z(a, c, e) {
					if (!b && !c) return;
					d.bgFade && !e
						? D.animate({ opacity: a }, { queue: !1, duration: d.fadeTime })
						: D.css('opacity', a);
				}
				function A() {
					K.show(), d.shade ? ba.opacity(O) : z(O, !0), (b = !0);
				}
				function B() {
					F(), K.hide(), d.shade ? ba.opacity(1) : z(1), (b = !1), d.onRelease.call(bs);
				}
				function C() {
					h && J.show();
				}
				function E() {
					h = !0;
					if (d.allowResize) return J.show(), !0;
				}
				function F() {
					(h = !1), J.hide();
				}
				function G(a) {
					a ? ((X = !0), F()) : ((X = !1), E());
				}
				function L() {
					G(!1), v();
				}
				var b,
					c = 370,
					e = {},
					f = {},
					g = {},
					h = !1;
				d.dragEdges && a.isArray(d.createDragbars) && o(d.createDragbars),
					a.isArray(d.createHandles) && q(d.createHandles),
					d.drawBorders && a.isArray(d.createBorders) && p(d.createBorders),
					a(document).bind('touchstart.jcrop-ios', function(b) {
						a(b.currentTarget).hasClass('jcrop-tracker') && b.stopPropagation();
					});
				var M = y().mousedown(s('move')).css({ cursor: 'move', position: 'absolute', zIndex: 360 });
				return (
					Z.support && M.bind('touchstart.jcrop', Z.createDragger('move')),
					I.append(M),
					F(),
					{
						updateVisible: w,
						update: x,
						release: B,
						refresh: v,
						isAwake: function() {
							return b;
						},
						setCursor: function(a) {
							M.css('cursor', a);
						},
						enableHandles: E,
						enableOnly: function() {
							h = !0;
						},
						showHandles: C,
						disableHandles: F,
						animMode: G,
						setBgOpacity: z,
						done: L
					}
				);
			})(),
			bc = (function() {
				function f(b) {
					M.css({ zIndex: 450 }),
						b
							? a(document).bind('touchmove.jcrop', k).bind('touchend.jcrop', l)
							: e && a(document).bind('mousemove.jcrop', h).bind('mouseup.jcrop', i);
				}
				function g() {
					M.css({ zIndex: 290 }), a(document).unbind('.jcrop');
				}
				function h(a) {
					return b(m(a)), !1;
				}
				function i(a) {
					return (
						a.preventDefault(),
						a.stopPropagation(),
						W &&
							((W = !1),
							c(m(a)),
							bb.isAwake() && d.onSelect.call(bs, u(_.getFixed())),
							g(),
							(b = function() {}),
							(c = function() {})),
						!1
					);
				}
				function j(a, d, e) {
					return (W = !0), (b = a), (c = d), f(e), !1;
				}
				function k(a) {
					return b(m(Z.cfilter(a))), !1;
				}
				function l(a) {
					return i(Z.cfilter(a));
				}
				function n(a) {
					M.css('cursor', a);
				}
				var b = function() {},
					c = function() {},
					e = d.trackDocument;
				return e || M.mousemove(h).mouseup(i).mouseout(i), D.before(M), { activateHandlers: j, setCursor: n };
			})(),
			bd = (function() {
				function e() {
					d.keySupport && (b.show(), b.focus());
				}
				function f(a) {
					b.hide();
				}
				function g(a, b, c) {
					d.allowMove && (_.moveOffset([ b, c ]), bb.updateVisible(!0)),
						a.preventDefault(),
						a.stopPropagation();
				}
				function i(a) {
					if (a.ctrlKey || a.metaKey) return !0;
					Y = a.shiftKey ? !0 : !1;
					var b = Y ? 10 : 1;
					switch (a.keyCode) {
						case 37:
							g(a, -b, 0);
							break;
						case 39:
							g(a, b, 0);
							break;
						case 38:
							g(a, 0, -b);
							break;
						case 40:
							g(a, 0, b);
							break;
						case 27:
							d.allowSelect && bb.release();
							break;
						case 9:
							return !0;
					}
					return !1;
				}
				var b = a('<input type="radio" />')
						.css({ position: 'fixed', left: '-120px', width: '12px' })
						.addClass('jcrop-keymgr'),
					c = a('<div />').css({ position: 'absolute', overflow: 'hidden' }).append(b);
				return (
					d.keySupport &&
						(b.keydown(i).blur(f),
						h || !d.fixedSupport
							? (b.css({ position: 'absolute', left: '-20px' }), c.append(b).insertBefore(D))
							: b.insertBefore(D)),
					{ watchKeys: e }
				);
			})();
		Z.support && M.bind('touchstart.jcrop', Z.newSelection), J.hide(), br(!0);
		var bs = {
			setImage: bp,
			animateTo: bf,
			setSelect: bg,
			setOptions: bk,
			tellSelect: bi,
			tellScaled: bj,
			setClass: be,
			disable: bl,
			enable: bm,
			cancel: bn,
			release: bb.release,
			destroy: bo,
			focus: bd.watchKeys,
			getBounds: function() {
				return [ E * T, F * U ];
			},
			getWidgetSize: function() {
				return [ E, F ];
			},
			getScaleFactor: function() {
				return [ T, U ];
			},
			getOptions: function() {
				return d;
			},
			ui: { holder: G, selection: K }
		};
		return (
			g &&
				G.bind('selectstart', function() {
					return !1;
				}),
			A.data('Jcrop', bs),
			bs
		);
	}),
		(a.fn.Jcrop = function(b, c) {
			var d;
			return (
				this.each(function() {
					if (a(this).data('Jcrop')) {
						if (b === 'api') return a(this).data('Jcrop');
						a(this).data('Jcrop').setOptions(b);
					} else
						this.tagName == 'IMG'
							? a.Jcrop.Loader(this, function() {
									a(this).css({ display: 'block', visibility: 'hidden' }),
										(d = a.Jcrop(this, b)),
										a.isFunction(c) && c.call(d);
								})
							: (a(this).css({ display: 'block', visibility: 'hidden' }),
								(d = a.Jcrop(this, b)),
								a.isFunction(c) && c.call(d));
				}),
				this
			);
		}),
		(a.Jcrop.Loader = function(b, c, d) {
			function g() {
				f.complete ? (e.unbind('.jcloader'), a.isFunction(c) && c.call(f)) : window.setTimeout(g, 50);
			}
			var e = a(b),
				f = e[0];
			e.bind('load.jcloader', g).bind('error.jcloader', function(b) {
				e.unbind('.jcloader'), a.isFunction(d) && d.call(f);
			}),
				f.complete && a.isFunction(c) && (e.unbind('.jcloader'), c.call(f));
		}),
		(a.Jcrop.defaults = {
			allowSelect: !0,
			allowMove: !0,
			allowResize: !0,
			trackDocument: !0,
			baseClass: 'jcrop',
			addClass: null,
			bgColor: 'black',
			bgOpacity: 0.6,
			bgFade: !1,
			borderOpacity: 0.4,
			handleOpacity: 0.5,
			handleSize: null,
			aspectRatio: 0,
			keySupport: !0,
			createHandles: [ 'n', 's', 'e', 'w', 'nw', 'ne', 'se', 'sw' ],
			createDragbars: [ 'n', 's', 'e', 'w' ],
			createBorders: [ 'n', 's', 'e', 'w' ],
			drawBorders: !0,
			dragEdges: !0,
			fixedSupport: !0,
			touchSupport: null,
			shade: null,
			boxWidth: 0,
			boxHeight: 0,
			boundary: 2,
			fadeTime: 400,
			animationDelay: 20,
			swingSpeed: 3,
			minSelect: [ 0, 0 ],
			maxSize: [ 0, 0 ],
			minSize: [ 0, 0 ],
			onChange: function() {},
			onSelect: function() {},
			onDblClick: function() {},
			onRelease: function() {}
		});
})(jQuery);

/* qTip2 v2.2.1 | Plugins: tips viewport imagemap svg modal ie6 | Styles: core basic css3 | qtip2.com | Licensed MIT | Sun Sep 07 2014 14:22:14 */

!(function(a, b, c) {
	!(function(a) {
		'use strict';
		'function' == typeof define && define.amd ? define([ 'jquery' ], a) : jQuery && !jQuery.fn.qtip && a(jQuery);
	})(function(d) {
		'use strict';
		function e(a, b, c, e) {
			(this.id = c),
				(this.target = a),
				(this.tooltip = F),
				(this.elements = { target: a }),
				(this._id = S + '-' + c),
				(this.timers = { img: {} }),
				(this.options = b),
				(this.plugins = {}),
				(this.cache = { event: {}, target: d(), disabled: E, attr: e, onTooltip: E, lastClass: '' }),
				(this.rendered = this.destroyed = this.disabled = this.waiting = this.hiddenDuringWait = this.positioning = this.triggering = E);
		}
		function f(a) {
			return a === F || 'object' !== d.type(a);
		}
		function g(a) {
			return !(d.isFunction(a) || (a && a.attr) || a.length || ('object' === d.type(a) && (a.jquery || a.then)));
		}
		function h(a) {
			var b, c, e, h;
			return f(a)
				? E
				: (f(a.metadata) && (a.metadata = { type: a.metadata }),
					'content' in a &&
						((b = a.content),
						f(b) || b.jquery || b.done ? (b = a.content = { text: (c = g(b) ? E : b) }) : (c = b.text),
						'ajax' in b &&
							((e = b.ajax),
							(h = e && e.once !== E),
							delete b.ajax,
							(b.text = function(a, b) {
								var f = c || d(this).attr(b.options.content.attr) || 'Loading...',
									g = d.ajax(d.extend({}, e, { context: b })).then(e.success, F, e.error).then(
										function(a) {
											return a && h && b.set('content.text', a), a;
										},
										function(a, c, d) {
											b.destroyed || 0 === a.status || b.set('content.text', c + ': ' + d);
										}
									);
								return h ? f : (b.set('content.text', f), g);
							})),
						'title' in b &&
							(d.isPlainObject(b.title) && ((b.button = b.title.button), (b.title = b.title.text)),
							g(b.title || E) && (b.title = E))),
					'position' in a && f(a.position) && (a.position = { my: a.position, at: a.position }),
					'show' in a &&
						f(a.show) &&
						(a.show = a.show.jquery ? { target: a.show } : a.show === D ? { ready: D } : { event: a.show }),
					'hide' in a && f(a.hide) && (a.hide = a.hide.jquery ? { target: a.hide } : { event: a.hide }),
					'style' in a && f(a.style) && (a.style = { classes: a.style }),
					d.each(R, function() {
						this.sanitize && this.sanitize(a);
					}),
					a);
		}
		function i(a, b) {
			for (var c, d = 0, e = a, f = b.split('.'); (e = e[f[d++]]); ) d < f.length && (c = e);
			return [ c || a, f.pop() ];
		}
		function j(a, b) {
			var c, d, e;
			for (c in this.checks)
				for (d in this.checks[c])
					(e = new RegExp(d, 'i').exec(a)) &&
						(b.push(e),
						('builtin' === c || this.plugins[c]) && this.checks[c][d].apply(this.plugins[c] || this, b));
		}
		function k(a) {
			return V.concat('').join(a ? '-' + a + ' ' : ' ');
		}
		function l(a, b) {
			return b > 0 ? setTimeout(d.proxy(a, this), b) : void a.call(this);
		}
		function m(a) {
			this.tooltip.hasClass(ab) ||
				(clearTimeout(this.timers.show),
				clearTimeout(this.timers.hide),
				(this.timers.show = l.call(
					this,
					function() {
						this.toggle(D, a);
					},
					this.options.show.delay
				)));
		}
		function n(a) {
			if (!this.tooltip.hasClass(ab) && !this.destroyed) {
				var b = d(a.relatedTarget),
					c = b.closest(W)[0] === this.tooltip[0],
					e = b[0] === this.options.show.target[0];
				if (
					(clearTimeout(this.timers.show),
					clearTimeout(this.timers.hide),
					(this !== b[0] && 'mouse' === this.options.position.target && c) ||
						(this.options.hide.fixed && /mouse(out|leave|move)/.test(a.type) && (c || e)))
				)
					try {
						a.preventDefault(), a.stopImmediatePropagation();
					} catch (f) {}
				else
					this.timers.hide = l.call(
						this,
						function() {
							this.toggle(E, a);
						},
						this.options.hide.delay,
						this
					);
			}
		}
		function o(a) {
			!this.tooltip.hasClass(ab) &&
				this.options.hide.inactive &&
				(clearTimeout(this.timers.inactive),
				(this.timers.inactive = l.call(
					this,
					function() {
						this.hide(a);
					},
					this.options.hide.inactive
				)));
		}
		function p(a) {
			this.rendered && this.tooltip[0].offsetWidth > 0 && this.reposition(a);
		}
		function q(a, c, e) {
			d(b.body).delegate(a, (c.split ? c : c.join('.' + S + ' ')) + '.' + S, function() {
				var a = y.api[d.attr(this, U)];
				a && !a.disabled && e.apply(a, arguments);
			});
		}
		function r(a, c, f) {
			var g,
				i,
				j,
				k,
				l,
				m = d(b.body),
				n = a[0] === b ? m : a,
				o = a.metadata ? a.metadata(f.metadata) : F,
				p = 'html5' === f.metadata.type && o ? o[f.metadata.name] : F,
				q = a.data(f.metadata.name || 'qtipopts');
			try {
				q = 'string' == typeof q ? d.parseJSON(q) : q;
			} catch (r) {}
			if (
				((k = d.extend(D, {}, y.defaults, f, 'object' == typeof q ? h(q) : F, h(p || o))),
				(i = k.position),
				(k.id = c),
				'boolean' == typeof k.content.text)
			) {
				if (((j = a.attr(k.content.attr)), k.content.attr === E || !j)) return E;
				k.content.text = j;
			}
			if (
				(i.container.length || (i.container = m),
				i.target === E && (i.target = n),
				k.show.target === E && (k.show.target = n),
				k.show.solo === D && (k.show.solo = i.container.closest('body')),
				k.hide.target === E && (k.hide.target = n),
				k.position.viewport === D && (k.position.viewport = i.container),
				(i.container = i.container.eq(0)),
				(i.at = new A(i.at, D)),
				(i.my = new A(i.my)),
				a.data(S))
			)
				if (k.overwrite) a.qtip('destroy', !0);
				else if (k.overwrite === E) return E;
			return (
				a.attr(T, c),
				k.suppress && (l = a.attr('title')) && a.removeAttr('title').attr(cb, l).attr('title', ''),
				(g = new e(a, k, c, !!j)),
				a.data(S, g),
				g
			);
		}
		function s(a) {
			return a.charAt(0).toUpperCase() + a.slice(1);
		}
		function t(a, b) {
			var d,
				e,
				f = b.charAt(0).toUpperCase() + b.slice(1),
				g = (b + ' ' + rb.join(f + ' ') + f).split(' '),
				h = 0;
			if (qb[b]) return a.css(qb[b]);
			for (; (d = g[h++]); ) if ((e = a.css(d)) !== c) return (qb[b] = d), e;
		}
		function u(a, b) {
			return Math.ceil(parseFloat(t(a, b)));
		}
		function v(a, b) {
			(this._ns = 'tip'),
				(this.options = b),
				(this.offset = b.offset),
				(this.size = [ b.width, b.height ]),
				this.init((this.qtip = a));
		}
		function w(a, b) {
			(this.options = b), (this._ns = '-modal'), this.init((this.qtip = a));
		}
		function x(a) {
			(this._ns = 'ie6'), this.init((this.qtip = a));
		}
		var y,
			z,
			A,
			B,
			C,
			D = !0,
			E = !1,
			F = null,
			G = 'x',
			H = 'y',
			I = 'width',
			J = 'height',
			K = 'top',
			L = 'left',
			M = 'bottom',
			N = 'right',
			O = 'center',
			P = 'flipinvert',
			Q = 'shift',
			R = {},
			S = 'qtip',
			T = 'data-hasqtip',
			U = 'data-qtip-id',
			V = [ 'ui-widget', 'ui-tooltip' ],
			W = '.' + S,
			X = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),
			Y = S + '-fixed',
			Z = S + '-default',
			$ = S + '-focus',
			_ = S + '-hover',
			ab = S + '-disabled',
			bb = '_replacedByqTip',
			cb = 'oldtitle',
			db = {
				ie: (function() {
					for (
						var a = 4, c = b.createElement('div');
						(c.innerHTML = '<!--[if gt IE ' + a + ']><i></i><![endif]-->') &&
						c.getElementsByTagName('i')[0];
						a += 1
					);
					return a > 4 ? a : 0 / 0;
				})(),
				iOS:
					parseFloat(
						('' +
							(/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
								0,
								''
							])[1])
							.replace('undefined', '3_2')
							.replace('_', '.')
							.replace('_', '')
					) || E
			};
		(z = e.prototype),
			(z._when = function(a) {
				return d.when.apply(d, a);
			}),
			(z.render = function(a) {
				if (this.rendered || this.destroyed) return this;
				var b,
					c = this,
					e = this.options,
					f = this.cache,
					g = this.elements,
					h = e.content.text,
					i = e.content.title,
					j = e.content.button,
					k = e.position,
					l = ('.' + this._id + ' ', []);
				return (
					d.attr(this.target[0], 'aria-describedby', this._id),
					(f.posClass = this._createPosClass((this.position = { my: k.my, at: k.at }).my)),
					(this.tooltip = g.tooltip = b = d('<div/>', {
						id: this._id,
						class: [ S, Z, e.style.classes, f.posClass ].join(' '),
						width: e.style.width || '',
						height: e.style.height || '',
						tracking: 'mouse' === k.target && k.adjust.mouse,
						role: 'alert',
						'aria-live': 'polite',
						'aria-atomic': E,
						'aria-describedby': this._id + '-content',
						'aria-hidden': D
					})
						.toggleClass(ab, this.disabled)
						.attr(U, this.id)
						.data(S, this)
						.appendTo(k.container)
						.append(
							(g.content = d('<div />', {
								class: S + '-content',
								id: this._id + '-content',
								'aria-atomic': D
							}))
						)),
					(this.rendered = -1),
					(this.positioning = D),
					i && (this._createTitle(), d.isFunction(i) || l.push(this._updateTitle(i, E))),
					j && this._createButton(),
					d.isFunction(h) || l.push(this._updateContent(h, E)),
					(this.rendered = D),
					this._setWidget(),
					d.each(R, function(a) {
						var b;
						'render' === this.initialize && (b = this(c)) && (c.plugins[a] = b);
					}),
					this._unassignEvents(),
					this._assignEvents(),
					this._when(l).then(function() {
						c._trigger('render'),
							(c.positioning = E),
							c.hiddenDuringWait || (!e.show.ready && !a) || c.toggle(D, f.event, E),
							(c.hiddenDuringWait = E);
					}),
					(y.api[this.id] = this),
					this
				);
			}),
			(z.destroy = function(a) {
				function b() {
					if (!this.destroyed) {
						this.destroyed = D;
						var a,
							b = this.target,
							c = b.attr(cb);
						this.rendered && this.tooltip.stop(1, 0).find('*').remove().end().remove(),
							d.each(this.plugins, function() {
								this.destroy && this.destroy();
							});
						for (a in this.timers) clearTimeout(this.timers[a]);
						b.removeData(S).removeAttr(U).removeAttr(T).removeAttr('aria-describedby'),
							this.options.suppress && c && b.attr('title', c).removeAttr(cb),
							this._unassignEvents(),
							(this.options = this.elements = this.cache = this.timers = this.plugins = this.mouse = F),
							delete y.api[this.id];
					}
				}
				return this.destroyed
					? this.target
					: ((a === D && 'hide' !== this.triggering) || !this.rendered
							? b.call(this)
							: (this.tooltip.one('tooltiphidden', d.proxy(b, this)), !this.triggering && this.hide()),
						this.target);
			}),
			(B = z.checks = {
				builtin: {
					'^id$': function(a, b, c, e) {
						var f = c === D ? y.nextid : c,
							g = S + '-' + f;
						f !== E && f.length > 0 && !d('#' + g).length
							? ((this._id = g),
								this.rendered &&
									((this.tooltip[0].id = this._id),
									(this.elements.content[0].id = this._id + '-content'),
									(this.elements.title[0].id = this._id + '-title')))
							: (a[b] = e);
					},
					'^prerender': function(a, b, c) {
						c && !this.rendered && this.render(this.options.show.ready);
					},
					'^content.text$': function(a, b, c) {
						this._updateContent(c);
					},
					'^content.attr$': function(a, b, c, d) {
						this.options.content.text === this.target.attr(d) && this._updateContent(this.target.attr(c));
					},
					'^content.title$': function(a, b, c) {
						return c
							? (c && !this.elements.title && this._createTitle(), void this._updateTitle(c))
							: this._removeTitle();
					},
					'^content.button$': function(a, b, c) {
						this._updateButton(c);
					},
					'^content.title.(text|button)$': function(a, b, c) {
						this.set('content.' + b, c);
					},
					'^position.(my|at)$': function(a, b, c) {
						'string' == typeof c && (this.position[b] = a[b] = new A(c, 'at' === b));
					},
					'^position.container$': function(a, b, c) {
						this.rendered && this.tooltip.appendTo(c);
					},
					'^show.ready$': function(a, b, c) {
						c && ((!this.rendered && this.render(D)) || this.toggle(D));
					},
					'^style.classes$': function(a, b, c, d) {
						this.rendered && this.tooltip.removeClass(d).addClass(c);
					},
					'^style.(width|height)': function(a, b, c) {
						this.rendered && this.tooltip.css(b, c);
					},
					'^style.widget|content.title': function() {
						this.rendered && this._setWidget();
					},
					'^style.def': function(a, b, c) {
						this.rendered && this.tooltip.toggleClass(Z, !!c);
					},
					'^events.(render|show|move|hide|focus|blur)$': function(a, b, c) {
						this.rendered && this.tooltip[(d.isFunction(c) ? '' : 'un') + 'bind']('tooltip' + b, c);
					},
					'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
						if (this.rendered) {
							var a = this.options.position;
							this.tooltip.attr('tracking', 'mouse' === a.target && a.adjust.mouse),
								this._unassignEvents(),
								this._assignEvents();
						}
					}
				}
			}),
			(z.get = function(a) {
				if (this.destroyed) return this;
				var b = i(this.options, a.toLowerCase()),
					c = b[0][b[1]];
				return c.precedance ? c.string() : c;
			});
		var eb = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
			fb = /^prerender|show\.ready/i;
		(z.set = function(a, b) {
			if (this.destroyed) return this;
			{
				var c,
					e = this.rendered,
					f = E,
					g = this.options;
				this.checks;
			}
			return (
				'string' == typeof a ? ((c = a), (a = {}), (a[c] = b)) : (a = d.extend({}, a)),
				d.each(a, function(b, c) {
					if (e && fb.test(b)) return void delete a[b];
					var h,
						j = i(g, b.toLowerCase());
					(h = j[0][j[1]]),
						(j[0][j[1]] = c && c.nodeType ? d(c) : c),
						(f = eb.test(b) || f),
						(a[b] = [ j[0], j[1], c, h ]);
				}),
				h(g),
				(this.positioning = D),
				d.each(a, d.proxy(j, this)),
				(this.positioning = E),
				this.rendered &&
					this.tooltip[0].offsetWidth > 0 &&
					f &&
					this.reposition('mouse' === g.position.target ? F : this.cache.event),
				this
			);
		}),
			(z._update = function(a, b) {
				var c = this,
					e = this.cache;
				return this.rendered && a
					? (d.isFunction(a) && (a = a.call(this.elements.target, e.event, this) || ''),
						d.isFunction(a.then)
							? ((e.waiting = D),
								a.then(
									function(a) {
										return (e.waiting = E), c._update(a, b);
									},
									F,
									function(a) {
										return c._update(a, b);
									}
								))
							: a === E || (!a && '' !== a)
								? E
								: (a.jquery && a.length > 0
										? b.empty().append(a.css({ display: 'block', visibility: 'visible' }))
										: b.html(a),
									this._waitForContent(b).then(function(a) {
										c.rendered && c.tooltip[0].offsetWidth > 0 && c.reposition(e.event, !a.length);
									})))
					: E;
			}),
			(z._waitForContent = function(a) {
				var b = this.cache;
				return (
					(b.waiting = D),
					(d.fn.imagesLoaded ? a.imagesLoaded() : d.Deferred().resolve([]))
						.done(function() {
							b.waiting = E;
						})
						.promise()
				);
			}),
			(z._updateContent = function(a, b) {
				this._update(a, this.elements.content, b);
			}),
			(z._updateTitle = function(a, b) {
				this._update(a, this.elements.title, b) === E && this._removeTitle(E);
			}),
			(z._createTitle = function() {
				var a = this.elements,
					b = this._id + '-title';
				a.titlebar && this._removeTitle(),
					(a.titlebar = d('<div />', {
						class: S + '-titlebar ' + (this.options.style.widget ? k('header') : '')
					})
						.append((a.title = d('<div />', { id: b, class: S + '-title', 'aria-atomic': D })))
						.insertBefore(a.content)
						.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(a) {
							d(this).toggleClass('ui-state-active ui-state-focus', 'down' === a.type.substr(-4));
						})
						.delegate('.qtip-close', 'mouseover mouseout', function(a) {
							d(this).toggleClass('ui-state-hover', 'mouseover' === a.type);
						})),
					this.options.content.button && this._createButton();
			}),
			(z._removeTitle = function(a) {
				var b = this.elements;
				b.title && (b.titlebar.remove(), (b.titlebar = b.title = b.button = F), a !== E && this.reposition());
			}),
			(z._createPosClass = function(a) {
				return S + '-pos-' + (a || this.options.position.my).abbrev();
			}),
			(z.reposition = function(c, e) {
				if (!this.rendered || this.positioning || this.destroyed) return this;
				this.positioning = D;
				var f,
					g,
					h,
					i,
					j = this.cache,
					k = this.tooltip,
					l = this.options.position,
					m = l.target,
					n = l.my,
					o = l.at,
					p = l.viewport,
					q = l.container,
					r = l.adjust,
					s = r.method.split(' '),
					t = k.outerWidth(E),
					u = k.outerHeight(E),
					v = 0,
					w = 0,
					x = k.css('position'),
					y = { left: 0, top: 0 },
					z = k[0].offsetWidth > 0,
					A = c && 'scroll' === c.type,
					B = d(a),
					C = q[0].ownerDocument,
					F = this.mouse;
				if (d.isArray(m) && 2 === m.length) (o = { x: L, y: K }), (y = { left: m[0], top: m[1] });
				else if ('mouse' === m)
					(o = { x: L, y: K }),
						(!r.mouse || this.options.hide.distance) && j.origin && j.origin.pageX
							? (c = j.origin)
							: !c || (c && ('resize' === c.type || 'scroll' === c.type))
								? (c = j.event)
								: F && F.pageX && (c = F),
						'static' !== x && (y = q.offset()),
						C.body.offsetWidth !== (a.innerWidth || C.documentElement.clientWidth) &&
							(g = d(b.body).offset()),
						(y = {
							left: c.pageX - y.left + ((g && g.left) || 0),
							top: c.pageY - y.top + ((g && g.top) || 0)
						}),
						r.mouse &&
							A &&
							F &&
							((y.left -= (F.scrollX || 0) - B.scrollLeft()),
							(y.top -= (F.scrollY || 0) - B.scrollTop()));
				else {
					if (
						('event' === m
							? c && c.target && 'scroll' !== c.type && 'resize' !== c.type
								? (j.target = d(c.target))
								: c.target || (j.target = this.elements.target)
							: 'event' !== m && (j.target = d(m.jquery ? m : this.elements.target)),
						(m = j.target),
						(m = d(m).eq(0)),
						0 === m.length)
					)
						return this;
					m[0] === b || m[0] === a
						? ((v = db.iOS ? a.innerWidth : m.width()),
							(w = db.iOS ? a.innerHeight : m.height()),
							m[0] === a && (y = { top: (p || m).scrollTop(), left: (p || m).scrollLeft() }))
						: R.imagemap && m.is('area')
							? (f = R.imagemap(this, m, o, R.viewport ? s : E))
							: R.svg && m && m[0].ownerSVGElement
								? (f = R.svg(this, m, o, R.viewport ? s : E))
								: ((v = m.outerWidth(E)), (w = m.outerHeight(E)), (y = m.offset())),
						f && ((v = f.width), (w = f.height), (g = f.offset), (y = f.position)),
						(y = this.reposition.offset(m, y, q)),
						((db.iOS > 3.1 && db.iOS < 4.1) ||
							(db.iOS >= 4.3 && db.iOS < 4.33) ||
							(!db.iOS && 'fixed' === x)) &&
							((y.left -= B.scrollLeft()), (y.top -= B.scrollTop())),
						(!f || (f && f.adjustable !== E)) &&
							((y.left += o.x === N ? v : o.x === O ? v / 2 : 0),
							(y.top += o.y === M ? w : o.y === O ? w / 2 : 0));
				}
				return (
					(y.left += r.x + (n.x === N ? -t : n.x === O ? -t / 2 : 0)),
					(y.top += r.y + (n.y === M ? -u : n.y === O ? -u / 2 : 0)),
					R.viewport
						? ((h = y.adjusted = R.viewport(this, y, l, v, w, t, u)),
							g && h.left && (y.left += g.left),
							g && h.top && (y.top += g.top),
							h.my && (this.position.my = h.my))
						: (y.adjusted = { left: 0, top: 0 }),
					j.posClass !== (i = this._createPosClass(this.position.my)) &&
						k.removeClass(j.posClass).addClass((j.posClass = i)),
					this._trigger('move', [ y, p.elem || p ], c)
						? (delete y.adjusted,
							e === E || !z || isNaN(y.left) || isNaN(y.top) || 'mouse' === m || !d.isFunction(l.effect)
								? k.css(y)
								: d.isFunction(l.effect) &&
									(l.effect.call(k, this, d.extend({}, y)),
									k.queue(function(a) {
										d(this).css({ opacity: '', height: '' }),
											db.ie && this.style.removeAttribute('filter'),
											a();
									})),
							(this.positioning = E),
							this)
						: this
				);
			}),
			(z.reposition.offset = function(a, c, e) {
				function f(a, b) {
					(c.left += b * a.scrollLeft()), (c.top += b * a.scrollTop());
				}
				if (!e[0]) return c;
				var g,
					h,
					i,
					j,
					k = d(a[0].ownerDocument),
					l = !!db.ie && 'CSS1Compat' !== b.compatMode,
					m = e[0];
				do
					'static' !== (h = d.css(m, 'position')) &&
						('fixed' === h
							? ((i = m.getBoundingClientRect()), f(k, -1))
							: ((i = d(m).position()),
								(i.left += parseFloat(d.css(m, 'borderLeftWidth')) || 0),
								(i.top += parseFloat(d.css(m, 'borderTopWidth')) || 0)),
						(c.left -= i.left + (parseFloat(d.css(m, 'marginLeft')) || 0)),
						(c.top -= i.top + (parseFloat(d.css(m, 'marginTop')) || 0)),
						g || 'hidden' === (j = d.css(m, 'overflow')) || 'visible' === j || (g = d(m)));
				while ((m = m.offsetParent));
				return g && (g[0] !== k[0] || l) && f(g, 1), c;
			});
		var gb = (A = z.reposition.Corner = function(a, b) {
			(a = ('' + a).replace(/([A-Z])/, ' $1').replace(/middle/gi, O).toLowerCase()),
				(this.x = (a.match(/left|right/i) || a.match(/center/) || [ 'inherit' ])[0].toLowerCase()),
				(this.y = (a.match(/top|bottom|center/i) || [ 'inherit' ])[0].toLowerCase()),
				(this.forceY = !!b);
			var c = a.charAt(0);
			this.precedance = 't' === c || 'b' === c ? H : G;
		}).prototype;
		(gb.invert = function(a, b) {
			this[a] = this[a] === L ? N : this[a] === N ? L : b || this[a];
		}),
			(gb.string = function(a) {
				var b = this.x,
					c = this.y,
					d =
						b !== c
							? 'center' === b || ('center' !== c && (this.precedance === H || this.forceY))
								? [ c, b ]
								: [ b, c ]
							: [ b ];
				return a !== !1 ? d.join(' ') : d;
			}),
			(gb.abbrev = function() {
				var a = this.string(!1);
				return a[0].charAt(0) + ((a[1] && a[1].charAt(0)) || '');
			}),
			(gb.clone = function() {
				return new A(this.string(), this.forceY);
			}),
			(z.toggle = function(a, c) {
				var e = this.cache,
					f = this.options,
					g = this.tooltip;
				if (c) {
					if (
						/over|enter/.test(c.type) &&
						e.event &&
						/out|leave/.test(e.event.type) &&
						f.show.target.add(c.target).length === f.show.target.length &&
						g.has(c.relatedTarget).length
					)
						return this;
					e.event = d.event.fix(c);
				}
				if ((this.waiting && !a && (this.hiddenDuringWait = D), !this.rendered))
					return a ? this.render(1) : this;
				if (this.destroyed || this.disabled) return this;
				var h,
					i,
					j,
					k = a ? 'show' : 'hide',
					l = this.options[k],
					m = (this.options[a ? 'hide' : 'show'], this.options.position),
					n = this.options.content,
					o = this.tooltip.css('width'),
					p = this.tooltip.is(':visible'),
					q = a || 1 === l.target.length,
					r = !c || l.target.length < 2 || e.target[0] === c.target;
				return (
					(typeof a).search('boolean|number') && (a = !p),
					(h = !g.is(':animated') && p === a && r),
					(i = h ? F : !!this._trigger(k, [ 90 ])),
					this.destroyed
						? this
						: (i !== E && a && this.focus(c),
							!i || h
								? this
								: (d.attr(g[0], 'aria-hidden', !a),
									a
										? (this.mouse && (e.origin = d.event.fix(this.mouse)),
											d.isFunction(n.text) && this._updateContent(n.text, E),
											d.isFunction(n.title) && this._updateTitle(n.title, E),
											!C &&
												'mouse' === m.target &&
												m.adjust.mouse &&
												(d(b).bind('mousemove.' + S, this._storeMouse), (C = D)),
											o || g.css('width', g.outerWidth(E)),
											this.reposition(c, arguments[2]),
											o || g.css('width', ''),
											l.solo &&
												('string' == typeof l.solo ? d(l.solo) : d(W, l.solo))
													.not(g)
													.not(l.target)
													.qtip('hide', d.Event('tooltipsolo')))
										: (clearTimeout(this.timers.show),
											delete e.origin,
											C &&
												!d(W + '[tracking="true"]:visible', l.solo).not(g).length &&
												(d(b).unbind('mousemove.' + S), (C = E)),
											this.blur(c)),
									(j = d.proxy(function() {
										a
											? (db.ie && g[0].style.removeAttribute('filter'),
												g.css('overflow', ''),
												'string' == typeof l.autofocus && d(this.options.show.autofocus, g).focus(),
												this.options.show.target.trigger('qtip-' + this.id + '-inactive'))
											: g.css({ display: '', visibility: '', opacity: '', left: '', top: '' }),
											this._trigger(a ? 'visible' : 'hidden');
									}, this)),
									l.effect === E || q === E
										? (g[k](), j())
										: d.isFunction(l.effect)
											? (g.stop(1, 1),
												l.effect.call(g, this),
												g.queue('fx', function(a) {
													j(), a();
												}))
											: g.fadeTo(90, a ? 1 : 0, j),
									a && l.target.trigger('qtip-' + this.id + '-inactive'),
									this))
				);
			}),
			(z.show = function(a) {
				return this.toggle(D, a);
			}),
			(z.hide = function(a) {
				return this.toggle(E, a);
			}),
			(z.focus = function(a) {
				if (!this.rendered || this.destroyed) return this;
				var b = d(W),
					c = this.tooltip,
					e = parseInt(c[0].style.zIndex, 10),
					f = y.zindex + b.length;
				return (
					c.hasClass($) ||
						(this._trigger('focus', [ f ], a) &&
							(e !== f &&
								(b.each(function() {
									this.style.zIndex > e && (this.style.zIndex = this.style.zIndex - 1);
								}),
								b.filter('.' + $).qtip('blur', a)),
							(c.addClass($)[0].style.zIndex = f))),
					this
				);
			}),
			(z.blur = function(a) {
				return !this.rendered || this.destroyed
					? this
					: (this.tooltip.removeClass($), this._trigger('blur', [ this.tooltip.css('zIndex') ], a), this);
			}),
			(z.disable = function(a) {
				return this.destroyed
					? this
					: ('toggle' === a
							? (a = !(this.rendered ? this.tooltip.hasClass(ab) : this.disabled))
							: 'boolean' != typeof a && (a = D),
						this.rendered && this.tooltip.toggleClass(ab, a).attr('aria-disabled', a),
						(this.disabled = !!a),
						this);
			}),
			(z.enable = function() {
				return this.disable(E);
			}),
			(z._createButton = function() {
				var a = this,
					b = this.elements,
					c = b.tooltip,
					e = this.options.content.button,
					f = 'string' == typeof e,
					g = f ? e : 'Close tooltip';
				b.button && b.button.remove(),
					(b.button = e.jquery
						? e
						: d('<a />', {
								class: 'qtip-close ' + (this.options.style.widget ? '' : S + '-icon'),
								title: g,
								'aria-label': g
							}).prepend(d('<span />', { class: 'ui-icon ui-icon-close', html: '&times;' }))),
					b.button.appendTo(b.titlebar || c).attr('role', 'button').click(function(b) {
						return c.hasClass(ab) || a.hide(b), E;
					});
			}),
			(z._updateButton = function(a) {
				if (!this.rendered) return E;
				var b = this.elements.button;
				a ? this._createButton() : b.remove();
			}),
			(z._setWidget = function() {
				var a = this.options.style.widget,
					b = this.elements,
					c = b.tooltip,
					d = c.hasClass(ab);
				c.removeClass(ab),
					(ab = a ? 'ui-state-disabled' : 'qtip-disabled'),
					c.toggleClass(ab, d),
					c.toggleClass('ui-helper-reset ' + k(), a).toggleClass(Z, this.options.style.def && !a),
					b.content && b.content.toggleClass(k('content'), a),
					b.titlebar && b.titlebar.toggleClass(k('header'), a),
					b.button && b.button.toggleClass(S + '-icon', !a);
			}),
			(z._storeMouse = function(a) {
				return ((this.mouse = d.event.fix(a)).type = 'mousemove'), this;
			}),
			(z._bind = function(a, b, c, e, f) {
				if (a && c && b.length) {
					var g = '.' + this._id + (e ? '-' + e : '');
					return d(a).bind((b.split ? b : b.join(g + ' ')) + g, d.proxy(c, f || this)), this;
				}
			}),
			(z._unbind = function(a, b) {
				return a && d(a).unbind('.' + this._id + (b ? '-' + b : '')), this;
			}),
			(z._trigger = function(a, b, c) {
				var e = d.Event('tooltip' + a);
				return (
					(e.originalEvent = (c && d.extend({}, c)) || this.cache.event || F),
					(this.triggering = a),
					this.tooltip.trigger(e, [ this ].concat(b || [])),
					(this.triggering = E),
					!e.isDefaultPrevented()
				);
			}),
			(z._bindEvents = function(a, b, c, e, f, g) {
				var h = c.filter(e).add(e.filter(c)),
					i = [];
				h.length &&
					(d.each(b, function(b, c) {
						var e = d.inArray(c, a);
						e > -1 && i.push(a.splice(e, 1)[0]);
					}),
					i.length &&
						(this._bind(h, i, function(a) {
							var b = this.rendered ? this.tooltip[0].offsetWidth > 0 : !1;
							(b ? g : f).call(this, a);
						}),
						(c = c.not(h)),
						(e = e.not(h)))),
					this._bind(c, a, f),
					this._bind(e, b, g);
			}),
			(z._assignInitialEvents = function(a) {
				function b(a) {
					return this.disabled || this.destroyed
						? E
						: ((this.cache.event = a && d.event.fix(a)),
							(this.cache.target = a && d(a.target)),
							clearTimeout(this.timers.show),
							void (this.timers.show = l.call(
								this,
								function() {
									this.render('object' == typeof a || c.show.ready);
								},
								c.prerender ? 0 : c.show.delay
							)));
				}
				var c = this.options,
					e = c.show.target,
					f = c.hide.target,
					g = c.show.event ? d.trim('' + c.show.event).split(' ') : [],
					h = c.hide.event ? d.trim('' + c.hide.event).split(' ') : [];
				this._bind(
					this.elements.target,
					[ 'remove', 'removeqtip' ],
					function() {
						this.destroy(!0);
					},
					'destroy'
				),
					/mouse(over|enter)/i.test(c.show.event) &&
						!/mouse(out|leave)/i.test(c.hide.event) &&
						h.push('mouseleave'),
					this._bind(e, 'mousemove', function(a) {
						this._storeMouse(a), (this.cache.onTarget = D);
					}),
					this._bindEvents(g, h, e, f, b, function() {
						return this.timers ? void clearTimeout(this.timers.show) : E;
					}),
					(c.show.ready || c.prerender) && b.call(this, a);
			}),
			(z._assignEvents = function() {
				var c = this,
					e = this.options,
					f = e.position,
					g = this.tooltip,
					h = e.show.target,
					i = e.hide.target,
					j = f.container,
					k = f.viewport,
					l = d(b),
					q = (d(b.body), d(a)),
					r = e.show.event ? d.trim('' + e.show.event).split(' ') : [],
					s = e.hide.event ? d.trim('' + e.hide.event).split(' ') : [];
				d.each(e.events, function(a, b) {
					c._bind(g, 'toggle' === a ? [ 'tooltipshow', 'tooltiphide' ] : [ 'tooltip' + a ], b, null, g);
				}),
					/mouse(out|leave)/i.test(e.hide.event) &&
						'window' === e.hide.leave &&
						this._bind(l, [ 'mouseout', 'blur' ], function(a) {
							/select|option/.test(a.target.nodeName) || a.relatedTarget || this.hide(a);
						}),
					e.hide.fixed
						? (i = i.add(g.addClass(Y)))
						: /mouse(over|enter)/i.test(e.show.event) &&
							this._bind(i, 'mouseleave', function() {
								clearTimeout(this.timers.show);
							}),
					('' + e.hide.event).indexOf('unfocus') > -1 &&
						this._bind(j.closest('html'), [ 'mousedown', 'touchstart' ], function(a) {
							var b = d(a.target),
								c = this.rendered && !this.tooltip.hasClass(ab) && this.tooltip[0].offsetWidth > 0,
								e = b.parents(W).filter(this.tooltip[0]).length > 0;
							b[0] === this.target[0] ||
								b[0] === this.tooltip[0] ||
								e ||
								this.target.has(b[0]).length ||
								!c ||
								this.hide(a);
						}),
					'number' == typeof e.hide.inactive &&
						(this._bind(h, 'qtip-' + this.id + '-inactive', o, 'inactive'),
						this._bind(i.add(g), y.inactiveEvents, o)),
					this._bindEvents(r, s, h, i, m, n),
					this._bind(h.add(g), 'mousemove', function(a) {
						if ('number' == typeof e.hide.distance) {
							var b = this.cache.origin || {},
								c = this.options.hide.distance,
								d = Math.abs;
							(d(a.pageX - b.pageX) >= c || d(a.pageY - b.pageY) >= c) && this.hide(a);
						}
						this._storeMouse(a);
					}),
					'mouse' === f.target &&
						f.adjust.mouse &&
						(e.hide.event &&
							this._bind(h, [ 'mouseenter', 'mouseleave' ], function(a) {
								return this.cache ? void (this.cache.onTarget = 'mouseenter' === a.type) : E;
							}),
						this._bind(l, 'mousemove', function(a) {
							this.rendered &&
								this.cache.onTarget &&
								!this.tooltip.hasClass(ab) &&
								this.tooltip[0].offsetWidth > 0 &&
								this.reposition(a);
						})),
					(f.adjust.resize || k.length) && this._bind(d.event.special.resize ? k : q, 'resize', p),
					f.adjust.scroll && this._bind(q.add(f.container), 'scroll', p);
			}),
			(z._unassignEvents = function() {
				var c = this.options,
					e = c.show.target,
					f = c.hide.target,
					g = d.grep(
						[
							this.elements.target[0],
							this.rendered && this.tooltip[0],
							c.position.container[0],
							c.position.viewport[0],
							c.position.container.closest('html')[0],
							a,
							b
						],
						function(a) {
							return 'object' == typeof a;
						}
					);
				e && e.toArray && (g = g.concat(e.toArray())),
					f && f.toArray && (g = g.concat(f.toArray())),
					this._unbind(g)._unbind(g, 'destroy')._unbind(g, 'inactive');
			}),
			d(function() {
				q(W, [ 'mouseenter', 'mouseleave' ], function(a) {
					var b = 'mouseenter' === a.type,
						c = d(a.currentTarget),
						e = d(a.relatedTarget || a.target),
						f = this.options;
					b
						? (this.focus(a), c.hasClass(Y) && !c.hasClass(ab) && clearTimeout(this.timers.hide))
						: 'mouse' === f.position.target &&
							f.position.adjust.mouse &&
							f.hide.event &&
							f.show.target &&
							!e.closest(f.show.target[0]).length &&
							this.hide(a),
						c.toggleClass(_, b);
				}),
					q('[' + U + ']', X, o);
			}),
			(y = d.fn.qtip = function(a, b, e) {
				var f = ('' + a).toLowerCase(),
					g = F,
					i = d.makeArray(arguments).slice(1),
					j = i[i.length - 1],
					k = this[0] ? d.data(this[0], S) : F;
				return (!arguments.length && k) || 'api' === f
					? k
					: 'string' == typeof a
						? (this.each(function() {
								var a = d.data(this, S);
								if (!a) return D;
								if ((j && j.timeStamp && (a.cache.event = j), !b || ('option' !== f && 'options' !== f)))
									a[f] && a[f].apply(a, i);
								else {
									if (e === c && !d.isPlainObject(b)) return (g = a.get(b)), E;
									a.set(b, e);
								}
							}),
							g !== F ? g : this)
						: 'object' != typeof a && arguments.length
							? void 0
							: ((k = h(d.extend(D, {}, a))),
								this.each(function(a) {
									var b, c;
									return (
										(c = d.isArray(k.id) ? k.id[a] : k.id),
										(c = !c || c === E || c.length < 1 || y.api[c] ? y.nextid++ : c),
										(b = r(d(this), c, k)),
										b === E
											? D
											: ((y.api[c] = b),
												d.each(R, function() {
													'initialize' === this.initialize && this(b);
												}),
												void b._assignInitialEvents(j))
									);
								}));
			}),
			(d.qtip = e),
			(y.api = {}),
			d.each(
				{
					attr: function(a, b) {
						if (this.length) {
							var c = this[0],
								e = 'title',
								f = d.data(c, 'qtip');
							if (a === e && f && 'object' == typeof f && f.options.suppress)
								return arguments.length < 2
									? d.attr(c, cb)
									: (f && f.options.content.attr === e && f.cache.attr && f.set('content.text', b),
										this.attr(cb, b));
						}
						return d.fn['attr' + bb].apply(this, arguments);
					},
					clone: function(a) {
						var b = (d([]), d.fn['clone' + bb].apply(this, arguments));
						return (
							a ||
								b
									.filter('[' + cb + ']')
									.attr('title', function() {
										return d.attr(this, cb);
									})
									.removeAttr(cb),
							b
						);
					}
				},
				function(a, b) {
					if (!b || d.fn[a + bb]) return D;
					var c = (d.fn[a + bb] = d.fn[a]);
					d.fn[a] = function() {
						return b.apply(this, arguments) || c.apply(this, arguments);
					};
				}
			),
			d.ui ||
				((d['cleanData' + bb] = d.cleanData),
				(d.cleanData = function(a) {
					for (var b, c = 0; (b = d(a[c])).length; c++)
						if (b.attr(T))
							try {
								b.triggerHandler('removeqtip');
							} catch (e) {}
					d['cleanData' + bb].apply(this, arguments);
				})),
			(y.version = '2.2.1'),
			(y.nextid = 0),
			(y.inactiveEvents = X),
			(y.zindex = 15e3),
			(y.defaults = {
				prerender: E,
				id: E,
				overwrite: D,
				suppress: D,
				content: { text: D, attr: 'title', title: E, button: E },
				position: {
					my: 'top left',
					at: 'bottom right',
					target: E,
					container: E,
					viewport: E,
					adjust: { x: 0, y: 0, mouse: D, scroll: D, resize: D, method: 'flipinvert flipinvert' },
					effect: function(a, b) {
						d(this).animate(b, { duration: 200, queue: E });
					}
				},
				show: { target: E, event: 'mouseenter', effect: D, delay: 90, solo: E, ready: E, autofocus: E },
				hide: {
					target: E,
					event: 'mouseleave',
					effect: D,
					delay: 0,
					fixed: E,
					inactive: E,
					leave: 'window',
					distance: E
				},
				style: { classes: '', widget: E, width: E, height: E, def: D },
				events: { render: F, move: F, show: F, hide: F, toggle: F, visible: F, hidden: F, focus: F, blur: F }
			});
		var hb,
			ib = 'margin',
			jb = 'border',
			kb = 'color',
			lb = 'background-color',
			mb = 'transparent',
			nb = ' !important',
			ob = !!b.createElement('canvas').getContext,
			pb = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i,
			qb = {},
			rb = [ 'Webkit', 'O', 'Moz', 'ms' ];
		if (ob)
			var sb = a.devicePixelRatio || 1,
				tb = (function() {
					var a = b.createElement('canvas').getContext('2d');
					return (
						a.backingStorePixelRatio ||
						a.webkitBackingStorePixelRatio ||
						a.mozBackingStorePixelRatio ||
						a.msBackingStorePixelRatio ||
						a.oBackingStorePixelRatio ||
						1
					);
				})(),
				ub = sb / tb;
		else
			var vb = function(a, b, c) {
				return (
					'<qtipvml:' +
					a +
					' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" ' +
					(b || '') +
					' style="behavior: url(#default#VML); ' +
					(c || '') +
					'" />'
				);
			};
		d.extend(v.prototype, {
			init: function(a) {
				var b, c;
				(c = this.element = a.elements.tip = d('<div />', { class: S + '-tip' }).prependTo(a.tooltip)),
					ob
						? ((b = d('<canvas />').appendTo(this.element)[0].getContext('2d')),
							(b.lineJoin = 'miter'),
							(b.miterLimit = 1e5),
							b.save())
						: ((b = vb('shape', 'coordorigin="0,0"', 'position:absolute;')),
							this.element.html(b + b),
							a._bind(
								d('*', c).add(c),
								[ 'click', 'mousedown' ],
								function(a) {
									a.stopPropagation();
								},
								this._ns
							)),
					a._bind(a.tooltip, 'tooltipmove', this.reposition, this._ns, this),
					this.create();
			},
			_swapDimensions: function() {
				(this.size[0] = this.options.height), (this.size[1] = this.options.width);
			},
			_resetDimensions: function() {
				(this.size[0] = this.options.width), (this.size[1] = this.options.height);
			},
			_useTitle: function(a) {
				var b = this.qtip.elements.titlebar;
				return (
					b &&
					(a.y === K ||
						(a.y === O &&
							this.element.position().top + this.size[1] / 2 + this.options.offset < b.outerHeight(D)))
				);
			},
			_parseCorner: function(a) {
				var b = this.qtip.options.position.my;
				return (
					a === E || b === E
						? (a = E)
						: a === D ? (a = new A(b.string())) : a.string || ((a = new A(a)), (a.fixed = D)),
					a
				);
			},
			_parseWidth: function(a, b, c) {
				var d = this.qtip.elements,
					e = jb + s(b) + 'Width';
				return (
					(c
						? u(c, e)
						: u(d.content, e) || u((this._useTitle(a) && d.titlebar) || d.content, e) || u(d.tooltip, e)) ||
					0
				);
			},
			_parseRadius: function(a) {
				var b = this.qtip.elements,
					c = jb + s(a.y) + s(a.x) + 'Radius';
				return db.ie < 9 ? 0 : u((this._useTitle(a) && b.titlebar) || b.content, c) || u(b.tooltip, c) || 0;
			},
			_invalidColour: function(a, b, c) {
				var d = a.css(b);
				return !d || (c && d === a.css(c)) || pb.test(d) ? E : d;
			},
			_parseColours: function(a) {
				var b = this.qtip.elements,
					c = this.element.css('cssText', ''),
					e = jb + s(a[a.precedance]) + s(kb),
					f = (this._useTitle(a) && b.titlebar) || b.content,
					g = this._invalidColour,
					h = [];
				return (
					(h[0] = g(c, lb) || g(f, lb) || g(b.content, lb) || g(b.tooltip, lb) || c.css(lb)),
					(h[1] =
						g(c, e, kb) || g(f, e, kb) || g(b.content, e, kb) || g(b.tooltip, e, kb) || b.tooltip.css(e)),
					d('*', c).add(c).css('cssText', lb + ':' + mb + nb + ';' + jb + ':0' + nb + ';'),
					h
				);
			},
			_calculateSize: function(a) {
				var b,
					c,
					d,
					e = a.precedance === H,
					f = this.options.width,
					g = this.options.height,
					h = 'c' === a.abbrev(),
					i = (e ? f : g) * (h ? 0.5 : 1),
					j = Math.pow,
					k = Math.round,
					l = Math.sqrt(j(i, 2) + j(g, 2)),
					m = [ this.border / i * l, this.border / g * l ];
				return (
					(m[2] = Math.sqrt(j(m[0], 2) - j(this.border, 2))),
					(m[3] = Math.sqrt(j(m[1], 2) - j(this.border, 2))),
					(b = l + m[2] + m[3] + (h ? 0 : m[0])),
					(c = b / l),
					(d = [ k(c * f), k(c * g) ]),
					e ? d : d.reverse()
				);
			},
			_calculateTip: function(a, b, c) {
				(c = c || 1), (b = b || this.size);
				var d = b[0] * c,
					e = b[1] * c,
					f = Math.ceil(d / 2),
					g = Math.ceil(e / 2),
					h = {
						br: [ 0, 0, d, e, d, 0 ],
						bl: [ 0, 0, d, 0, 0, e ],
						tr: [ 0, e, d, 0, d, e ],
						tl: [ 0, 0, 0, e, d, e ],
						tc: [ 0, e, f, 0, d, e ],
						bc: [ 0, 0, d, 0, f, e ],
						rc: [ 0, 0, d, g, 0, e ],
						lc: [ d, 0, d, e, 0, g ]
					};
				return (h.lt = h.br), (h.rt = h.bl), (h.lb = h.tr), (h.rb = h.tl), h[a.abbrev()];
			},
			_drawCoords: function(a, b) {
				a.beginPath(), a.moveTo(b[0], b[1]), a.lineTo(b[2], b[3]), a.lineTo(b[4], b[5]), a.closePath();
			},
			create: function() {
				var a = (this.corner = (ob || db.ie) && this._parseCorner(this.options.corner));
				return (
					(this.enabled = !!this.corner && 'c' !== this.corner.abbrev()) &&
						((this.qtip.cache.corner = a.clone()), this.update()),
					this.element.toggle(this.enabled),
					this.corner
				);
			},
			update: function(b, c) {
				if (!this.enabled) return this;
				var e,
					f,
					g,
					h,
					i,
					j,
					k,
					l,
					m = this.qtip.elements,
					n = this.element,
					o = n.children(),
					p = this.options,
					q = this.size,
					r = p.mimic,
					s = Math.round;
				b || (b = this.qtip.cache.corner || this.corner),
					r === E
						? (r = b)
						: ((r = new A(r)),
							(r.precedance = b.precedance),
							'inherit' === r.x
								? (r.x = b.x)
								: 'inherit' === r.y ? (r.y = b.y) : r.x === r.y && (r[b.precedance] = b[b.precedance])),
					(f = r.precedance),
					b.precedance === G ? this._swapDimensions() : this._resetDimensions(),
					(e = this.color = this._parseColours(b)),
					e[1] !== mb
						? ((l = this.border = this._parseWidth(b, b[b.precedance])),
							p.border && 1 > l && !pb.test(e[1]) && (e[0] = e[1]),
							(this.border = l = p.border !== D ? p.border : l))
						: (this.border = l = 0),
					(k = this.size = this._calculateSize(b)),
					n.css({ width: k[0], height: k[1], lineHeight: k[1] + 'px' }),
					(j =
						b.precedance === H
							? [
									s(r.x === L ? l : r.x === N ? k[0] - q[0] - l : (k[0] - q[0]) / 2),
									s(r.y === K ? k[1] - q[1] : 0)
								]
							: [
									s(r.x === L ? k[0] - q[0] : 0),
									s(r.y === K ? l : r.y === M ? k[1] - q[1] - l : (k[1] - q[1]) / 2)
								]),
					ob
						? ((g = o[0].getContext('2d')),
							g.restore(),
							g.save(),
							g.clearRect(0, 0, 6e3, 6e3),
							(h = this._calculateTip(r, q, ub)),
							(i = this._calculateTip(r, this.size, ub)),
							o.attr(I, k[0] * ub).attr(J, k[1] * ub),
							o.css(I, k[0]).css(J, k[1]),
							this._drawCoords(g, i),
							(g.fillStyle = e[1]),
							g.fill(),
							g.translate(j[0] * ub, j[1] * ub),
							this._drawCoords(g, h),
							(g.fillStyle = e[0]),
							g.fill())
						: ((h = this._calculateTip(r)),
							(h = 'm' + h[0] + ',' + h[1] + ' l' + h[2] + ',' + h[3] + ' ' + h[4] + ',' + h[5] + ' xe'),
							(j[2] = l && /^(r|b)/i.test(b.string()) ? (8 === db.ie ? 2 : 1) : 0),
							o
								.css({
									coordsize: k[0] + l + ' ' + (k[1] + l),
									antialias: '' + (r.string().indexOf(O) > -1),
									left: j[0] - j[2] * Number(f === G),
									top: j[1] - j[2] * Number(f === H),
									width: k[0] + l,
									height: k[1] + l
								})
								.each(function(a) {
									var b = d(this);
									b
										[b.prop ? 'prop' : 'attr']({
											coordsize: k[0] + l + ' ' + (k[1] + l),
											path: h,
											fillcolor: e[0],
											filled: !!a,
											stroked: !a
										})
										.toggle(!(!l && !a)),
										!a &&
											b.html(
												vb(
													'stroke',
													'weight="' +
														2 * l +
														'px" color="' +
														e[1] +
														'" miterlimit="1000" joinstyle="miter"'
												)
											);
								})),
					a.opera &&
						setTimeout(function() {
							m.tip.css({ display: 'inline-block', visibility: 'visible' });
						}, 1),
					c !== E && this.calculate(b, k);
			},
			calculate: function(a, b) {
				if (!this.enabled) return E;
				var c,
					e,
					f = this,
					g = this.qtip.elements,
					h = this.element,
					i = this.options.offset,
					j = (g.tooltip.hasClass('ui-widget'), {});
				return (
					(a = a || this.corner),
					(c = a.precedance),
					(b = b || this._calculateSize(a)),
					(e = [ a.x, a.y ]),
					c === G && e.reverse(),
					d.each(e, function(d, e) {
						var h, k, l;
						e === O
							? ((h = c === H ? L : K),
								(j[h] = '50%'),
								(j[ib + '-' + h] = -Math.round(b[c === H ? 0 : 1] / 2) + i))
							: ((h = f._parseWidth(a, e, g.tooltip)),
								(k = f._parseWidth(a, e, g.content)),
								(l = f._parseRadius(a)),
								(j[e] = Math.max(-f.border, d ? k : i + (l > h ? l : -h))));
					}),
					(j[a[c]] -= b[c === G ? 0 : 1]),
					h.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(j),
					j
				);
			},
			reposition: function(a, b, d) {
				function e(a, b, c, d, e) {
					a === Q && j.precedance === b && k[d] && j[c] !== O
						? (j.precedance = j.precedance === G ? H : G)
						: a !== Q && k[d] && (j[b] = j[b] === O ? (k[d] > 0 ? d : e) : j[b] === d ? e : d);
				}
				function f(a, b, e) {
					j[a] === O
						? (p[ib + '-' + b] = o[a] = g[ib + '-' + b] - k[b])
						: ((h = g[e] !== c ? [ k[b], -g[b] ] : [ -k[b], g[b] ]),
							(o[a] = Math.max(h[0], h[1])) > h[0] && ((d[b] -= k[b]), (o[b] = E)),
							(p[g[e] !== c ? e : b] = o[a]));
				}
				if (this.enabled) {
					var g,
						h,
						i = b.cache,
						j = this.corner.clone(),
						k = d.adjusted,
						l = b.options.position.adjust.method.split(' '),
						m = l[0],
						n = l[1] || l[0],
						o = { left: E, top: E, x: 0, y: 0 },
						p = {};
					this.corner.fixed !== D &&
						(e(m, G, H, L, N),
						e(n, H, G, K, M),
						(j.string() !== i.corner.string() || i.cornerTop !== k.top || i.cornerLeft !== k.left) &&
							this.update(j, E)),
						(g = this.calculate(j)),
						g.right !== c && (g.left = -g.right),
						g.bottom !== c && (g.top = -g.bottom),
						(g.user = this.offset),
						(o.left = m === Q && !!k.left) && f(G, L, N),
						(o.top = n === Q && !!k.top) && f(H, K, M),
						this.element.css(p).toggle(!((o.x && o.y) || (j.x === O && o.y) || (j.y === O && o.x))),
						(d.left -= g.left.charAt
							? g.user
							: m !== Q || o.top || (!o.left && !o.top) ? g.left + this.border : 0),
						(d.top -= g.top.charAt
							? g.user
							: n !== Q || o.left || (!o.left && !o.top) ? g.top + this.border : 0),
						(i.cornerLeft = k.left),
						(i.cornerTop = k.top),
						(i.corner = j.clone());
				}
			},
			destroy: function() {
				this.qtip._unbind(this.qtip.tooltip, this._ns),
					this.qtip.elements.tip && this.qtip.elements.tip.find('*').remove().end().remove();
			}
		}),
			(hb = R.tip = function(a) {
				return new v(a, a.options.style.tip);
			}),
			(hb.initialize = 'render'),
			(hb.sanitize = function(a) {
				if (a.style && 'tip' in a.style) {
					var b = a.style.tip;
					'object' != typeof b && (b = a.style.tip = { corner: b }),
						/string|boolean/i.test(typeof b.corner) || (b.corner = D);
				}
			}),
			(B.tip = {
				'^position.my|style.tip.(corner|mimic|border)$': function() {
					this.create(), this.qtip.reposition();
				},
				'^style.tip.(height|width)$': function(a) {
					(this.size = [ a.width, a.height ]), this.update(), this.qtip.reposition();
				},
				'^content.title|style.(classes|widget)$': function() {
					this.update();
				}
			}),
			d.extend(D, y.defaults, {
				style: { tip: { corner: D, mimic: E, width: 6, height: 6, border: D, offset: 0 } }
			}),
			(R.viewport = function(c, d, e, f, g, h, i) {
				function j(a, b, c, e, f, g, h, i, j) {
					var k = d[f],
						s = u[a],
						t = v[a],
						w = c === Q,
						x = s === f ? j : s === g ? -j : -j / 2,
						y = t === f ? i : t === g ? -i : -i / 2,
						z = q[f] + r[f] - (n ? 0 : m[f]),
						A = z - k,
						B = k + j - (h === I ? o : p) - z,
						C = x - (u.precedance === a || s === u[b] ? y : 0) - (t === O ? i / 2 : 0);
					return (
						w
							? ((C = (s === f ? 1 : -1) * x),
								(d[f] += A > 0 ? A : B > 0 ? -B : 0),
								(d[f] = Math.max(
									-m[f] + r[f],
									k - C,
									Math.min(
										Math.max(-m[f] + r[f] + (h === I ? o : p), k + C),
										d[f],
										'center' === s ? k - x : 1e9
									)
								)))
							: ((e *= c === P ? 2 : 0),
								A > 0 && (s !== f || B > 0)
									? ((d[f] -= C + e), l.invert(a, f))
									: B > 0 && (s !== g || A > 0) && ((d[f] -= (s === O ? -C : C) + e), l.invert(a, g)),
								d[f] < q && -d[f] > B && ((d[f] = k), (l = u.clone()))),
						d[f] - k
					);
				}
				var k,
					l,
					m,
					n,
					o,
					p,
					q,
					r,
					s = e.target,
					t = c.elements.tooltip,
					u = e.my,
					v = e.at,
					w = e.adjust,
					x = w.method.split(' '),
					y = x[0],
					z = x[1] || x[0],
					A = e.viewport,
					B = e.container,
					C = (c.cache, { left: 0, top: 0 });
				return A.jquery && s[0] !== a && s[0] !== b.body && 'none' !== w.method
					? ((m = B.offset() || C),
						(n = 'static' === B.css('position')),
						(k = 'fixed' === t.css('position')),
						(o = A[0] === a ? A.width() : A.outerWidth(E)),
						(p = A[0] === a ? A.height() : A.outerHeight(E)),
						(q = { left: k ? 0 : A.scrollLeft(), top: k ? 0 : A.scrollTop() }),
						(r = A.offset() || C),
						('shift' !== y || 'shift' !== z) && (l = u.clone()),
						(C = {
							left: 'none' !== y ? j(G, H, y, w.x, L, N, I, f, h) : 0,
							top: 'none' !== z ? j(H, G, z, w.y, K, M, J, g, i) : 0,
							my: l
						}))
					: C;
			}),
			(R.polys = {
				polygon: function(a, b) {
					var c,
						d,
						e,
						f = {
							width: 0,
							height: 0,
							position: { top: 1e10, right: 0, bottom: 0, left: 1e10 },
							adjustable: E
						},
						g = 0,
						h = [],
						i = 1,
						j = 1,
						k = 0,
						l = 0;
					for (g = a.length; g--; )
						(c = [ parseInt(a[--g], 10), parseInt(a[g + 1], 10) ]),
							c[0] > f.position.right && (f.position.right = c[0]),
							c[0] < f.position.left && (f.position.left = c[0]),
							c[1] > f.position.bottom && (f.position.bottom = c[1]),
							c[1] < f.position.top && (f.position.top = c[1]),
							h.push(c);
					if (
						((d = f.width = Math.abs(f.position.right - f.position.left)),
						(e = f.height = Math.abs(f.position.bottom - f.position.top)),
						'c' === b.abbrev())
					)
						f.position = { left: f.position.left + f.width / 2, top: f.position.top + f.height / 2 };
					else {
						for (; d > 0 && e > 0 && i > 0 && j > 0; )
							for (
								d = Math.floor(d / 2),
									e = Math.floor(e / 2),
									b.x === L ? (i = d) : b.x === N ? (i = f.width - d) : (i += Math.floor(d / 2)),
									b.y === K ? (j = e) : b.y === M ? (j = f.height - e) : (j += Math.floor(e / 2)),
									g = h.length;
								g-- && !(h.length < 2);

							)
								(k = h[g][0] - f.position.left),
									(l = h[g][1] - f.position.top),
									((b.x === L && k >= i) ||
										(b.x === N && i >= k) ||
										(b.x === O && (i > k || k > f.width - i)) ||
										(b.y === K && l >= j) ||
										(b.y === M && j >= l) ||
										(b.y === O && (j > l || l > f.height - j))) &&
										h.splice(g, 1);
						f.position = { left: h[0][0], top: h[0][1] };
					}
					return f;
				},
				rect: function(a, b, c, d) {
					return {
						width: Math.abs(c - a),
						height: Math.abs(d - b),
						position: { left: Math.min(a, c), top: Math.min(b, d) }
					};
				},
				_angles: { tc: 1.5, tr: 7 / 4, tl: 5 / 4, bc: 0.5, br: 0.25, bl: 0.75, rc: 2, lc: 1, c: 0 },
				ellipse: function(a, b, c, d, e) {
					var f = R.polys._angles[e.abbrev()],
						g = 0 === f ? 0 : c * Math.cos(f * Math.PI),
						h = d * Math.sin(f * Math.PI);
					return {
						width: 2 * c - Math.abs(g),
						height: 2 * d - Math.abs(h),
						position: { left: a + g, top: b + h },
						adjustable: E
					};
				},
				circle: function(a, b, c, d) {
					return R.polys.ellipse(a, b, c, c, d);
				}
			}),
			(R.imagemap = function(a, b, c) {
				b.jquery || (b = d(b));
				var e,
					f,
					g,
					h,
					i,
					j = (b.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
					k = d('img[usemap="#' + b.parent('map').attr('name') + '"]'),
					l = d.trim(b.attr('coords')),
					m = l.replace(/,$/, '').split(',');
				if (!k.length) return E;
				if ('polygon' === j) h = R.polys.polygon(m, c);
				else {
					if (!R.polys[j]) return E;
					for (g = -1, i = m.length, f = []; ++g < i; ) f.push(parseInt(m[g], 10));
					h = R.polys[j].apply(this, f.concat(c));
				}
				return (
					(e = k.offset()),
					(e.left += Math.ceil((k.outerWidth(E) - k.width()) / 2)),
					(e.top += Math.ceil((k.outerHeight(E) - k.height()) / 2)),
					(h.position.left += e.left),
					(h.position.top += e.top),
					h
				);
			}),
			(R.svg = function(a, c, e) {
				for (
					var f,
						g,
						h,
						i,
						j,
						k,
						l,
						m,
						n,
						o = (d(b), c[0]),
						p = d(o.ownerSVGElement),
						q = o.ownerDocument,
						r = (parseInt(c.css('stroke-width'), 10) || 0) / 2;
					!o.getBBox;

				)
					o = o.parentNode;
				if (!o.getBBox || !o.parentNode) return E;
				switch (o.nodeName) {
					case 'ellipse':
					case 'circle':
						m = R.polys.ellipse(
							o.cx.baseVal.value,
							o.cy.baseVal.value,
							(o.rx || o.r).baseVal.value + r,
							(o.ry || o.r).baseVal.value + r,
							e
						);
						break;
					case 'line':
					case 'polygon':
					case 'polyline':
						for (
							l = o.points || [
								{ x: o.x1.baseVal.value, y: o.y1.baseVal.value },
								{ x: o.x2.baseVal.value, y: o.y2.baseVal.value }
							],
								m = [],
								k = -1,
								i = l.numberOfItems || l.length;
							++k < i;

						)
							(j = l.getItem ? l.getItem(k) : l[k]), m.push.apply(m, [ j.x, j.y ]);
						m = R.polys.polygon(m, e);
						break;
					default:
						(m = o.getBBox()),
							(m = { width: m.width, height: m.height, position: { left: m.x, top: m.y } });
				}
				return (
					(n = m.position),
					(p = p[0]),
					p.createSVGPoint &&
						((g = o.getScreenCTM()),
						(l = p.createSVGPoint()),
						(l.x = n.left),
						(l.y = n.top),
						(h = l.matrixTransform(g)),
						(n.left = h.x),
						(n.top = h.y)),
					q !== b &&
						'mouse' !== a.position.target &&
						((f = d((q.defaultView || q.parentWindow).frameElement).offset()),
						f && ((n.left += f.left), (n.top += f.top))),
					(q = d(q)),
					(n.left += q.scrollLeft()),
					(n.top += q.scrollTop()),
					m
				);
			});
		var wb,
			xb,
			yb = 'qtip-modal',
			zb = '.' + yb;
		(xb = function() {
			function a(a) {
				if (d.expr[':'].focusable) return d.expr[':'].focusable;
				var b,
					c,
					e,
					f = !isNaN(d.attr(a, 'tabindex')),
					g = a.nodeName && a.nodeName.toLowerCase();
				return 'area' === g
					? ((b = a.parentNode),
						(c = b.name),
						a.href && c && 'map' === b.nodeName.toLowerCase()
							? ((e = d('img[usemap=#' + c + ']')[0]), !!e && e.is(':visible'))
							: !1)
					: /input|select|textarea|button|object/.test(g) ? !a.disabled : 'a' === g ? a.href || f : f;
			}
			function c(a) {
				k.length < 1 && a.length ? a.not('body').blur() : k.first().focus();
			}
			function e(a) {
				if (i.is(':visible')) {
					var b,
						e = d(a.target),
						h = f.tooltip,
						j = e.closest(W);
					(b = j.length < 1 ? E : parseInt(j[0].style.zIndex, 10) > parseInt(h[0].style.zIndex, 10)),
						b || e.closest(W)[0] === h[0] || c(e),
						(g = a.target === k[k.length - 1]);
				}
			}
			var f,
				g,
				h,
				i,
				j = this,
				k = {};
			d.extend(j, {
				init: function() {
					return (
						(i = j.elem = d('<div />', {
							id: 'qtip-overlay',
							html: '<div></div>',
							mousedown: function() {
								return E;
							}
						}).hide()),
						d(b.body).bind('focusin' + zb, e),
						d(b).bind('keydown' + zb, function(a) {
							f && f.options.show.modal.escape && 27 === a.keyCode && f.hide(a);
						}),
						i.bind('click' + zb, function(a) {
							f && f.options.show.modal.blur && f.hide(a);
						}),
						j
					);
				},
				update: function(b) {
					(f = b),
						(k =
							b.options.show.modal.stealfocus !== E
								? b.tooltip.find('*').filter(function() {
										return a(this);
									})
								: []);
				},
				toggle: function(a, e, g) {
					var k = (d(b.body), a.tooltip),
						l = a.options.show.modal,
						m = l.effect,
						n = e ? 'show' : 'hide',
						o = i.is(':visible'),
						p = d(zb).filter(':visible:not(:animated)').not(k);
					return (
						j.update(a),
						e && l.stealfocus !== E && c(d(':focus')),
						i.toggleClass('blurs', l.blur),
						e && i.appendTo(b.body),
						(i.is(':animated') && o === e && h !== E) || (!e && p.length)
							? j
							: (i.stop(D, E),
								d.isFunction(m)
									? m.call(i, e)
									: m === E
										? i[n]()
										: i.fadeTo(parseInt(g, 10) || 90, e ? 1 : 0, function() {
												e || i.hide();
											}),
								e ||
									i.queue(function(a) {
										i.css({ left: '', top: '' }), d(zb).length || i.detach(), a();
									}),
								(h = e),
								f.destroyed && (f = F),
								j)
					);
				}
			}),
				j.init();
		}),
			(xb = new xb()),
			d.extend(w.prototype, {
				init: function(a) {
					var b = a.tooltip;
					return this.options.on
						? ((a.elements.overlay = xb.elem),
							b.addClass(yb).css('z-index', y.modal_zindex + d(zb).length),
							a._bind(
								b,
								[ 'tooltipshow', 'tooltiphide' ],
								function(a, c, e) {
									var f = a.originalEvent;
									if (a.target === b[0])
										if (
											f &&
											'tooltiphide' === a.type &&
											/mouse(leave|enter)/.test(f.type) &&
											d(f.relatedTarget).closest(xb.elem[0]).length
										)
											try {
												a.preventDefault();
											} catch (g) {}
										else
											(!f || (f && 'tooltipsolo' !== f.type)) &&
												this.toggle(a, 'tooltipshow' === a.type, e);
								},
								this._ns,
								this
							),
							a._bind(
								b,
								'tooltipfocus',
								function(a, c) {
									if (!a.isDefaultPrevented() && a.target === b[0]) {
										var e = d(zb),
											f = y.modal_zindex + e.length,
											g = parseInt(b[0].style.zIndex, 10);
										(xb.elem[0].style.zIndex = f - 1),
											e.each(function() {
												this.style.zIndex > g && (this.style.zIndex -= 1);
											}),
											e.filter('.' + $).qtip('blur', a.originalEvent),
											(b.addClass($)[0].style.zIndex = f),
											xb.update(c);
										try {
											a.preventDefault();
										} catch (h) {}
									}
								},
								this._ns,
								this
							),
							void a._bind(
								b,
								'tooltiphide',
								function(a) {
									a.target === b[0] && d(zb).filter(':visible').not(b).last().qtip('focus', a);
								},
								this._ns,
								this
							))
						: this;
				},
				toggle: function(a, b, c) {
					return a && a.isDefaultPrevented() ? this : void xb.toggle(this.qtip, !!b, c);
				},
				destroy: function() {
					this.qtip.tooltip.removeClass(yb),
						this.qtip._unbind(this.qtip.tooltip, this._ns),
						xb.toggle(this.qtip, E),
						delete this.qtip.elements.overlay;
				}
			}),
			(wb = R.modal = function(a) {
				return new w(a, a.options.show.modal);
			}),
			(wb.sanitize = function(a) {
				a.show &&
					('object' != typeof a.show.modal
						? (a.show.modal = { on: !!a.show.modal })
						: 'undefined' == typeof a.show.modal.on && (a.show.modal.on = D));
			}),
			(y.modal_zindex = y.zindex - 200),
			(wb.initialize = 'render'),
			(B.modal = {
				'^show.modal.(on|blur)$': function() {
					this.destroy(), this.init(), this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth > 0);
				}
			}),
			d.extend(D, y.defaults, { show: { modal: { on: E, effect: D, blur: D, stealfocus: D, escape: D } } });
		var Ab,
			Bb =
				'<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';
		d.extend(x.prototype, {
			_scroll: function() {
				var b = this.qtip.elements.overlay;
				b && (b[0].style.top = d(a).scrollTop() + 'px');
			},
			init: function(c) {
				var e = c.tooltip;
				d('select, object').length < 1 &&
					((this.bgiframe = c.elements.bgiframe = d(Bb).appendTo(e)),
					c._bind(e, 'tooltipmove', this.adjustBGIFrame, this._ns, this)),
					(this.redrawContainer = d('<div/>', { id: S + '-rcontainer' }).appendTo(b.body)),
					c.elements.overlay &&
						c.elements.overlay.addClass('qtipmodal-ie6fix') &&
						(c._bind(a, [ 'scroll', 'resize' ], this._scroll, this._ns, this),
						c._bind(e, [ 'tooltipshow' ], this._scroll, this._ns, this)),
					this.redraw();
			},
			adjustBGIFrame: function() {
				var a,
					b,
					c = this.qtip.tooltip,
					d = { height: c.outerHeight(E), width: c.outerWidth(E) },
					e = this.qtip.plugins.tip,
					f = this.qtip.elements.tip;
				(b = parseInt(c.css('borderLeftWidth'), 10) || 0),
					(b = { left: -b, top: -b }),
					e && f && ((a = 'x' === e.corner.precedance ? [ I, L ] : [ J, K ]), (b[a[1]] -= f[a[0]]())),
					this.bgiframe.css(b).css(d);
			},
			redraw: function() {
				if (this.qtip.rendered < 1 || this.drawing) return this;
				var a,
					b,
					c,
					d,
					e = this.qtip.tooltip,
					f = this.qtip.options.style,
					g = this.qtip.options.position.container;
				return (
					(this.qtip.drawing = 1),
					f.height && e.css(J, f.height),
					f.width
						? e.css(I, f.width)
						: (e.css(I, '').appendTo(this.redrawContainer),
							(b = e.width()),
							1 > b % 2 && (b += 1),
							(c = e.css('maxWidth') || ''),
							(d = e.css('minWidth') || ''),
							(a = (c + d).indexOf('%') > -1 ? g.width() / 100 : 0),
							(c = (c.indexOf('%') > -1 ? a : 1) * parseInt(c, 10) || b),
							(d = (d.indexOf('%') > -1 ? a : 1) * parseInt(d, 10) || 0),
							(b = c + d ? Math.min(Math.max(b, d), c) : b),
							e.css(I, Math.round(b)).appendTo(g)),
					(this.drawing = 0),
					this
				);
			},
			destroy: function() {
				this.bgiframe && this.bgiframe.remove(), this.qtip._unbind([ a, this.qtip.tooltip ], this._ns);
			}
		}),
			(Ab = R.ie6 = function(a) {
				return 6 === db.ie ? new x(a) : E;
			}),
			(Ab.initialize = 'render'),
			(B.ie6 = {
				'^content|style$': function() {
					this.redraw();
				}
			});
	});
})(window, document);
//# sourceMappingURL=jquery.qtip.min.js.map

// DateTIMEPICKER http://www.malot.fr/bootstrap-datetimepicker/
!(function(e) {
	if (!('indexOf' in Array.prototype)) {
		Array.prototype.indexOf = function(k, j) {
			if (j === undefined) {
				j = 0;
			}
			if (j < 0) {
				j += this.length;
			}
			if (j < 0) {
				j = 0;
			}
			for (var l = this.length; j < l; j++) {
				if (j in this && this[j] === k) {
					return j;
				}
			}
			return -1;
		};
	}
	function b(k) {
		var j = e(k);
		var i = j.add(j.parents());
		var l = false;
		i.each(function() {
			if (e(this).css('position') === 'fixed') {
				l = true;
				return false;
			}
		});
		return l;
	}
	function h() {
		return new Date(Date.UTC.apply(Date, arguments));
	}
	function c() {
		var i = new Date();
		return h(
			i.getUTCFullYear(),
			i.getUTCMonth(),
			i.getUTCDate(),
			i.getUTCHours(),
			i.getUTCMinutes(),
			i.getUTCSeconds(),
			0
		);
	}
	var g = function(k, j) {
		var m = this;
		this.element = e(k);
		this.container = j.container || 'body';
		this.language = j.language || this.element.data('date-language') || 'en';
		this.language = this.language in f ? this.language : this.language.split('-')[0];
		this.language = this.language in f ? this.language : 'en';
		this.isRTL = f[this.language].rtl || false;
		this.formatType = j.formatType || this.element.data('format-type') || 'standard';
		this.format = d.parseFormat(
			j.format ||
				this.element.data('date-format') ||
				f[this.language].format ||
				d.getDefaultFormat(this.formatType, 'input'),
			this.formatType
		);
		this.isInline = false;
		this.isVisible = false;
		this.isInput = this.element.is('input');
		this.fontAwesome = j.fontAwesome || this.element.data('font-awesome') || false;
		this.bootcssVer =
			j.bootcssVer ||
			(this.isInput
				? this.element.is('.form-control') ? 3 : 2
				: (this.bootcssVer = this.element.is('.input-group') ? 3 : 2));
		this.component = this.element.is('.date')
			? this.bootcssVer == 3
				? this.element
						.find(
							'.input-group-addon .glyphicon-th, .input-group-addon .glyphicon-time, .input-group-addon .glyphicon-calendar, .input-group-addon .glyphicon-calendar, .input-group-addon .mdi-calendar, .input-group-addon .mdi-clock'
						)
						.parent()
				: this.element
						.find('.add-on .icon-th, .add-on .icon-time, .add-on .icon-calendar .mdi-calendar .mdi-clock')
						.parent()
			: false;
		this.componentReset = this.element.is('.date')
			? this.bootcssVer == 3
				? this.element.find('.input-group-addon .glyphicon-remove, .input-group-addon .mdi-close').parent()
				: this.element.find('.add-on .icon-remove, .add-on .mdi-close').parent()
			: false;
		this.hasInput = this.component && this.element.find('input').length;
		if (this.component && this.component.length === 0) {
			this.component = false;
		}
		this.linkField = j.linkField || this.element.data('link-field') || false;
		this.linkFormat = d.parseFormat(
			j.linkFormat || this.element.data('link-format') || d.getDefaultFormat(this.formatType, 'link'),
			this.formatType
		);
		this.minuteStep = j.minuteStep || this.element.data('minute-step') || 5;
		this.pickerPosition = j.pickerPosition || this.element.data('picker-position') || 'bottom-right';
		this.showMeridian = j.showMeridian || this.element.data('show-meridian') || false;
		this.initialDate = j.initialDate || new Date();
		this.zIndex = j.zIndex || this.element.data('z-index') || undefined;
		this.icons = { leftArrow: ' mdi-arrow-left', rightArrow: 'mdi-arrow-right' };
		this.icontype = 'mdi';
		this._attachEvents();
		this.clickedOutside = function(n) {
			if (e(n.target).closest('.datetimepicker').length === 0) {
				m.hide();
			}
		};
		this.formatViewType = 'datetime';
		if ('formatViewType' in j) {
			this.formatViewType = j.formatViewType;
		} else {
			if ('formatViewType' in this.element.data()) {
				this.formatViewType = this.element.data('formatViewType');
			}
		}
		this.minView = 0;
		if ('minView' in j) {
			this.minView = j.minView;
		} else {
			if ('minView' in this.element.data()) {
				this.minView = this.element.data('min-view');
			}
		}
		this.minView = d.convertViewMode(this.minView);
		this.maxView = d.modes.length - 1;
		if ('maxView' in j) {
			this.maxView = j.maxView;
		} else {
			if ('maxView' in this.element.data()) {
				this.maxView = this.element.data('max-view');
			}
		}
		this.maxView = d.convertViewMode(this.maxView);
		this.wheelViewModeNavigation = false;
		if ('wheelViewModeNavigation' in j) {
			this.wheelViewModeNavigation = j.wheelViewModeNavigation;
		} else {
			if ('wheelViewModeNavigation' in this.element.data()) {
				this.wheelViewModeNavigation = this.element.data('view-mode-wheel-navigation');
			}
		}
		this.wheelViewModeNavigationInverseDirection = false;
		if ('wheelViewModeNavigationInverseDirection' in j) {
			this.wheelViewModeNavigationInverseDirection = j.wheelViewModeNavigationInverseDirection;
		} else {
			if ('wheelViewModeNavigationInverseDirection' in this.element.data()) {
				this.wheelViewModeNavigationInverseDirection = this.element.data(
					'view-mode-wheel-navigation-inverse-dir'
				);
			}
		}
		this.wheelViewModeNavigationDelay = 100;
		if ('wheelViewModeNavigationDelay' in j) {
			this.wheelViewModeNavigationDelay = j.wheelViewModeNavigationDelay;
		} else {
			if ('wheelViewModeNavigationDelay' in this.element.data()) {
				this.wheelViewModeNavigationDelay = this.element.data('view-mode-wheel-navigation-delay');
			}
		}
		this.startViewMode = 2;
		if ('startView' in j) {
			this.startViewMode = j.startView;
		} else {
			if ('startView' in this.element.data()) {
				this.startViewMode = this.element.data('start-view');
			}
		}
		this.startViewMode = d.convertViewMode(this.startViewMode);
		this.viewMode = this.startViewMode;
		this.viewSelect = this.minView;
		if ('viewSelect' in j) {
			this.viewSelect = j.viewSelect;
		} else {
			if ('viewSelect' in this.element.data()) {
				this.viewSelect = this.element.data('view-select');
			}
		}
		this.viewSelect = d.convertViewMode(this.viewSelect);
		this.forceParse = true;
		if ('forceParse' in j) {
			this.forceParse = j.forceParse;
		} else {
			if ('dateForceParse' in this.element.data()) {
				this.forceParse = this.element.data('date-force-parse');
			}
		}
		var l = this.bootcssVer === 3 ? d.templateV3 : d.template;
		while (l.indexOf('{iconType}') !== -1) {
			l = l.replace('{iconType}', this.icontype);
		}
		while (l.indexOf('{leftArrow}') !== -1) {
			l = l.replace('{leftArrow}', this.icons.leftArrow);
		}
		while (l.indexOf('{rightArrow}') !== -1) {
			l = l.replace('{rightArrow}', this.icons.rightArrow);
		}
		this.picker = e(l)
			.appendTo(this.isInline ? this.element : this.container)
			.on({ click: e.proxy(this.click, this), mousedown: e.proxy(this.mousedown, this) });
		if (this.wheelViewModeNavigation) {
			if (e.fn.mousewheel) {
				this.picker.on({ mousewheel: e.proxy(this.mousewheel, this) });
			} else {
				console.log(
					'Mouse Wheel event is not supported. Please include the jQuery Mouse Wheel plugin before enabling this option'
				);
			}
		}
		if (this.isInline) {
			this.picker.addClass('datetimepicker-inline');
		} else {
			this.picker.addClass('datetimepicker-dropdown-' + this.pickerPosition + ' dropdown-menu');
		}
		if (this.isRTL) {
			this.picker.addClass('datetimepicker-rtl');
			var i = this.bootcssVer === 3 ? '.prev span, .next span' : '.prev i, .next i';
			this.picker.find(i).toggleClass(this.icons.leftArrow + ' ' + this.icons.rightArrow);
		}
		e(document).on('mousedown', this.clickedOutside);
		this.autoclose = false;
		if ('autoclose' in j) {
			this.autoclose = j.autoclose;
		} else {
			if ('dateAutoclose' in this.element.data()) {
				this.autoclose = this.element.data('date-autoclose');
			}
		}
		this.keyboardNavigation = true;
		if ('keyboardNavigation' in j) {
			this.keyboardNavigation = j.keyboardNavigation;
		} else {
			if ('dateKeyboardNavigation' in this.element.data()) {
				this.keyboardNavigation = this.element.data('date-keyboard-navigation');
			}
		}
		this.todayBtn = j.todayBtn || this.element.data('date-today-btn') || false;
		this.todayHighlight = j.todayHighlight || this.element.data('date-today-highlight') || false;
		this.weekStart = (j.weekStart || this.element.data('date-weekstart') || f[this.language].weekStart || 0) % 7;
		this.weekEnd = (this.weekStart + 6) % 7;
		this.startDate = -Infinity;
		this.endDate = Infinity;
		this.daysOfWeekDisabled = [];
		this.setStartDate(j.startDate || this.element.data('date-startdate'));
		this.setEndDate(j.endDate || this.element.data('date-enddate'));
		this.setDaysOfWeekDisabled(j.daysOfWeekDisabled || this.element.data('date-days-of-week-disabled'));
		this.setMinutesDisabled(j.minutesDisabled || this.element.data('date-minute-disabled'));
		this.setHoursDisabled(j.hoursDisabled || this.element.data('date-hour-disabled'));
		this.fillDow();
		this.fillMonths();
		this.update();
		this.showMode();
		if (this.isInline) {
			this.show();
		}
	};
	g.prototype = {
		constructor: g,
		_events: [],
		_attachEvents: function() {
			this._detachEvents();
			if (this.isInput) {
				this._events = [
					[
						this.element,
						{
							focus: e.proxy(this.show, this),
							keyup: e.proxy(this.update, this),
							keydown: e.proxy(this.keydown, this)
						}
					]
				];
			} else {
				if (this.component && this.hasInput) {
					this._events = [
						[
							this.element.find('input'),
							{
								focus: e.proxy(this.show, this),
								keyup: e.proxy(this.update, this),
								keydown: e.proxy(this.keydown, this)
							}
						],
						[ this.component, { click: e.proxy(this.show, this) } ]
					];
					if (this.componentReset) {
						this._events.push([ this.componentReset, { click: e.proxy(this.reset, this) } ]);
					}
				} else {
					if (this.element.is('div')) {
						this.isInline = true;
					} else {
						this._events = [ [ this.element, { click: e.proxy(this.show, this) } ] ];
					}
				}
			}
			for (var j = 0, k, l; j < this._events.length; j++) {
				k = this._events[j][0];
				l = this._events[j][1];
				k.on(l);
			}
		},
		_detachEvents: function() {
			for (var j = 0, k, l; j < this._events.length; j++) {
				k = this._events[j][0];
				l = this._events[j][1];
				k.off(l);
			}
			this._events = [];
		},
		show: function(i) {
			this.picker.show();
			this.height = this.component ? this.component.outerHeight() : this.element.outerHeight();
			if (this.forceParse) {
				this.update();
			}
			this.place();
			e(window).on('resize', e.proxy(this.place, this));
			if (i) {
				i.stopPropagation();
				i.preventDefault();
			}
			this.isVisible = true;
			this.element.trigger({ type: 'show', date: this.date });
		},
		hide: function(i) {
			if (!this.isVisible) {
				return;
			}
			if (this.isInline) {
				return;
			}
			this.picker.hide();
			e(window).off('resize', this.place);
			this.viewMode = this.startViewMode;
			this.showMode();
			if (!this.isInput) {
				e(document).off('mousedown', this.hide);
			}
			if (
				this.forceParse &&
				((this.isInput && this.element.val()) || (this.hasInput && this.element.find('input').val()))
			) {
				this.setValue();
			}
			this.isVisible = false;
			this.element.trigger({ type: 'hide', date: this.date });
		},
		remove: function() {
			this._detachEvents();
			e(document).off('mousedown', this.clickedOutside);
			this.picker.remove();
			delete this.picker;
			delete this.element.data().datetimepicker;
		},
		getDate: function() {
			var i = this.getUTCDate();
			return new Date(i.getTime() + i.getTimezoneOffset() * 60000);
		},
		getUTCDate: function() {
			return this.date;
		},
		setDate: function(i) {
			this.setUTCDate(new Date(i.getTime() - i.getTimezoneOffset() * 60000));
		},
		setUTCDate: function(i) {
			if (i >= this.startDate && i <= this.endDate) {
				this.date = i;
				this.setValue();
				this.viewDate = this.date;
				this.fill();
			} else {
				this.element.trigger({ type: 'outOfRange', date: i, startDate: this.startDate, endDate: this.endDate });
			}
		},
		setFormat: function(j) {
			this.format = d.parseFormat(j, this.formatType);
			var i;
			if (this.isInput) {
				i = this.element;
			} else {
				if (this.component) {
					i = this.element.find('input');
				}
			}
			if (i && i.val()) {
				this.setValue();
			}
		},
		setValue: function() {
			var i = this.getFormattedDate();
			if (!this.isInput) {
				if (this.component) {
					this.element.find('input').val(i);
				}
				this.element.data('date', i);
			} else {
				this.element.val(i);
			}
			if (this.linkField) {
				e('#' + this.linkField).val(this.getFormattedDate(this.linkFormat));
			}
		},
		getFormattedDate: function(i) {
			if (i == undefined) {
				i = this.format;
			}
			return d.formatDate(this.date, i, this.language, this.formatType);
		},
		setStartDate: function(i) {
			this.startDate = i || -Infinity;
			if (this.startDate !== -Infinity) {
				this.startDate = d.parseDate(this.startDate, this.format, this.language, this.formatType);
			}
			this.update();
			this.updateNavArrows();
		},
		setEndDate: function(i) {
			this.endDate = i || Infinity;
			if (this.endDate !== Infinity) {
				this.endDate = d.parseDate(this.endDate, this.format, this.language, this.formatType);
			}
			this.update();
			this.updateNavArrows();
		},
		setDaysOfWeekDisabled: function(i) {
			this.daysOfWeekDisabled = i || [];
			if (!e.isArray(this.daysOfWeekDisabled)) {
				this.daysOfWeekDisabled = this.daysOfWeekDisabled.split(/,\s*/);
			}
			this.daysOfWeekDisabled = e.map(this.daysOfWeekDisabled, function(j) {
				return parseInt(j, 10);
			});
			this.update();
			this.updateNavArrows();
		},
		setMinutesDisabled: function(i) {
			this.minutesDisabled = i || [];
			if (!e.isArray(this.minutesDisabled)) {
				this.minutesDisabled = this.minutesDisabled.split(/,\s*/);
			}
			this.minutesDisabled = e.map(this.minutesDisabled, function(j) {
				return parseInt(j, 10);
			});
			this.update();
			this.updateNavArrows();
		},
		setHoursDisabled: function(i) {
			this.hoursDisabled = i || [];
			if (!e.isArray(this.hoursDisabled)) {
				this.hoursDisabled = this.hoursDisabled.split(/,\s*/);
			}
			this.hoursDisabled = e.map(this.hoursDisabled, function(j) {
				return parseInt(j, 10);
			});
			this.update();
			this.updateNavArrows();
		},
		place: function() {
			if (this.isInline) {
				return;
			}
			if (!this.zIndex) {
				var j = 0;
				e('div').each(function() {
					var o = parseInt(e(this).css('zIndex'), 10);
					if (o > j) {
						j = o;
					}
				});
				this.zIndex = j + 10;
			}
			var n, m, l, k;
			if (this.container instanceof e) {
				k = this.container.offset();
			} else {
				k = e(this.container).offset();
			}
			if (this.component) {
				n = this.component.offset();
				l = n.left;
				if (this.pickerPosition == 'bottom-left' || this.pickerPosition == 'top-left') {
					l += this.component.outerWidth() - this.picker.outerWidth();
				}
			} else {
				n = this.element.offset();
				l = n.left;
			}
			var i = document.body.clientWidth || window.innerWidth;
			if (l + 220 > i) {
				l = i - 220;
			}
			if (this.pickerPosition == 'top-left' || this.pickerPosition == 'top-right') {
				m = n.top - this.picker.outerHeight();
			} else {
				m = n.top + this.height;
			}
			m = m - k.top;
			l = l - k.left;
			if (!b(this.element)) {
				m = m + document.body.scrollTop;
			}
			this.picker.css({ top: m, left: l, zIndex: this.zIndex });
		},
		update: function() {
			var i,
				j = false;
			if (arguments && arguments.length && (typeof arguments[0] === 'string' || arguments[0] instanceof Date)) {
				i = arguments[0];
				j = true;
			} else {
				i =
					(this.isInput ? this.element.val() : this.element.find('input').val()) ||
					this.element.data('date') ||
					this.initialDate;
				if (typeof i == 'string' || i instanceof String) {
					i = i.replace(/^\s+|\s+$/g, '');
				}
			}
			if (!i) {
				i = new Date();
				j = false;
			}
			this.date = d.parseDate(i, this.format, this.language, this.formatType);
			if (j) {
				this.setValue();
			}
			if (this.date < this.startDate) {
				this.viewDate = new Date(this.startDate);
			} else {
				if (this.date > this.endDate) {
					this.viewDate = new Date(this.endDate);
				} else {
					this.viewDate = new Date(this.date);
				}
			}
			this.fill();
		},
		fillDow: function() {
			var i = this.weekStart,
				j = '<tr>';
			while (i < this.weekStart + 7) {
				j += '<th class="dow">' + f[this.language].daysMin[i++ % 7] + '</th>';
			}
			j += '</tr>';
			this.picker.find('.datetimepicker-days thead').append(j);
		},
		fillMonths: function() {
			var k = '',
				j = 0;
			while (j < 12) {
				k += '<span class="month">' + f[this.language].monthsShort[j++] + '</span>';
			}
			this.picker.find('.datetimepicker-months td').html(k);
		},
		fill: function() {
			if (this.date == null || this.viewDate == null) {
				return;
			}
			var H = new Date(this.viewDate),
				u = H.getUTCFullYear(),
				I = H.getUTCMonth(),
				n = H.getUTCDate(),
				D = H.getUTCHours(),
				y = H.getUTCMinutes(),
				z = this.startDate !== -Infinity ? this.startDate.getUTCFullYear() : -Infinity,
				E = this.startDate !== -Infinity ? this.startDate.getUTCMonth() + 1 : -Infinity,
				q = this.endDate !== Infinity ? this.endDate.getUTCFullYear() : Infinity,
				A = this.endDate !== Infinity ? this.endDate.getUTCMonth() + 1 : Infinity,
				r = new h(this.date.getUTCFullYear(), this.date.getUTCMonth(), this.date.getUTCDate()).valueOf(),
				G = new Date();
			this.picker.find('.datetimepicker-days thead th:eq(1)').text(f[this.language].months[I] + ' ' + u);
			if (this.formatViewType == 'time') {
				var k = this.getFormattedDate();
				this.picker.find('.datetimepicker-hours thead th:eq(1)').text(k);
				this.picker.find('.datetimepicker-minutes thead th:eq(1)').text(k);
			} else {
				this.picker
					.find('.datetimepicker-hours thead th:eq(1)')
					.text(n + ' ' + f[this.language].months[I] + ' ' + u);
				this.picker
					.find('.datetimepicker-minutes thead th:eq(1)')
					.text(n + ' ' + f[this.language].months[I] + ' ' + u);
			}
			this.picker.find('tfoot th.today').text(f[this.language].today).toggle(this.todayBtn !== false);
			this.updateNavArrows();
			this.fillMonths();
			var K = h(u, I - 1, 28, 0, 0, 0, 0),
				C = d.getDaysInMonth(K.getUTCFullYear(), K.getUTCMonth());
			K.setUTCDate(C);
			K.setUTCDate(C - (K.getUTCDay() - this.weekStart + 7) % 7);
			var j = new Date(K);
			j.setUTCDate(j.getUTCDate() + 42);
			j = j.valueOf();
			var s = [];
			var v;
			while (K.valueOf() < j) {
				if (K.getUTCDay() == this.weekStart) {
					s.push('<tr>');
				}
				v = '';
				if (K.getUTCFullYear() < u || (K.getUTCFullYear() == u && K.getUTCMonth() < I)) {
					v += ' old';
				} else {
					if (K.getUTCFullYear() > u || (K.getUTCFullYear() == u && K.getUTCMonth() > I)) {
						v += ' new';
					}
				}
				if (
					this.todayHighlight &&
					K.getUTCFullYear() == G.getFullYear() &&
					K.getUTCMonth() == G.getMonth() &&
					K.getUTCDate() == G.getDate()
				) {
					v += ' today';
				}
				if (K.valueOf() == r) {
					v += ' active';
				}
				if (
					K.valueOf() + 86400000 <= this.startDate ||
					K.valueOf() > this.endDate ||
					e.inArray(K.getUTCDay(), this.daysOfWeekDisabled) !== -1
				) {
					v += ' disabled';
				}
				s.push('<td class="day' + v + '">' + K.getUTCDate() + '</td>');
				if (K.getUTCDay() == this.weekEnd) {
					s.push('</tr>');
				}
				K.setUTCDate(K.getUTCDate() + 1);
			}
			this.picker.find('.datetimepicker-days tbody').empty().append(s.join(''));
			s = [];
			var w = '',
				F = '',
				t = '';
			var l = this.hoursDisabled || [];
			for (var B = 0; B < 24; B++) {
				if (l.indexOf(B) !== -1) {
					continue;
				}
				var x = h(u, I, n, B);
				v = '';
				if (x.valueOf() + 3600000 <= this.startDate || x.valueOf() > this.endDate) {
					v += ' disabled';
				} else {
					if (D == B) {
						v += ' active';
					}
				}
				if (this.showMeridian && f[this.language].meridiem.length == 2) {
					F = B < 12 ? f[this.language].meridiem[0] : f[this.language].meridiem[1];
					if (F != t) {
						if (t != '') {
							s.push('</fieldset>');
						}
						s.push('<fieldset class="hour"><legend>' + F.toUpperCase() + '</legend>');
					}
					t = F;
					w = B % 12 ? B % 12 : 12;
					s.push('<span class="hour' + v + ' hour_' + (B < 12 ? 'am' : 'pm') + '">' + w + '</span>');
					if (B == 23) {
						s.push('</fieldset>');
					}
				} else {
					w = B + ':00';
					s.push('<span class="hour' + v + '">' + w + '</span>');
				}
			}
			this.picker.find('.datetimepicker-hours td').html(s.join(''));
			s = [];
			(w = ''), (F = ''), (t = '');
			var m = this.minutesDisabled || [];
			for (var B = 0; B < 60; B += this.minuteStep) {
				if (m.indexOf(B) !== -1) {
					continue;
				}
				var x = h(u, I, n, D, B, 0);
				v = '';
				if (x.valueOf() < this.startDate || x.valueOf() > this.endDate) {
					v += ' disabled';
				} else {
					if (Math.floor(y / this.minuteStep) == Math.floor(B / this.minuteStep)) {
						v += ' active';
					}
				}
				if (this.showMeridian && f[this.language].meridiem.length == 2) {
					F = D < 12 ? f[this.language].meridiem[0] : f[this.language].meridiem[1];
					if (F != t) {
						if (t != '') {
							s.push('</fieldset>');
						}
						s.push('<fieldset class="minute"><legend>' + F.toUpperCase() + '</legend>');
					}
					t = F;
					w = D % 12 ? D % 12 : 12;
					s.push('<span class="minute' + v + '">' + w + ':' + (B < 10 ? '0' + B : B) + '</span>');
					if (B == 59) {
						s.push('</fieldset>');
					}
				} else {
					w = B + ':00';
					s.push('<span class="minute' + v + '">' + D + ':' + (B < 10 ? '0' + B : B) + '</span>');
				}
			}
			this.picker.find('.datetimepicker-minutes td').html(s.join(''));
			var L = this.date.getUTCFullYear();
			var p = this.picker
				.find('.datetimepicker-months')
				.find('th:eq(1)')
				.text(u)
				.end()
				.find('span')
				.removeClass('active');
			if (L == u) {
				var o = p.length - 12;
				p.eq(this.date.getUTCMonth() + o).addClass('active');
			}
			if (u < z || u > q) {
				p.addClass('disabled');
			}
			if (u == z) {
				p.slice(0, E + 1).addClass('disabled');
			}
			if (u == q) {
				p.slice(A).addClass('disabled');
			}
			s = '';
			u = parseInt(u / 10, 10) * 10;
			var J = this.picker.find('.datetimepicker-years').find('th:eq(1)').text(u + '-' + (u + 9)).end().find('td');
			u -= 1;
			for (var B = -1; B < 11; B++) {
				s +=
					'<span class="year' +
					(B == -1 || B == 10 ? ' old' : '') +
					(L == u ? ' active' : '') +
					(u < z || u > q ? ' disabled' : '') +
					'">' +
					u +
					'</span>';
				u += 1;
			}
			J.html(s);
			this.place();
		},
		updateNavArrows: function() {
			var m = new Date(this.viewDate),
				k = m.getUTCFullYear(),
				l = m.getUTCMonth(),
				j = m.getUTCDate(),
				i = m.getUTCHours();
			switch (this.viewMode) {
				case 0:
					if (
						this.startDate !== -Infinity &&
						k <= this.startDate.getUTCFullYear() &&
						l <= this.startDate.getUTCMonth() &&
						j <= this.startDate.getUTCDate() &&
						i <= this.startDate.getUTCHours()
					) {
						this.picker.find('.prev').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.prev').css({ visibility: 'visible' });
					}
					if (
						this.endDate !== Infinity &&
						k >= this.endDate.getUTCFullYear() &&
						l >= this.endDate.getUTCMonth() &&
						j >= this.endDate.getUTCDate() &&
						i >= this.endDate.getUTCHours()
					) {
						this.picker.find('.next').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.next').css({ visibility: 'visible' });
					}
					break;
				case 1:
					if (
						this.startDate !== -Infinity &&
						k <= this.startDate.getUTCFullYear() &&
						l <= this.startDate.getUTCMonth() &&
						j <= this.startDate.getUTCDate()
					) {
						this.picker.find('.prev').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.prev').css({ visibility: 'visible' });
					}
					if (
						this.endDate !== Infinity &&
						k >= this.endDate.getUTCFullYear() &&
						l >= this.endDate.getUTCMonth() &&
						j >= this.endDate.getUTCDate()
					) {
						this.picker.find('.next').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.next').css({ visibility: 'visible' });
					}
					break;
				case 2:
					if (
						this.startDate !== -Infinity &&
						k <= this.startDate.getUTCFullYear() &&
						l <= this.startDate.getUTCMonth()
					) {
						this.picker.find('.prev').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.prev').css({ visibility: 'visible' });
					}
					if (
						this.endDate !== Infinity &&
						k >= this.endDate.getUTCFullYear() &&
						l >= this.endDate.getUTCMonth()
					) {
						this.picker.find('.next').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.next').css({ visibility: 'visible' });
					}
					break;
				case 3:
				case 4:
					if (this.startDate !== -Infinity && k <= this.startDate.getUTCFullYear()) {
						this.picker.find('.prev').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.prev').css({ visibility: 'visible' });
					}
					if (this.endDate !== Infinity && k >= this.endDate.getUTCFullYear()) {
						this.picker.find('.next').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.next').css({ visibility: 'visible' });
					}
					break;
			}
		},
		mousewheel: function(j) {
			j.preventDefault();
			j.stopPropagation();
			if (this.wheelPause) {
				return;
			}
			this.wheelPause = true;
			var i = j.originalEvent;
			var l = i.wheelDelta;
			var k = l > 0 ? 1 : l === 0 ? 0 : -1;
			if (this.wheelViewModeNavigationInverseDirection) {
				k = -k;
			}
			this.showMode(k);
			setTimeout(
				e.proxy(function() {
					this.wheelPause = false;
				}, this),
				this.wheelViewModeNavigationDelay
			);
		},
		click: function(m) {
			m.stopPropagation();
			m.preventDefault();
			var n = e(m.target).closest('span, td, th, legend');
			if (n.is('.' + this.icontype)) {
				n = e(n).parent().closest('span, td, th, legend');
			}
			if (n.length == 1) {
				if (n.is('.disabled')) {
					this.element.trigger({
						type: 'outOfRange',
						date: this.viewDate,
						startDate: this.startDate,
						endDate: this.endDate
					});
					return;
				}
				switch (n[0].nodeName.toLowerCase()) {
					case 'th':
						switch (n[0].className) {
							case 'switch':
								this.showMode(1);
								break;
							case 'prev':
							case 'next':
								var i = d.modes[this.viewMode].navStep * (n[0].className == 'prev' ? -1 : 1);
								switch (this.viewMode) {
									case 0:
										this.viewDate = this.moveHour(this.viewDate, i);
										break;
									case 1:
										this.viewDate = this.moveDate(this.viewDate, i);
										break;
									case 2:
										this.viewDate = this.moveMonth(this.viewDate, i);
										break;
									case 3:
									case 4:
										this.viewDate = this.moveYear(this.viewDate, i);
										break;
								}
								this.fill();
								this.element.trigger({
									type: n[0].className + ':' + this.convertViewModeText(this.viewMode),
									date: this.viewDate,
									startDate: this.startDate,
									endDate: this.endDate
								});
								break;
							case 'today':
								var j = new Date();
								j = h(
									j.getFullYear(),
									j.getMonth(),
									j.getDate(),
									j.getHours(),
									j.getMinutes(),
									j.getSeconds(),
									0
								);
								if (j < this.startDate) {
									j = this.startDate;
								} else {
									if (j > this.endDate) {
										j = this.endDate;
									}
								}
								this.viewMode = this.startViewMode;
								this.showMode(0);
								this._setDate(j);
								this.fill();
								if (this.autoclose) {
									this.hide();
								}
								break;
						}
						break;
					case 'span':
						if (!n.is('.disabled')) {
							var p = this.viewDate.getUTCFullYear(),
								o = this.viewDate.getUTCMonth(),
								q = this.viewDate.getUTCDate(),
								r = this.viewDate.getUTCHours(),
								k = this.viewDate.getUTCMinutes(),
								s = this.viewDate.getUTCSeconds();
							if (n.is('.month')) {
								this.viewDate.setUTCDate(1);
								o = n.parent().find('span').index(n);
								q = this.viewDate.getUTCDate();
								this.viewDate.setUTCMonth(o);
								this.element.trigger({ type: 'changeMonth', date: this.viewDate });
								if (this.viewSelect >= 3) {
									this._setDate(h(p, o, q, r, k, s, 0));
								}
							} else {
								if (n.is('.year')) {
									this.viewDate.setUTCDate(1);
									p = parseInt(n.text(), 10) || 0;
									this.viewDate.setUTCFullYear(p);
									this.element.trigger({ type: 'changeYear', date: this.viewDate });
									if (this.viewSelect >= 4) {
										this._setDate(h(p, o, q, r, k, s, 0));
									}
								} else {
									if (n.is('.hour')) {
										r = parseInt(n.text(), 10) || 0;
										if (n.hasClass('hour_am') || n.hasClass('hour_pm')) {
											if (r == 12 && n.hasClass('hour_am')) {
												r = 0;
											} else {
												if (r != 12 && n.hasClass('hour_pm')) {
													r += 12;
												}
											}
										}
										this.viewDate.setUTCHours(r);
										this.element.trigger({ type: 'changeHour', date: this.viewDate });
										if (this.viewSelect >= 1) {
											this._setDate(h(p, o, q, r, k, s, 0));
										}
									} else {
										if (n.is('.minute')) {
											k = parseInt(n.text().substr(n.text().indexOf(':') + 1), 10) || 0;
											this.viewDate.setUTCMinutes(k);
											this.element.trigger({ type: 'changeMinute', date: this.viewDate });
											if (this.viewSelect >= 0) {
												this._setDate(h(p, o, q, r, k, s, 0));
											}
										}
									}
								}
							}
							if (this.viewMode != 0) {
								var l = this.viewMode;
								this.showMode(-1);
								this.fill();
								if (l == this.viewMode && this.autoclose) {
									this.hide();
								}
							} else {
								this.fill();
								if (this.autoclose) {
									this.hide();
								}
							}
						}
						break;
					case 'td':
						if (n.is('.day') && !n.is('.disabled')) {
							var q = parseInt(n.text(), 10) || 1;
							var p = this.viewDate.getUTCFullYear(),
								o = this.viewDate.getUTCMonth(),
								r = this.viewDate.getUTCHours(),
								k = this.viewDate.getUTCMinutes(),
								s = this.viewDate.getUTCSeconds();
							if (n.is('.old')) {
								if (o === 0) {
									o = 11;
									p -= 1;
								} else {
									o -= 1;
								}
							} else {
								if (n.is('.new')) {
									if (o == 11) {
										o = 0;
										p += 1;
									} else {
										o += 1;
									}
								}
							}
							this.viewDate.setUTCFullYear(p);
							this.viewDate.setUTCMonth(o, q);
							this.element.trigger({ type: 'changeDay', date: this.viewDate });
							if (this.viewSelect >= 2) {
								this._setDate(h(p, o, q, r, k, s, 0));
							}
						}
						var l = this.viewMode;
						this.showMode(-1);
						this.fill();
						if (l == this.viewMode && this.autoclose) {
							this.hide();
						}
						break;
				}
			}
		},
		_setDate: function(i, k) {
			if (!k || k == 'date') {
				this.date = i;
			}
			if (!k || k == 'view') {
				this.viewDate = i;
			}
			this.fill();
			this.setValue();
			var j;
			if (this.isInput) {
				j = this.element;
			} else {
				if (this.component) {
					j = this.element.find('input');
				}
			}
			if (j) {
				j.change();
				if (this.autoclose && (!k || k == 'date')) {
				}
			}
			this.element.trigger({ type: 'changeDate', date: this.date });
			if (i == null) {
				this.date = this.viewDate;
			}
		},
		moveMinute: function(j, i) {
			if (!i) {
				return j;
			}
			var k = new Date(j.valueOf());
			k.setUTCMinutes(k.getUTCMinutes() + i * this.minuteStep);
			return k;
		},
		moveHour: function(j, i) {
			if (!i) {
				return j;
			}
			var k = new Date(j.valueOf());
			k.setUTCHours(k.getUTCHours() + i);
			return k;
		},
		moveDate: function(j, i) {
			if (!i) {
				return j;
			}
			var k = new Date(j.valueOf());
			k.setUTCDate(k.getUTCDate() + i);
			return k;
		},
		moveMonth: function(j, k) {
			if (!k) {
				return j;
			}
			var n = new Date(j.valueOf()),
				r = n.getUTCDate(),
				o = n.getUTCMonth(),
				m = Math.abs(k),
				q,
				p;
			k = k > 0 ? 1 : -1;
			if (m == 1) {
				p =
					k == -1
						? function() {
								return n.getUTCMonth() == o;
							}
						: function() {
								return n.getUTCMonth() != q;
							};
				q = o + k;
				n.setUTCMonth(q);
				if (q < 0 || q > 11) {
					q = (q + 12) % 12;
				}
			} else {
				for (var l = 0; l < m; l++) {
					n = this.moveMonth(n, k);
				}
				q = n.getUTCMonth();
				n.setUTCDate(r);
				p = function() {
					return q != n.getUTCMonth();
				};
			}
			while (p()) {
				n.setUTCDate(--r);
				n.setUTCMonth(q);
			}
			return n;
		},
		moveYear: function(j, i) {
			return this.moveMonth(j, i * 12);
		},
		dateWithinRange: function(i) {
			return i >= this.startDate && i <= this.endDate;
		},
		keydown: function(m) {
			if (this.picker.is(':not(:visible)')) {
				if (m.keyCode == 27) {
					this.show();
				}
				return;
			}
			var o = false,
				j,
				p,
				n,
				q,
				i;
			switch (m.keyCode) {
				case 27:
					this.hide();
					m.preventDefault();
					break;
				case 37:
				case 39:
					if (!this.keyboardNavigation) {
						break;
					}
					j = m.keyCode == 37 ? -1 : 1;
					viewMode = this.viewMode;
					if (m.ctrlKey) {
						viewMode += 2;
					} else {
						if (m.shiftKey) {
							viewMode += 1;
						}
					}
					if (viewMode == 4) {
						q = this.moveYear(this.date, j);
						i = this.moveYear(this.viewDate, j);
					} else {
						if (viewMode == 3) {
							q = this.moveMonth(this.date, j);
							i = this.moveMonth(this.viewDate, j);
						} else {
							if (viewMode == 2) {
								q = this.moveDate(this.date, j);
								i = this.moveDate(this.viewDate, j);
							} else {
								if (viewMode == 1) {
									q = this.moveHour(this.date, j);
									i = this.moveHour(this.viewDate, j);
								} else {
									if (viewMode == 0) {
										q = this.moveMinute(this.date, j);
										i = this.moveMinute(this.viewDate, j);
									}
								}
							}
						}
					}
					if (this.dateWithinRange(q)) {
						this.date = q;
						this.viewDate = i;
						this.setValue();
						this.update();
						m.preventDefault();
						o = true;
					}
					break;
				case 38:
				case 40:
					if (!this.keyboardNavigation) {
						break;
					}
					j = m.keyCode == 38 ? -1 : 1;
					viewMode = this.viewMode;
					if (m.ctrlKey) {
						viewMode += 2;
					} else {
						if (m.shiftKey) {
							viewMode += 1;
						}
					}
					if (viewMode == 4) {
						q = this.moveYear(this.date, j);
						i = this.moveYear(this.viewDate, j);
					} else {
						if (viewMode == 3) {
							q = this.moveMonth(this.date, j);
							i = this.moveMonth(this.viewDate, j);
						} else {
							if (viewMode == 2) {
								q = this.moveDate(this.date, j * 7);
								i = this.moveDate(this.viewDate, j * 7);
							} else {
								if (viewMode == 1) {
									if (this.showMeridian) {
										q = this.moveHour(this.date, j * 6);
										i = this.moveHour(this.viewDate, j * 6);
									} else {
										q = this.moveHour(this.date, j * 4);
										i = this.moveHour(this.viewDate, j * 4);
									}
								} else {
									if (viewMode == 0) {
										q = this.moveMinute(this.date, j * 4);
										i = this.moveMinute(this.viewDate, j * 4);
									}
								}
							}
						}
					}
					if (this.dateWithinRange(q)) {
						this.date = q;
						this.viewDate = i;
						this.setValue();
						this.update();
						m.preventDefault();
						o = true;
					}
					break;
				case 13:
					if (this.viewMode != 0) {
						var l = this.viewMode;
						this.showMode(-1);
						this.fill();
						if (l == this.viewMode && this.autoclose) {
							this.hide();
						}
					} else {
						this.fill();
						if (this.autoclose) {
							this.hide();
						}
					}
					m.preventDefault();
					break;
				case 9:
					this.hide();
					break;
			}
			if (o) {
				var k;
				if (this.isInput) {
					k = this.element;
				} else {
					if (this.component) {
						k = this.element.find('input');
					}
				}
				if (k) {
					k.change();
				}
				this.element.trigger({ type: 'changeDate', date: this.date });
			}
		},
		showMode: function(i) {
			if (i) {
				var j = Math.max(0, Math.min(d.modes.length - 1, this.viewMode + i));
				if (j >= this.minView && j <= this.maxView) {
					this.element.trigger({
						type: 'changeMode',
						date: this.viewDate,
						oldViewMode: this.viewMode,
						newViewMode: j
					});
					this.viewMode = j;
				}
			}
			this.picker
				.find('>div')
				.hide()
				.filter('.datetimepicker-' + d.modes[this.viewMode].clsName)
				.css('display', 'block');
			this.updateNavArrows();
		},
		reset: function(i) {
			this._setDate(null, 'date');
		},
		convertViewModeText: function(i) {
			switch (i) {
				case 4:
					return 'decade';
				case 3:
					return 'year';
				case 2:
					return 'month';
				case 1:
					return 'day';
				case 0:
					return 'hour';
			}
		}
	};
	var a = e.fn.datetimepicker;
	e.fn.datetimepicker = function(k) {
		var i = Array.apply(null, arguments);
		i.shift();
		var j;
		this.each(function() {
			var n = e(this),
				m = n.data('datetimepicker'),
				l = typeof k == 'object' && k;
			if (!m) {
				n.data('datetimepicker', (m = new g(this, e.extend({}, e.fn.datetimepicker.defaults, l))));
			}
			if (typeof k == 'string' && typeof m[k] == 'function') {
				j = m[k].apply(m, i);
				if (j !== undefined) {
					return false;
				}
			}
		});
		if (j !== undefined) {
			return j;
		} else {
			return this;
		}
	};
	e.fn.datetimepicker.defaults = {};
	e.fn.datetimepicker.Constructor = g;
	var f = (e.fn.datetimepicker.dates = {
		en: {
			days: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday' ],
			daysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun' ],
			daysMin: [ 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su' ],
			months: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			],
			monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
			meridiem: [ 'am', 'pm' ],
			suffix: [ 'st', 'nd', 'rd', 'th' ],
			today: 'Today'
		}
	});
	var d = {
		modes: [
			{ clsName: 'minutes', navFnc: 'Hours', navStep: 1 },
			{ clsName: 'hours', navFnc: 'Date', navStep: 1 },
			{ clsName: 'days', navFnc: 'Month', navStep: 1 },
			{ clsName: 'months', navFnc: 'FullYear', navStep: 1 },
			{ clsName: 'years', navFnc: 'FullYear', navStep: 10 }
		],
		isLeapYear: function(i) {
			return (i % 4 === 0 && i % 100 !== 0) || i % 400 === 0;
		},
		getDaysInMonth: function(i, j) {
			return [ 31, d.isLeapYear(i) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ][j];
		},
		getDefaultFormat: function(i, j) {
			if (i == 'standard') {
				if (j == 'input') {
					return 'yyyy-mm-dd hh:ii';
				} else {
					return 'yyyy-mm-dd hh:ii:ss';
				}
			} else {
				if (i == 'php') {
					if (j == 'input') {
						return 'Y-m-d H:i';
					} else {
						return 'Y-m-d H:i:s';
					}
				} else {
					throw new Error('Invalid format type.');
				}
			}
		},
		validParts: function(i) {
			if (i == 'standard') {
				return /hh?|HH?|p|P|ii?|ss?|dd?|DD?|mm?|MM?|yy(?:yy)?/g;
			} else {
				if (i == 'php') {
					return /[dDjlNwzFmMnStyYaABgGhHis]/g;
				} else {
					throw new Error('Invalid format type.');
				}
			}
		},
		nonpunctuation: /[^ -\/:-@\[-`{-~\t\n\rTZ]+/g,
		parseFormat: function(l, j) {
			var i = l.replace(this.validParts(j), '\0').split('\0'),
				k = l.match(this.validParts(j));
			if (!i || !i.length || !k || k.length == 0) {
				throw new Error('Invalid date format.');
			}
			return { separators: i, parts: k };
		},
		parseDate: function(n, w, q, u) {
			if (n instanceof Date) {
				var y = new Date(n.valueOf() - n.getTimezoneOffset() * 60000);
				y.setMilliseconds(0);
				return y;
			}
			if (/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(n)) {
				w = this.parseFormat('yyyy-mm-dd', u);
			}
			if (/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}$/.test(n)) {
				w = this.parseFormat('yyyy-mm-dd hh:ii', u);
			}
			if (/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}\:\d{1,2}[Z]{0,1}$/.test(n)) {
				w = this.parseFormat('yyyy-mm-dd hh:ii:ss', u);
			}
			if (/^[-+]\d+[dmwy]([\s,]+[-+]\d+[dmwy])*$/.test(n)) {
				var z = /([-+]\d+)([dmwy])/,
					o = n.match(/([-+]\d+)([dmwy])/g),
					j,
					m;
				n = new Date();
				for (var p = 0; p < o.length; p++) {
					j = z.exec(o[p]);
					m = parseInt(j[1]);
					switch (j[2]) {
						case 'd':
							n.setUTCDate(n.getUTCDate() + m);
							break;
						case 'm':
							n = g.prototype.moveMonth.call(g.prototype, n, m);
							break;
						case 'w':
							n.setUTCDate(n.getUTCDate() + m * 7);
							break;
						case 'y':
							n = g.prototype.moveYear.call(g.prototype, n, m);
							break;
					}
				}
				return h(
					n.getUTCFullYear(),
					n.getUTCMonth(),
					n.getUTCDate(),
					n.getUTCHours(),
					n.getUTCMinutes(),
					n.getUTCSeconds(),
					0
				);
			}
			var o = (n && n.toString().match(this.nonpunctuation)) || [],
				n = new Date(0, 0, 0, 0, 0, 0, 0),
				t = {},
				v = [
					'hh',
					'h',
					'ii',
					'i',
					'ss',
					's',
					'yyyy',
					'yy',
					'M',
					'MM',
					'm',
					'mm',
					'D',
					'DD',
					'd',
					'dd',
					'H',
					'HH',
					'p',
					'P'
				],
				x = {
					hh: function(s, i) {
						return s.setUTCHours(i);
					},
					h: function(s, i) {
						return s.setUTCHours(i);
					},
					HH: function(s, i) {
						return s.setUTCHours(i == 12 ? 0 : i);
					},
					H: function(s, i) {
						return s.setUTCHours(i == 12 ? 0 : i);
					},
					ii: function(s, i) {
						return s.setUTCMinutes(i);
					},
					i: function(s, i) {
						return s.setUTCMinutes(i);
					},
					ss: function(s, i) {
						return s.setUTCSeconds(i);
					},
					s: function(s, i) {
						return s.setUTCSeconds(i);
					},
					yyyy: function(s, i) {
						return s.setUTCFullYear(i);
					},
					yy: function(s, i) {
						return s.setUTCFullYear(2000 + i);
					},
					m: function(s, i) {
						i -= 1;
						while (i < 0) {
							i += 12;
						}
						i %= 12;
						s.setUTCMonth(i);
						while (s.getUTCMonth() != i) {
							if (isNaN(s.getUTCMonth())) {
								return s;
							} else {
								s.setUTCDate(s.getUTCDate() - 1);
							}
						}
						return s;
					},
					d: function(s, i) {
						return s.setUTCDate(i);
					},
					p: function(s, i) {
						return s.setUTCHours(i == 1 ? s.getUTCHours() + 12 : s.getUTCHours());
					}
				},
				l,
				r,
				j;
			x.M = x.MM = x.mm = x.m;
			x.dd = x.d;
			x.P = x.p;
			n = h(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds());
			if (o.length == w.parts.length) {
				for (var p = 0, k = w.parts.length; p < k; p++) {
					l = parseInt(o[p], 10);
					j = w.parts[p];
					if (isNaN(l)) {
						switch (j) {
							case 'MM':
								r = e(f[q].months).filter(function() {
									var i = this.slice(0, o[p].length),
										s = o[p].slice(0, i.length);
									return i == s;
								});
								l = e.inArray(r[0], f[q].months) + 1;
								break;
							case 'M':
								r = e(f[q].monthsShort).filter(function() {
									var i = this.slice(0, o[p].length),
										s = o[p].slice(0, i.length);
									return i.toLowerCase() == s.toLowerCase();
								});
								l = e.inArray(r[0], f[q].monthsShort) + 1;
								break;
							case 'p':
							case 'P':
								l = e.inArray(o[p].toLowerCase(), f[q].meridiem);
								break;
						}
					}
					t[j] = l;
				}
				for (var p = 0, A; p < v.length; p++) {
					A = v[p];
					if (A in t && !isNaN(t[A])) {
						x[A](n, t[A]);
					}
				}
			}
			return n;
		},
		formatDate: function(j, o, q, m) {
			if (j == null) {
				return '';
			}
			var p;
			if (m == 'standard') {
				p = {
					yy: j.getUTCFullYear().toString().substring(2),
					yyyy: j.getUTCFullYear(),
					m: j.getUTCMonth() + 1,
					M: f[q].monthsShort[j.getUTCMonth()],
					MM: f[q].months[j.getUTCMonth()],
					d: j.getUTCDate(),
					D: f[q].daysShort[j.getUTCDay()],
					DD: f[q].days[j.getUTCDay()],
					p: f[q].meridiem.length == 2 ? f[q].meridiem[j.getUTCHours() < 12 ? 0 : 1] : '',
					h: j.getUTCHours(),
					i: j.getUTCMinutes(),
					s: j.getUTCSeconds()
				};
				if (f[q].meridiem.length == 2) {
					p.H = p.h % 12 == 0 ? 12 : p.h % 12;
				} else {
					p.H = p.h;
				}
				p.HH = (p.H < 10 ? '0' : '') + p.H;
				p.P = p.p.toUpperCase();
				p.hh = (p.h < 10 ? '0' : '') + p.h;
				p.ii = (p.i < 10 ? '0' : '') + p.i;
				p.ss = (p.s < 10 ? '0' : '') + p.s;
				p.dd = (p.d < 10 ? '0' : '') + p.d;
				p.mm = (p.m < 10 ? '0' : '') + p.m;
			} else {
				if (m == 'php') {
					p = {
						y: j.getUTCFullYear().toString().substring(2),
						Y: j.getUTCFullYear(),
						F: f[q].months[j.getUTCMonth()],
						M: f[q].monthsShort[j.getUTCMonth()],
						n: j.getUTCMonth() + 1,
						t: d.getDaysInMonth(j.getUTCFullYear(), j.getUTCMonth()),
						j: j.getUTCDate(),
						l: f[q].days[j.getUTCDay()],
						D: f[q].daysShort[j.getUTCDay()],
						w: j.getUTCDay(),
						N: j.getUTCDay() == 0 ? 7 : j.getUTCDay(),
						S: j.getUTCDate() % 10 <= f[q].suffix.length ? f[q].suffix[j.getUTCDate() % 10 - 1] : '',
						a: f[q].meridiem.length == 2 ? f[q].meridiem[j.getUTCHours() < 12 ? 0 : 1] : '',
						g: j.getUTCHours() % 12 == 0 ? 12 : j.getUTCHours() % 12,
						G: j.getUTCHours(),
						i: j.getUTCMinutes(),
						s: j.getUTCSeconds()
					};
					p.m = (p.n < 10 ? '0' : '') + p.n;
					p.d = (p.j < 10 ? '0' : '') + p.j;
					p.A = p.a.toString().toUpperCase();
					p.h = (p.g < 10 ? '0' : '') + p.g;
					p.H = (p.G < 10 ? '0' : '') + p.G;
					p.i = (p.i < 10 ? '0' : '') + p.i;
					p.s = (p.s < 10 ? '0' : '') + p.s;
				} else {
					throw new Error('Invalid format type.');
				}
			}
			var j = [],
				n = e.extend([], o.separators);
			for (var l = 0, k = o.parts.length; l < k; l++) {
				if (n.length) {
					j.push(n.shift());
				}
				j.push(p[o.parts[l]]);
			}
			if (n.length) {
				j.push(n.shift());
			}
			return j.join('');
		},
		convertViewMode: function(i) {
			switch (i) {
				case 4:
				case 'decade':
					i = 4;
					break;
				case 3:
				case 'year':
					i = 3;
					break;
				case 2:
				case 'month':
					i = 2;
					break;
				case 1:
				case 'day':
					i = 1;
					break;
				case 0:
				case 'hour':
					i = 0;
					break;
			}
			return i;
		},
		headTemplate:
			'<thead><tr><th class="prev"><i class="{iconType} {leftArrow}"/></th><th colspan="5" class="switch"></th><th class="next"><i class="{iconType} {rightArrow}"/></th></tr></thead>',
		headTemplateV3:
			'<thead><tr><th class="prev"><span class="{iconType} {leftArrow}"></span> </th><th colspan="5" class="switch"></th><th class="next"><span class="{iconType} {rightArrow}"></span> </th></tr></thead>',
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr></tfoot>'
	};
	d.template =
		'<div class="datetimepicker"><div class="datetimepicker-minutes"><table class=" table-condensed">' +
		d.headTemplate +
		d.contTemplate +
		d.footTemplate +
		'</table></div><div class="datetimepicker-hours"><table class=" table-condensed">' +
		d.headTemplate +
		d.contTemplate +
		d.footTemplate +
		'</table></div><div class="datetimepicker-days"><table class=" table-condensed">' +
		d.headTemplate +
		'<tbody></tbody>' +
		d.footTemplate +
		'</table></div><div class="datetimepicker-months"><table class="table-condensed">' +
		d.headTemplate +
		d.contTemplate +
		d.footTemplate +
		'</table></div><div class="datetimepicker-years"><table class="table-condensed">' +
		d.headTemplate +
		d.contTemplate +
		d.footTemplate +
		'</table></div></div>';
	d.templateV3 =
		'<div class="datetimepicker"><div class="datetimepicker-minutes"><table class=" table-condensed">' +
		d.headTemplateV3 +
		d.contTemplate +
		d.footTemplate +
		'</table></div><div class="datetimepicker-hours"><table class=" table-condensed">' +
		d.headTemplateV3 +
		d.contTemplate +
		d.footTemplate +
		'</table></div><div class="datetimepicker-days"><table class=" table-condensed">' +
		d.headTemplateV3 +
		'<tbody></tbody>' +
		d.footTemplate +
		'</table></div><div class="datetimepicker-months"><table class="table-condensed">' +
		d.headTemplateV3 +
		d.contTemplate +
		d.footTemplate +
		'</table></div><div class="datetimepicker-years"><table class="table-condensed">' +
		d.headTemplateV3 +
		d.contTemplate +
		d.footTemplate +
		'</table></div></div>';
	e.fn.datetimepicker.DPGlobal = d;
	e.fn.datetimepicker.noConflict = function() {
		e.fn.datetimepicker = a;
		return this;
	};
	e(
		document
	).on('focus.datetimepicker.data-api click.datetimepicker.data-api', '[data-provide="datetimepicker"]', function(j) {
		var i = e(this);
		if (i.data('datetimepicker')) {
			return;
		}
		j.preventDefault();
		i.datetimepicker('show');
	});
	e(function() {
		e('[data-provide="datetimepicker-inline"]').datetimepicker();
	});
})(window.jQuery);

/**
 * Brazilian translation for bootstrap-datetimepicker
 * Cauan Cabral <cauan@radig.com.br>
 */
(function($) {
	$.fn.datetimepicker.dates['en'] = {
		days: [ 'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo' ],
		daysShort: [ 'Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom' ],
		daysMin: [ 'Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa', 'Do' ],
		months: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro'
		],
		monthsShort: [ 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez' ],
		today: 'Hoje',
		suffix: [],
		meridiem: [],
		autoclose: true
	};
})(jQuery);

// ClockPicker v0.0.7 (http://weareoutman.github.io/clockpicker/)
!(function() {
	function t(t) {
		return document.createElementNS(p, t);
	}
	function i(t) {
		return (10 > t ? '0' : '') + t;
	}
	function e(t) {
		var i = ++m + '';
		return t ? t + i : i;
	}
	function s(s, r) {
		function p(t, i) {
			var e = u.offset(),
				s = /^touch/.test(t.type),
				o = e.left + b,
				n = e.top + b,
				p = (s ? t.originalEvent.touches[0] : t).pageX - o,
				h = (s ? t.originalEvent.touches[0] : t).pageY - n,
				k = Math.sqrt(p * p + h * h),
				v = !1;
			if (!i || !(g - y > k || k > g + y)) {
				t.preventDefault();
				var m = setTimeout(function() {
					c.addClass('clockpicker-moving');
				}, 200);
				l && u.append(x.canvas),
					x.setHand(p, h, !i, !0),
					a.off(d).on(d, function(t) {
						t.preventDefault();
						var i = /^touch/.test(t.type),
							e = (i ? t.originalEvent.touches[0] : t).pageX - o,
							s = (i ? t.originalEvent.touches[0] : t).pageY - n;
						(v || e !== p || s !== h) && ((v = !0), x.setHand(e, s, !1, !0));
					}),
					a.off(f).on(f, function(t) {
						a.off(f), t.preventDefault();
						var e = /^touch/.test(t.type),
							s = (e ? t.originalEvent.changedTouches[0] : t).pageX - o,
							l = (e ? t.originalEvent.changedTouches[0] : t).pageY - n;
						(i || v) && s === p && l === h && x.setHand(s, l),
							'hours' === x.currentView
								? x.toggleView('minutes', A / 2)
								: r.autoclose &&
									(x.minutesView.addClass('clockpicker-dial-out'),
									setTimeout(function() {
										x.done();
									}, A / 2)),
							u.prepend(j),
							clearTimeout(m),
							c.removeClass('clockpicker-moving'),
							a.off(d);
					});
			}
		}
		var h = n(V),
			u = h.find('.clockpicker-plate'),
			v = h.find('.clockpicker-hours'),
			m = h.find('.clockpicker-minutes'),
			T = h.find('.clockpicker-am-pm-block'),
			C = 'INPUT' === s.prop('tagName'),
			H = C ? s : s.find('input'),
			P = s.find('.input-group-addon'),
			x = this;
		if (
			((this.id = e('cp')),
			(this.element = s),
			(this.options = r),
			(this.isAppended = !1),
			(this.isShown = !1),
			(this.currentView = 'hours'),
			(this.isInput = C),
			(this.input = H),
			(this.addon = P),
			(this.popover = h),
			(this.plate = u),
			(this.hoursView = v),
			(this.minutesView = m),
			(this.amPmBlock = T),
			(this.spanHours = h.find('.clockpicker-span-hours')),
			(this.spanMinutes = h.find('.clockpicker-span-minutes')),
			(this.spanAmPm = h.find('.clockpicker-span-am-pm')),
			(this.amOrPm = 'PM'),
			r.twelvehour)
		) {
			{
				var S = [
					'<div class="clockpicker-am-pm-block">',
					'<button type="button" class="btn btn-sm btn-default clockpicker-button clockpicker-am-button">',
					'AM</button>',
					'<button type="button" class="btn btn-sm btn-default clockpicker-button clockpicker-pm-button">',
					'PM</button>',
					'</div>'
				].join('');
				n(S);
			}
			n('<button type="button" class="btn btn-sm btn-default clockpicker-button am-button">AM</button>')
				.on('click', function() {
					(x.amOrPm = 'AM'), n('.clockpicker-span-am-pm').empty().append('AM');
				})
				.appendTo(this.amPmBlock),
				n('<button type="button" class="btn btn-sm btn-default clockpicker-button pm-button">PM</button>')
					.on('click', function() {
						(x.amOrPm = 'PM'), n('.clockpicker-span-am-pm').empty().append('PM');
					})
					.appendTo(this.amPmBlock);
		}
		r.autoclose ||
			n(
				'<button type="button" class="btn btn-sm btn-default btn-block clockpicker-button">' +
					r.donetext +
					'</button>'
			)
				.click(n.proxy(this.done, this))
				.appendTo(h),
			('top' !== r.placement && 'bottom' !== r.placement) ||
				('top' !== r.align && 'bottom' !== r.align) ||
				(r.align = 'left'),
			('left' !== r.placement && 'right' !== r.placement) ||
				('left' !== r.align && 'right' !== r.align) ||
				(r.align = 'top'),
			h.addClass(r.placement),
			h.addClass('clockpicker-align-' + r.align),
			this.spanHours.click(n.proxy(this.toggleView, this, 'hours')),
			this.spanMinutes.click(n.proxy(this.toggleView, this, 'minutes')),
			H.on('focus.clockpicker click.clockpicker', n.proxy(this.show, this)),
			P.on('click.clockpicker', n.proxy(this.toggle, this));
		var E,
			D,
			I,
			B,
			z = n('<div class="clockpicker-tick"></div>');
		if (r.twelvehour)
			for (E = 1; 13 > E; E += 1)
				(D = z.clone()),
					(I = E / 6 * Math.PI),
					(B = g),
					D.css('font-size', '120%'),
					D.css({ left: b + Math.sin(I) * B - y, top: b - Math.cos(I) * B - y }),
					D.html(0 === E ? '00' : E),
					v.append(D),
					D.on(k, p);
		else
			for (E = 0; 24 > E; E += 1) {
				(D = z.clone()), (I = E / 6 * Math.PI);
				var O = E > 0 && 13 > E;
				(B = O ? w : g),
					D.css({ left: b + Math.sin(I) * B - y, top: b - Math.cos(I) * B - y }),
					O && D.css('font-size', '120%'),
					D.html(0 === E ? '00' : E),
					v.append(D),
					D.on(k, p);
			}
		for (E = 0; 60 > E; E += 5)
			(D = z.clone()),
				(I = E / 30 * Math.PI),
				D.css({ left: b + Math.sin(I) * g - y, top: b - Math.cos(I) * g - y }),
				D.css('font-size', '120%'),
				D.html(i(E)),
				m.append(D),
				D.on(k, p);
		if (
			(u.on(k, function(t) {
				0 === n(t.target).closest('.clockpicker-tick').length && p(t, !0);
			}),
			l)
		) {
			var j = h.find('.clockpicker-canvas'),
				L = t('svg');
			L.setAttribute('class', 'clockpicker-svg'), L.setAttribute('width', M), L.setAttribute('height', M);
			var U = t('g');
			U.setAttribute('transform', 'translate(' + b + ',' + b + ')');
			var W = t('circle');
			W.setAttribute('class', 'clockpicker-canvas-bearing'),
				W.setAttribute('cx', 0),
				W.setAttribute('cy', 0),
				W.setAttribute('r', 2);
			var N = t('line');
			N.setAttribute('x1', 0), N.setAttribute('y1', 0);
			var X = t('circle');
			X.setAttribute('class', 'clockpicker-canvas-bg'), X.setAttribute('r', y);
			var Y = t('circle');
			Y.setAttribute('class', 'clockpicker-canvas-fg'),
				Y.setAttribute('r', 3.5),
				U.appendChild(N),
				U.appendChild(X),
				U.appendChild(Y),
				U.appendChild(W),
				L.appendChild(U),
				j.append(L),
				(this.hand = N),
				(this.bg = X),
				(this.fg = Y),
				(this.bearing = W),
				(this.g = U),
				(this.canvas = j);
		}
		o(this.options.init);
	}
	function o(t) {
		t && 'function' == typeof t && t();
	}
	var c,
		n = window.jQuery,
		r = n(window),
		a = n(document),
		p = 'http://www.w3.org/2000/svg',
		l =
			'SVGAngle' in window &&
			(function() {
				var t,
					i = document.createElement('div');
				return (
					(i.innerHTML = '<svg/>'),
					(t = (i.firstChild && i.firstChild.namespaceURI) == p),
					(i.innerHTML = ''),
					t
				);
			})(),
		h = (function() {
			var t = document.createElement('div').style;
			return (
				'transition' in t ||
				'WebkitTransition' in t ||
				'MozTransition' in t ||
				'msTransition' in t ||
				'OTransition' in t
			);
		})(),
		u = 'ontouchstart' in window,
		k = 'mousedown' + (u ? ' touchstart' : ''),
		d = 'mousemove.clockpicker' + (u ? ' touchmove.clockpicker' : ''),
		f = 'mouseup.clockpicker' + (u ? ' touchend.clockpicker' : ''),
		v = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null,
		m = 0,
		b = 100,
		g = 80,
		w = 54,
		y = 13,
		M = 2 * b,
		A = h ? 350 : 1,
		V = [
			'<div class="popover clockpicker-popover">',
			'<div class="arrow"></div>',
			'<div class="popover-title">',
			'<span class="clockpicker-span-hours text-primary"></span>',
			' : ',
			'<span class="clockpicker-span-minutes"></span>',
			'<span class="clockpicker-span-am-pm"></span>',
			'</div>',
			'<div class="popover-content">',
			'<div class="clockpicker-plate">',
			'<div class="clockpicker-canvas"></div>',
			'<div class="clockpicker-dial clockpicker-hours"></div>',
			'<div class="clockpicker-dial clockpicker-minutes clockpicker-dial-out"></div>',
			'</div>',
			'<span class="clockpicker-am-pm-block">',
			'</span>',
			'</div>',
			'</div>'
		].join('');
	(s.DEFAULTS = {
		default: '',
		fromnow: 0,
		placement: 'bottom',
		align: 'left',
		donetext: '完成',
		autoclose: !1,
		twelvehour: !1,
		vibrate: !0
	}),
		(s.prototype.toggle = function() {
			this[this.isShown ? 'hide' : 'show']();
		}),
		(s.prototype.locate = function() {
			var t = this.element,
				i = this.popover,
				e = t.offset(),
				s = t.outerWidth(),
				o = t.outerHeight(),
				c = this.options.placement,
				n = this.options.align,
				r = {};
			switch ((i.show(), c)) {
				case 'bottom':
					r.top = e.top + o;
					break;
				case 'right':
					r.left = e.left + s;
					break;
				case 'top':
					r.top = e.top - i.outerHeight();
					break;
				case 'left':
					r.left = e.left - i.outerWidth();
			}
			switch (n) {
				case 'left':
					r.left = e.left;
					break;
				case 'right':
					r.left = e.left + s - i.outerWidth();
					break;
				case 'top':
					r.top = e.top;
					break;
				case 'bottom':
					r.top = e.top + o - i.outerHeight();
			}
			i.css(r);
		}),
		(s.prototype.show = function() {
			if (!this.isShown) {
				o(this.options.beforeShow);
				var t = this;
				this.isAppended ||
					((c = n(document.body).append(this.popover)),
					r.on('resize.clockpicker' + this.id, function() {
						t.isShown && t.locate();
					}),
					(this.isAppended = !0));
				var e = ((this.input.prop('value') || this.options['default'] || '') + '').split(':');
				if ('now' === e[0]) {
					var s = new Date(+new Date() + this.options.fromnow);
					e = [ s.getHours(), s.getMinutes() ];
				}
				(this.hours = +e[0] || 0),
					(this.minutes = +e[1] || 0),
					this.spanHours.html(i(this.hours)),
					this.spanMinutes.html(i(this.minutes)),
					this.toggleView('hours'),
					this.locate(),
					(this.isShown = !0),
					a.on('click.clockpicker.' + this.id + ' focusin.clockpicker.' + this.id, function(i) {
						var e = n(i.target);
						0 === e.closest(t.popover).length &&
							0 === e.closest(t.addon).length &&
							0 === e.closest(t.input).length &&
							t.hide();
					}),
					a.on('keyup.clockpicker.' + this.id, function(i) {
						27 === i.keyCode && t.hide();
					}),
					o(this.options.afterShow);
			}
		}),
		(s.prototype.hide = function() {
			o(this.options.beforeHide),
				(this.isShown = !1),
				a.off('click.clockpicker.' + this.id + ' focusin.clockpicker.' + this.id),
				a.off('keyup.clockpicker.' + this.id),
				this.popover.hide(),
				o(this.options.afterHide);
		}),
		(s.prototype.toggleView = function(t, i) {
			var e = !1;
			'minutes' === t &&
				'visible' === n(this.hoursView).css('visibility') &&
				(o(this.options.beforeHourSelect), (e = !0));
			var s = 'hours' === t,
				c = s ? this.hoursView : this.minutesView,
				r = s ? this.minutesView : this.hoursView;
			(this.currentView = t),
				this.spanHours.toggleClass('text-primary', s),
				this.spanMinutes.toggleClass('text-primary', !s),
				r.addClass('clockpicker-dial-out'),
				c.css('visibility', 'visible').removeClass('clockpicker-dial-out'),
				this.resetClock(i),
				clearTimeout(this.toggleViewTimer),
				(this.toggleViewTimer = setTimeout(function() {
					r.css('visibility', 'hidden');
				}, A)),
				e && o(this.options.afterHourSelect);
		}),
		(s.prototype.resetClock = function(t) {
			var i = this.currentView,
				e = this[i],
				s = 'hours' === i,
				o = Math.PI / (s ? 6 : 30),
				c = e * o,
				n = s && e > 0 && 13 > e ? w : g,
				r = Math.sin(c) * n,
				a = -Math.cos(c) * n,
				p = this;
			l && t
				? (p.canvas.addClass('clockpicker-canvas-out'),
					setTimeout(function() {
						p.canvas.removeClass('clockpicker-canvas-out'), p.setHand(r, a);
					}, t))
				: this.setHand(r, a);
		}),
		(s.prototype.setHand = function(t, e, s, o) {
			var c,
				r = Math.atan2(t, -e),
				a = 'hours' === this.currentView,
				p = Math.PI / (a || s ? 6 : 30),
				h = Math.sqrt(t * t + e * e),
				u = this.options,
				k = a && (g + w) / 2 > h,
				d = k ? w : g;
			if (
				(u.twelvehour && (d = g),
				0 > r && (r = 2 * Math.PI + r),
				(c = Math.round(r / p)),
				(r = c * p),
				u.twelvehour
					? a ? 0 === c && (c = 12) : (s && (c *= 5), 60 === c && (c = 0))
					: a
						? (12 === c && (c = 0), (c = k ? (0 === c ? 12 : c) : 0 === c ? 0 : c + 12))
						: (s && (c *= 5), 60 === c && (c = 0)),
				this[this.currentView] !== c &&
					v &&
					this.options.vibrate &&
					(this.vibrateTimer ||
						(navigator[v](10),
						(this.vibrateTimer = setTimeout(
							n.proxy(function() {
								this.vibrateTimer = null;
							}, this),
							100
						)))),
				(this[this.currentView] = c),
				this[a ? 'spanHours' : 'spanMinutes'].html(i(c)),
				!l)
			)
				return void this[a ? 'hoursView' : 'minutesView'].find('.clockpicker-tick').each(function() {
					var t = n(this);
					t.toggleClass('active', c === +t.html());
				});
			o || (!a && c % 5)
				? (this.g.insertBefore(this.hand, this.bearing),
					this.g.insertBefore(this.bg, this.fg),
					this.bg.setAttribute('class', 'clockpicker-canvas-bg clockpicker-canvas-bg-trans'))
				: (this.g.insertBefore(this.hand, this.bg),
					this.g.insertBefore(this.fg, this.bg),
					this.bg.setAttribute('class', 'clockpicker-canvas-bg'));
			var f = Math.sin(r) * d,
				m = -Math.cos(r) * d;
			this.hand.setAttribute('x2', f),
				this.hand.setAttribute('y2', m),
				this.bg.setAttribute('cx', f),
				this.bg.setAttribute('cy', m),
				this.fg.setAttribute('cx', f),
				this.fg.setAttribute('cy', m);
		}),
		(s.prototype.done = function() {
			o(this.options.beforeDone), this.hide();
			var t = this.input.prop('value'),
				e = i(this.hours) + ':' + i(this.minutes);
			this.options.twelvehour && (e += this.amOrPm),
				this.input.prop('value', e),
				e !== t && (this.input.triggerHandler('change'), this.isInput || this.element.trigger('change')),
				this.options.autoclose && this.input.trigger('blur'),
				o(this.options.afterDone);
		}),
		(s.prototype.remove = function() {
			this.element.removeData('clockpicker'),
				this.input.off('focus.clockpicker click.clockpicker'),
				this.addon.off('click.clockpicker'),
				this.isShown && this.hide(),
				this.isAppended && (r.off('resize.clockpicker' + this.id), this.popover.remove());
		}),
		(n.fn.clockpicker = function(t) {
			var i = Array.prototype.slice.call(arguments, 1);
			return this.each(function() {
				var e = n(this),
					o = e.data('clockpicker');
				if (o) 'function' == typeof o[t] && o[t].apply(o, i);
				else {
					var c = n.extend({}, s.DEFAULTS, e.data(), 'object' == typeof t && t);
					e.data('clockpicker', new s(e, c));
				}
			});
		});
})();

//button loading
(function($) {
	$.fn.buttonLoader = function(action) {
		var self = $(this);
		if (action == 'start') {
			if ($(self).attr('disabled') == 'disabled') {
				return false;
			}
			$(self).prop('disabled', true);
			$(self).attr('data-btn-text', $(self).html());

			let text = 'Aguarde';
			if ($(self).attr('data-load-text') != undefined && $(self).attr('data-load-text') != '') {
				text = $(self).attr('data-load-text');
			}

			$(self)
				.html(
					'<span class="spinner"><i class="mdi mdi-reload mdi-spin" title="button-loader"></i></span> ' + text
				)
				.button('refresh');
			$(self).addClass('active');
		} else if (action == 'stop') {
			$(self).html($(self).attr('data-btn-text'));
			$(self).removeClass('active');
			$(self).prop('disabled', false);
		}
	};
})(jQuery);

// Bootstrap 4 multi dropdown navbar
$(document).ready(function() {
	$('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
		let $el = $(this);
		let $parent = $(this).offsetParent('.dropdown-menu');
		if (!$(this).next().hasClass('show')) {
			$(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
		}
		let $subMenu = $(this).next('.dropdown-menu');
		$subMenu.toggleClass('show');

		$(this).parent('li').toggleClass('show');

		$(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
			$('.dropdown-menu .show').removeClass('show');
		});

		if (!$parent.parent().hasClass('navbar-nav')) {
			$el.next().css({ top: $el[0].offsetTop, left: $parent.outerWidth() - 2 });
		}

		return false;
	});
});
